import React, { Component} from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import Marker from './Marker';
import { useGsiTerrainSource } from 'maplibre-gl-gsi-terrain';
import AddMarkerPopup from './AddMarkerPopup';
import EditMarkerPopup from './EditMarkerPopup';
import { CommonUtils } from './CommonUtils';
import { FIRESTORE_CACHE_MODE, FIRESTORE_FORCE_LONG_POLLING } from './FirebaseManager';
import { generateGridGeoJSON } from './mgrsUtmGrid';
import PalettePopup from './PalettePopup';
import MapSharePopup from './MapSharePopup';
import DiagLogPopup from './DiagLogPopup';
import { DiagLog } from './DiagLog';
import { ITEMS_INDEX_VERSION, ITEMS_INDEX_DEBOUNCE_MS, ITEMS_INDEX_MAX_WAIT_MS, ITEMS_INDEX_FETCH_TIMEOUT_MS, ITEMS_INDEX_LISTENER_MARGIN_MS, PROJECT_DOC_WAIT_MS, itemsIndexStoragePath, buildItemsIndexJson, parseItemsIndexJson, liveItemCount, maxUpdatetimeMillis, updatetimeMillis } from './ItemsIndex';
import './css/App.css';
import FileHandler from './FileHandler';
import CustomScaleControl from './CustomScaleControl';
import { Translator, resources } from './Translator';
import ConfirmDialog from './ConfirmDialog';
import MapWithMagneticNorthLine from './MapWithMagneticNorthLine';
import { field } from 'geomag'; // geomagからfieldをインポート
import DistanceLayer from './DistanceLayer';
import SearchPopup from './SearchPopup';
import LayerListPanel from './LayerListPanel';
import * as turf from '@turf/turf';
import DataListPanel from './DataListPanel';
import EditProjectPopup from './EditProjectPopup';
import ChatPanel from './ChatPanel';
import PhotoViewer from './PhotoViewer';
import html2canvas from 'html2canvas';
import { MapLibrePrinter } from './MapLibrePrinter';
import ProgressBar from './ProgressBar';
import elevationService from './ElevationService';
import { toast } from 'react-toastify';
import LayerSettingPopup from './LayerSettingPopup';
import CustomSource from './CustomSource';
import LoadingPopup from './LoadingPopup';
import FirebaseManager from './FirebaseManager';
import ShapeOperationPanel from './ShapeOperationPanel';
import GridDivisionPopup from './GridDivisionPopup';
import PrintMapPopup from './PrintMapPopup';
import LabelPopup from './LabelPopup';
import ShortcutsPopup from './ShortcutsPopup';
import domtoimage from 'dom-to-image';
import SeamlessLegendPanel from './SeamlessLegendPanel';

const translator = new Translator(resources);
const normalBackGround = '#ffffff';
const activeBackGround = '#8fbc18';

// カスタムプロトコル登録時にハンドラ参照も保存しておき、multiply 合成内で
// http(s) 以外のオーバーレイ URL を該当ハンドラ経由で取得できるようにする。
// (maplibre-gl の namespace は frozen で addProtocol 自体は差し替えできないので、
//  登録は registerCustomProtocol() 経由で行うことに統一する)
const customProtocolHandlers = {};
function registerCustomProtocol(scheme, handler) {
	customProtocolHandlers[scheme] = handler;
	maplibregl.addProtocol(scheme, handler);
}

const _drawingTag = 'drawing';
const _shapeTag = 'shape';

const _drawUpdateTimer = 1500;
// 円ツールでドラッグせずタップ/クリックした際に生じる半径0円を弾く最小半径(m)
const MIN_CIRCLE_RADIUS_M = 1;
const MAX_HISTORY = 30; // 履歴の最大件数
const MAX_MARKER_COUNT = 150;	//マーカー＋写真の登録上限
const MAX_FILE_COUNT = 50;	//アップロードファイル(トラック等)の登録上限

// アイテム初回読み込みのリトライ間隔(ms)。getDocs は onSnapshot と違って
// SDK 側で再試行してくれないため、接続確立前の unavailable を自前で拾い直す。
const ITEM_LOAD_RETRY_DELAYS = [1000, 3000, 7000, 15000, 30000];
// onSnapshot がエラーで停止したときの再購読間隔(ms)
const LISTENER_RETRY_DELAYS = [2000, 4000, 8000, 16000, 30000];
// getDocs は接続が「オフライン確定」にも「確立」にもならない中間状態だと
// reject も resolve もせず永久に待つ。SDK側にタイムアウトが無いので自前で打ち切る。
// 正常時の getDocs は数百ms で返る。ハングは待っても回復しないので短めに打ち切り、
// キャッシュ表示に切り替えて裏でサーバ読みを続けた方が体感が良い。
const ITEM_LOAD_TIMEOUT_MS = 3500;
// 図形・描画の実体は Storage 上の GeoJSON を fetch して取る。fetch にも既定の
// タイムアウトが無いため、ハングすると Promise.all が永久に終わらずリトライごと止まる。
const ITEM_FETCH_TIMEOUT_MS = 6000;
const ITEM_PROCESS_TIMEOUT_MS = 10000;

// AbortController 付き fetch。ハングした接続を実際に切る。
async function fetchWithTimeout(url, ms = ITEM_FETCH_TIMEOUT_MS, init = {}) {
	const controller = new AbortController();
	const timer = setTimeout(() => controller.abort(), ms);
	try {
		return await fetch(url, { ...init, signal: controller.signal });
	} catch (e) {
		if (e && e.name === 'AbortError') {
			throw Object.assign(new Error(`fetch timed out after ${ms}ms`), { code: 'timeout' });
		}
		throw e;
	} finally {
		clearTimeout(timer);
	}
}

// promise が期限内に決着しなければ code='timeout' で reject する
function withTimeout(promise, ms, label) {
	let timer = null;
	const timeout = new Promise((resolve, reject) => {
		timer = setTimeout(() => {
			reject(Object.assign(new Error(`${label} timed out after ${ms}ms`), { code: 'timeout' }));
		}, ms);
	});
	return Promise.race([promise, timeout]).finally(() => {
		if (timer) clearTimeout(timer);
	});
}

class MapManager extends Component {


	gsiTerrainSourceKokudo = useGsiTerrainSource(maplibregl.addProtocol);
	terrainUrlS3 = "https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png";

    tileUrlDocomo = `https://asia-northeast1-collabomap-1bcb9.cloudfunctions.net/proxyTile?baseUrl=${encodeURIComponent('https://servicearea.nttdocomo.co.jp/map/1014/0000000000000000/{z}/{x}/{z}_{x}_{y}.gif')}&z={z}&x={x}&y={y}`
    tileUrlRakuten = `https://asia-northeast1-collabomap-1bcb9.cloudfunctions.net/proxyTile?baseUrl=${encodeURIComponent('https://area-map.mobile.rakuten.co.jp/dsd/geoserver/4g/mno_coverage_map/gwc/service/gmaps?LAYERS=mno_coverage_map:all_map&FORMAT=image/png&TRANSPARENT=TRUE&x={x}&y={y}&zoom={z}')}&z={z}&x={x}&y={y}`

	gsiTerrainSourceS3 = {
		type: "raster-dem",
		tiles:[this.terrainUrlS3],
		encoding: 'terrarium',
		tileSize: 256,
		maxzoom: 15,
		minzoom: 1,
		attribution: 'ArcticDEM terrain data DEM(s) were created from DigitalGlobe, Inc., imagery and funded under National Science Foundation awards 1043681, 1559691, and 1542736; / Australia terrain data © Commonwealth of Australia (Geoscience Australia) 2017; / Austria terrain data © offene Daten Österreichs – Digitales Geländemodell (DGM) Österreich; / Canada terrain data contains information licensed under the Open Government Licence – Canada; / Europe terrain data produced using Copernicus data and information funded by the European Union - EU-DEM layers; / Global ETOPO1 terrain data U.S. National Oceanic and Atmospheric Administration / Mexico terrain data source: INEGI, Continental relief, 2016; / New Zealand terrain data Copyright 2011 Crown copyright (c) Land Information New Zealand and the New Zealand Government (All rights reserved); / Norway terrain data © Kartverket; / United Kingdom terrain data © Environment Agency copyright and/or database right 2015. All rights reserved; / United States 3DEP (formerly NED) and global GMTED2010 and SRTM terrain data courtesy of the U.S. Geological Survey.'
	};
	skyLayer =  {
		"sky-color": "#199EF3",
		"sky-horizon-blend": 0.5,
		"horizon-color": "#ffffff",
		"horizon-fog-blend": 0.5,
		"fog-color": "#0000ff",
		"fog-ground-blend": 0.5,
		"atmosphere-blend": ["interpolate",["linear"],["zoom"],0,1,10,1,12,0]
	}


	constructor(props) {
		super(props);
		
		const savedColor = localStorage.getItem('selectedColor') || '#FF0000';
		const savedOpacity = localStorage.getItem('selectedOpacity') || 80;
		const savedLineWidth = localStorage.getItem('lineWidth') || 4;
		const savedGridSettingsRaw = localStorage.getItem('gridSettings');
		const savedGridSettings = savedGridSettingsRaw ? JSON.parse(savedGridSettingsRaw) : null;
		const savedLabelSettingsRaw = localStorage.getItem('labelSettings');
		const savedLabelSettings = savedLabelSettingsRaw ? JSON.parse(savedLabelSettingsRaw) : null;

		this.state = {
			lng: 139.767125,
			lat: 35.681236,
			zoom: 10,
			map: null,
			showAddMarkerPopup:false,
			showEditMarkerPopup:false,
			showMarkerSelectPopup:false,
			showMapSharePopup:false,
			showDiagLogPopup:false,
			itemsLoadSource: null,//'firestore' | 'index'（データ一覧に読み込み元を表示する）
			itemsIndexTime: null,
			showSearchPopup:false,
			showLayerListPanel: false,
			showDataListPanel: false,
			showEditProjectPopup: false,

			searchKeyword: '',
			searchResults: [],

			is3DEnabled: false,
			showPalettePopup: false,
			isDrawingMode:0,
			isjapan : true,
			isDrawing : false,
			erasedLinesDocIds: new Set(), 
			projectTitle:"",
			ownerName:"",

			penButtonBG: normalBackGround,
			shapeButtonBG: normalBackGround,
			eraserButtonBG: normalBackGround,

			selectedColor: savedColor,
			selectedOpacity: parseInt(savedOpacity, 10),
			lineWidth: parseInt(savedLineWidth, 10),

			showConfirmDialog:false,
			showConfshowOkConfirmDialogirmDialog:false,

			confirmDialog:({
				message: '',
				data:null,
				onConfirm: () => {},
				onCancel: () => {},
			}),
			okConfirmDialog:({
				message: '',
				data:null,
				onConfirm: () => {},
			}),
			permission:0,
			showDistanceLayer: false,
			labelScaleDistance: '',
			currentLocation:null,

			shapeDrawingMode: null,
			lineButtonBG: activeBackGround,
			circleButtonBG: normalBackGround,
			polygonButtonBG: normalBackGround,
			measurementButtonBG: normalBackGround,
			gridButtonBG: normalBackGround,
			labelButtonBG: normalBackGround,
			labelMode: false,
			pendingLabelLngLat: null,
			showLabelAddPopup: false,
			showLabelEditPopup: false,
			editingLabelFeature: null,
			labelSettings: savedLabelSettings || { fontSize: 20 },
			currentShape: null,
			shapePoints: [],
			circleRadius: 0,
			showGridDivisionPopup: false,
			pendingGridBounds: null,
			gridSettings: savedGridSettings || { method: 'equal', equalDivisions: 4, distanceInterval: 100, fontSize: 28, labelMode: 'exterior_aux' },
			showChatPanel: false,
			selectedPhoto: null,

			photoMarkers: [],
			currentPhotoIndex: 0,
			isPhotoViewerFullscreen: false,
			isfavorite: false,
			isShowUI:true,
			showThumbnailPopup: false,
			showPrintMap: false,
			uploadProgress: null,
			centerElevation: null,
			showLayerSettingPopup: false,
			showShortcutsPopup: false,
			files:[],
			showLoadingPopup: false,
			loadingMessage: "",
			exaggeration: 1,

			showShapeOperationPanel: false,
			operationPanelPosition: null
		};
		this.latestClickTime = null;//最新クリック時間

		this.lastTap = 0;
		this.tapTimeout = null;
		this.instanceID = CommonUtils.generateUUID();

		this.terrainControl = null;

		this.currentOverlay = null;
		this.currentMap = null;

		this.thumbnailUrl = null;
		this.imageUrl = null;

		this.updateProjectInfo = props.updateProjectInfo;

		this.undoHistory = []; // 描画・マーカー操作の統合アンドゥスタック
		this.redoHistory = []; // 描画操作のリドゥスタック（マーカー操作はリドゥ非対応）
		this.suppressRedoClear = false; // undo/redo 実行中に新規アクション扱いで redo を消さないためのフラグ

		this.currentProject = null;
		this.myDrawing = null;
		this.myShape = null;

		if(this.props.fm.auth.currentUser) {
			this.myDrawing = _drawingTag + '_' + this.props.fm.auth.currentUser.uid;
			this.myShape = _shapeTag  + '_' + this.props.fm.auth.currentUser.uid;
		}

		this.markers = [];
		this.currentMarker = null;

		this.currentLine =  [];//this.stateに入れていると描画時にレンダリングが呼ばれて重くなるので外に出した
		this.isSpaceKeyPressed = false;
		this.isAltKeyPressed = false;
		this.isInitializeMap = false;
		this.editingMarker = null;
		this.shapeDrawing = false;
		this.isLoadedDrawingData = false;

		// アイテム(マーカー/図形/描画/ファイル)読み込みのリトライ状態
		this.map = null;//state.map の反映を待たずに使える同期用の参照
		this.itemCollectionPath = null;
		this.itemListenerStartTime = null;
		this.itemLoadRetryTimer = null;
		this.itemLoadRenderedFromCache = false;
		this.docListenerRetryTimer = null;
		this.docListenerRetryCount = 0;
		this.colListenerRetryTimer = null;
		this.colListenerRetryCount = 0;

		// アイテム索引(items_index.json)関連
		this.itemDocs = null;//オーナーのみ: docId -> 生データ の鏡像（索引の元）
		this.itemsIndexState = { timer: null, maxTimer: null, dirty: false, inFlight: false };
		this.itemsIndexMode = false;//閲覧者: 索引から読み込んだ
		this.pendingIndexItems = null;//閲覧者: 索引から処理に失敗して再試行待ちの item
		this.resolveProjectDoc = null;
		this.projectDocPromise = new Promise((resolve) => { this.resolveProjectDoc = resolve; });
		// 閲覧履歴コピー（非オーナー）の read を初回だけにするための記憶
		this.historyCopyState = { known: false, exists: false, lastPayload: '' };

		this.mapContainerRef = React.createRef();
		this.fileHandler = null;
		this.customScale = null;
		this.defaultIconNumber = 0;
		this.drawUpdatetimerId = null;
		this.shapeUpdatetimerId = null;

		this.lastUpdate = null;

		this.customOverlays = {
			'custom_1':{ type:'', name: 'custom_1', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:40,cc:0 ,proxy:false},
			'custom_2':{ type:'', name: 'custom_2', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:40,cc:0 ,proxy:false},
			'custom_3':{ type:'', name: 'custom_3', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:40,cc:0 ,proxy:false},
			'custom_4':{ type:'', name: 'custom_4', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:40,cc:0 ,proxy:false},
			'custom_5':{ type:'', name: 'custom_5', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:40,cc:0 ,proxy:false},
		};

		this.customMaps = {
			'custom_1':{ type:'', name: 'custom_1', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:100,cc:0 ,proxy:false},
			'custom_2':{ type:'', name: 'custom_2', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:100,cc:0 ,proxy:false},
			'custom_3':{ type:'', name: 'custom_3', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:100,cc:0 ,proxy:false},
			'custom_4':{ type:'', name: 'custom_4', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:100,cc:0 ,proxy:false},
			'custom_5':{ type:'', name: 'custom_5', cp: '', url: '',ts:256, minz:1 ,mz:18,bp:0,op:100,cc:0 ,proxy:false},
		};
	}
	startLoading = (loadingMessage) => {
		this.setState({ showLoadingPopup: true,loadingMessage:loadingMessage });
	}

	// 処理終了時に呼び出す
	endLoading = () => {
		this.setState({ showLoadingPopup: false });
	}
	
	updateCenterElevation = async () => {
		//console.log("updateCenterElevation");
		if(!this.state.map) return;

		const center = this.state.map.getCenter();
		try {
			const elevation = await elevationService.getElevation(center.lat, center.lng);
			this.setState({ centerElevation: elevation });
		} catch (error) {
			console.error('Error fetching elevation:', error);
			this.setState({ centerElevation: null });
		}
	};

	toggleDistanceLayer = () => {
		this.setState(prevState => ({
			showDistanceLayer: !prevState.showDistanceLayer
		}));
	};

	handleFileUpload = async (event) => {
		if(event.target.files && this.fileHandler) {
			this.setState({ uploadProgress: { current: 0, total: event.target.files.length } });

			//写真はマーカー枠、それ以外のファイルはファイル枠として別々に残り件数を渡す
			const rest = {
				marker: Math.max(0, MAX_MARKER_COUNT - this.getMarkerDataCount()),
				file: Math.max(0, MAX_FILE_COUNT - this.getFileDataCount()),
			};
			this.fileHandler.handleFileUpload(event,this.props.myName,this.props.myColor,rest,
				(current, total) => this.setUploadProgress({ current, total }),
				(kind)=>{//kind: 'marker' | 'file' | 'both'
					const t = (key) => translator.t(key);
					if(kind === 'marker') toast.info(t('max_data_message_B'));
					else if(kind === 'file') toast.info(t('max_file_message_B'));
					else toast.info(t('max_data_message_all'));
				});
		}
	};

	setUploadProgress = ({ current, total }) => {
		this.setState({ uploadProgress: { current, total } });
		if(current === total) setTimeout(() => this.setState({ uploadProgress: null }), 1000);
	}

	//操作履歴関連-------------------------
	addToHistory = () => {
//			console.log('addToHistory');
		if(!this.props.fm.auth || !this.props.fm.auth.currentUser) return;

		const map = this.getMap();
		if(!map) return;
		const source_d = map.getSource(this.myDrawing);
		const source_s = map.getSource(this.myShape);
		let data_d = null;
		let data_s = null;

		if(source_d) data_d = source_d._data;
		if(source_s) data_s = source_s._data;

		if(!data_d && !data_s) return;

		const action = {
			kind: 'drawing',
			sourceId_d: this.myDrawing,
			data_d:JSON.parse(JSON.stringify(data_d)),
			sourceId_s: this.myShape,
			data_s:JSON.parse(JSON.stringify(data_s)),
		};

		this.recordUndo(action);
	};

	// undoHistory への追加と redoHistory のクリアをまとめて行うヘルパ
	recordUndo = (entry) => {
		this.undoHistory.push(entry);
		if (this.undoHistory.length > MAX_HISTORY * 2) {
			this.undoHistory.splice(0, this.undoHistory.length - MAX_HISTORY * 2);
		}
		if (!this.suppressRedoClear) this.redoHistory = [];
	};

	undo = () => {
		const { map } = this.state;
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);
		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);

//		console.log('undo: drawUpdatetimerId:' + this.drawUpdatetimerId + ' shapeUpdatetimerId:' + this.shapeUpdatetimerId.length);

		if (this.undoHistory.length === 0) {
			this.addToHistory();
			return;
		}

		const last = this.undoHistory[this.undoHistory.length - 1];

		if (last.kind === 'marker') {
			this.undoHistory.pop();
			// applyMarkerUndo 内の handleAddMarker 等で recordUndo が呼ばれても
			// redoHistory が消えないようにフラグを立てる。
			this.suppressRedoClear = true;
			let redoEntry = null;
			try {
				redoEntry = this.captureMarkerRedo(last);
				const newDocId = this.applyMarkerUndo(last);
				if (redoEntry && redoEntry.op === 'delete' && newDocId) {
					redoEntry.docId = newDocId;
				}
				if (redoEntry) {
					this.redoHistory.push(redoEntry);
					if (this.redoHistory.length > MAX_HISTORY * 2) {
						this.redoHistory.splice(0, this.redoHistory.length - MAX_HISTORY * 2);
					}
				}
			} finally {
				this.suppressRedoClear = false;
			}
			return;
		}

		// kind === 'drawing': エントリがあれば即アンドゥ
		this.undoHistory.pop();
		// リドゥ用に現在の描画状態をスナップショット
		const source_d_now = map.getSource(last.sourceId_d);
		const source_s_now = map.getSource(last.sourceId_s);
		this.redoHistory.push({
			kind: 'drawing',
			sourceId_d: last.sourceId_d,
			data_d: source_d_now ? JSON.parse(JSON.stringify(source_d_now._data)) : null,
			sourceId_s: last.sourceId_s,
			data_s: source_s_now ? JSON.parse(JSON.stringify(source_s_now._data)) : null,
		});
		if (this.redoHistory.length > MAX_HISTORY * 2) {
			this.redoHistory.splice(0, this.redoHistory.length - MAX_HISTORY * 2);
		}

		this.applyAction(last);
		const center = map.getCenter();
		const source_d = map.getSource(last.sourceId_d);
		if (source_d) {
			this.drawUpdatetimerId = setTimeout(() => {
				this.updateDrawingData(2, source_d._data, _drawingTag, center.lng, center.lat);
			}, _drawUpdateTimer);
		}
		const source_s = map.getSource(last.sourceId_s);
		if (source_s) {
			this.shapeUpdatetimerId = setTimeout(() => {
				this.updateDrawingData(3, source_s._data, _shapeTag, center.lng, center.lat);
			}, _drawUpdateTimer);
		}
	};

	redo = () => {
		const { map } = this.state;
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);
		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);

		if (this.redoHistory.length === 0) return;

		const next = this.redoHistory.pop();

		if (next.kind === 'marker') {
			this.suppressRedoClear = true;
			try {
				this.applyMarkerRedo(next);
			} finally {
				this.suppressRedoClear = false;
			}
			return;
		}

		if (next.kind !== 'drawing') return;

		// 現在の状態を undoHistory に積む（redoHistory はクリアしない）
		const source_d_now = map.getSource(next.sourceId_d);
		const source_s_now = map.getSource(next.sourceId_s);
		this.suppressRedoClear = true;
		this.recordUndo({
			kind: 'drawing',
			sourceId_d: next.sourceId_d,
			data_d: source_d_now ? JSON.parse(JSON.stringify(source_d_now._data)) : null,
			sourceId_s: next.sourceId_s,
			data_s: source_s_now ? JSON.parse(JSON.stringify(source_s_now._data)) : null,
		});
		this.suppressRedoClear = false;

		this.applyAction(next);
		const center = map.getCenter();
		const source_d = map.getSource(next.sourceId_d);
		if (source_d) {
			this.drawUpdatetimerId = setTimeout(() => {
				this.updateDrawingData(2, source_d._data, _drawingTag, center.lng, center.lat);
			}, _drawUpdateTimer);
		}
		const source_s = map.getSource(next.sourceId_s);
		if (source_s) {
			this.shapeUpdatetimerId = setTimeout(() => {
				this.updateDrawingData(3, source_s._data, _shapeTag, center.lng, center.lat);
			}, _drawUpdateTimer);
		}
	};

	// マーカーのアンドゥ実行直前に、リドゥ用のエントリを生成する。
	// 'add' のアンドゥ→削除直前にデータを退避、'edit'/'move' は現在値を退避、
	// 'delete' のアンドゥは再追加後に新 docId を後から差し込む。
	captureMarkerRedo = (undoEntry) => {
		switch (undoEntry.op) {
			case 'add': {
				const existMarker = this.markers.find(m => m.id === undoEntry.docId);
				if (!existMarker) return null;
				const m = existMarker.marker;
				return {
					kind: 'marker',
					op: 'add',
					markerData: {
						lng: m.lng, lat: m.lat, elevation: m.elevation,
						name: m.name, reading: m.reading, note: m.note,
						iconNumber: m.iconNumber,
					},
				};
			}
			case 'delete': {
				return {
					kind: 'marker',
					op: 'delete',
					docId: null, // applyMarkerUndo 後に新 docId を設定
				};
			}
			case 'edit': {
				const existMarker = this.markers.find(m => m.id === undoEntry.docId);
				if (!existMarker) return null;
				const m = existMarker.marker;
				return {
					kind: 'marker',
					op: 'edit',
					docId: undoEntry.docId,
					newData: {
						name: m.name, reading: m.reading, note: m.note,
						iconNumber: m.iconNumber, elevation: m.elevation,
						lng: m.lng, lat: m.lat,
					},
				};
			}
			case 'move': {
				const existMarker = this.markers.find(m => m.id === undoEntry.docId);
				if (!existMarker) return null;
				const m = existMarker.marker;
				return {
					kind: 'marker',
					op: 'move',
					docId: undoEntry.docId,
					newLng: m.lng, newLat: m.lat, newElevation: m.elevation,
				};
			}
			default:
				return null;
		}
	};

	// マーカーのリドゥを適用。次のアンドゥ用に undoHistory にも適切なエントリを積む。
	applyMarkerRedo = (entry) => {
		const { map } = this.state;
		if (!map) return;
		const collectionPath = `userdata/${this.props.owneruid}/projects/${this.props.uuid}/items`;
		switch (entry.op) {
			case 'add': {
				// 'add' のリドゥ = 再追加。handleAddMarker が undo エントリを async で積む。
				this.handleAddMarker(entry.markerData, { skipLimitCheck: true });
				break;
			}
			case 'delete': {
				// 'delete' のリドゥ = 再削除
				const existMarker = this.markers.find(m => m.id === entry.docId);
				if (!existMarker) return;
				const m = existMarker.marker;
				const markerData = {
					lng: m.lng, lat: m.lat, elevation: m.elevation,
					name: m.name, reading: m.reading, note: m.note,
					iconNumber: m.iconNumber,
				};
				this.removeMarkerFromMap(entry.docId);
				this.props.fm.deleteDocument(collectionPath, entry.docId);
				this.touchProjectIfEditable();
				this.recordUndo({
					kind: 'marker',
					op: 'delete',
					docId: entry.docId,
					markerData,
				});
				break;
			}
			case 'edit': {
				const existMarker = this.markers.find(m => m.id === entry.docId);
				if (!existMarker) return;
				const m = existMarker.marker;
				// 現在値（アンドゥ後に復元された旧データ）を新 undo エントリに退避
				this.recordUndo({
					kind: 'marker',
					op: 'edit',
					docId: entry.docId,
					oldData: {
						name: m.name, reading: m.reading, note: m.note,
						iconNumber: m.iconNumber, elevation: m.elevation,
						lng: m.lng, lat: m.lat,
					},
				});
				const nd = entry.newData;
				m.name = nd.name;
				m.reading = nd.reading;
				m.note = nd.note;
				m.iconNumber = nd.iconNumber;
				m.elevation = nd.elevation;
				m.data = { ...m.data, ...nd };
				m.remakeMarker(
					(marker) => { marker.addToMap(); this.updateFirebaseMarker(marker, entry.docId); },
					(marker) => { this.updateFirebaseMarker(marker, entry.docId); }
				);
				break;
			}
			case 'move': {
				const existMarker = this.markers.find(m => m.id === entry.docId);
				if (!existMarker) return;
				const m = existMarker.marker;
				this.recordUndo({
					kind: 'marker',
					op: 'move',
					docId: entry.docId,
					oldLng: m.lng, oldLat: m.lat, oldElevation: m.elevation,
				});
				m.lng = entry.newLng;
				m.lat = entry.newLat;
				m.elevation = entry.newElevation;
				if (m.marker) {
					m.marker.setLngLat([entry.newLng, entry.newLat]);
				}
				this.updateFirebaseMarker(m, entry.docId);
				break;
			}
			default:
				break;
		}
	};

	applyAction = (action) => {
		if(!action) return;
		const { map } = this.state;
		const source_d = map.getSource(action.sourceId_d);
		const source_s = map.getSource(action.sourceId_s);

		if (source_d && action.data_d && action.data_d) {
			source_d.setData(action.data_d);
			this.syncLabelMarkers(action.sourceId_d, action.data_d);
		}
		if (source_s && action.data_s && action.data_s) {
			source_s.setData(action.data_s);
		}
	};

	// マーカー操作のアンドゥを適用
	applyMarkerUndo = (entry) => {
		const { map } = this.state;
		if (!map) return;
		const collectionPath = `userdata/${this.props.owneruid}/projects/${this.props.uuid}/items`;
		switch (entry.op) {
			case 'add':
				// 追加のアンドゥ = 削除
				this.removeMarkerFromMap(entry.docId);
				this.props.fm.deleteDocument(collectionPath, entry.docId);
				this.touchProjectIfEditable();
				break;
			case 'delete':
				// 削除のアンドゥ = 再追加（handleAddMarker 経由で新規 docId になるが内容は復元）
				return this.handleAddMarker(entry.markerData, { skipLimitCheck: true });
			case 'edit':
				// 編集のアンドゥ = 旧データを復元
				{
					const existMarker = this.markers.find(m => m.id === entry.docId);
					if (existMarker) {
						const old = entry.oldData;
						existMarker.marker.name = old.name;
						existMarker.marker.reading = old.reading;
						existMarker.marker.note = old.note;
						existMarker.marker.iconNumber = old.iconNumber;
						existMarker.marker.elevation = old.elevation;
						existMarker.marker.data = { ...existMarker.marker.data, ...old };
						existMarker.marker.remakeMarker(
							(marker) => { marker.addToMap(); this.updateFirebaseMarker(marker, entry.docId); },
							(marker) => { this.updateFirebaseMarker(marker, entry.docId); }
						);
					}
				}
				break;
			case 'move':
				// 移動のアンドゥ = 旧位置を復元
				{
					const existMarker = this.markers.find(m => m.id === entry.docId);
					if (existMarker) {
						existMarker.marker.lng = entry.oldLng;
						existMarker.marker.lat = entry.oldLat;
						existMarker.marker.elevation = entry.oldElevation;
						if (existMarker.marker.marker) {
							existMarker.marker.marker.setLngLat([entry.oldLng, entry.oldLat]);
						}
						this.updateFirebaseMarker(existMarker.marker, entry.docId);
					}
				}
				break;
			default:
				break;
		}
	};

	// Marker.js の dragend から呼ばれる（this.lng 更新前）
	onBeforeMarkerMove = (markerInstance) => {
		if (!markerInstance || !markerInstance.docId) return;
		this.recordUndo({
			kind: 'marker',
			op: 'move',
			docId: markerInstance.docId,
			oldLng: markerInstance.lng,
			oldLat: markerInstance.lat,
			oldElevation: markerInstance.elevation,
		});
	};


	//--------------------イベント処理

	// state.map は setState 経由なので反映が1テンポ遅れる。load 時に同期代入した
	// this.map を優先して使い、読み込み処理が state 反映待ちで落ちないようにする。
	getMap() {
		return this.map || this.state.map;
	}

	//フォーカス
	handleVisibilityChange = () => {
		if (document.visibilityState === 'visible') {
			// iOSでタブがサスペンドされて読み込みを取りこぼしたケースの復帰
			this.retryItemLoadIfIncomplete();
		}
		else if (document.visibilityState === 'hidden') {
			// タブが閉じられる/サスペンドされる前に、保留中の索引書き込みを済ませる
			this.flushItemsIndexRebuild();
		}
	};

	//オンライン復帰
	handleOnline = () => {
		this.retryItemLoadIfIncomplete();
	};

	toggleDiagLogPopup = () => {
		this.setState(prev => ({ showDiagLogPopup: !prev.showDiagLogPopup }));
	};

	componentDidMount() {
		// 診断ログのヘッダに画面側の状態を載せる
		DiagLog.setContextProvider(() => ({
			cacheMode: FIRESTORE_CACHE_MODE,
			longPoll: FIRESTORE_FORCE_LONG_POLLING,
			serverSeen: this.firestoreServerSeen === true,//一度でもサーバ由来の応答が来たか
			uuid: this.props.uuid,
			owneruid: this.props.owneruid,
			signedIn: this.props.isSignedIn,
			authUid: (this.props.fm && this.props.fm.auth && this.props.fm.auth.currentUser) ? this.props.fm.auth.currentUser.uid : null,
			permission: this.state.permission,
			mapReady: !!this.getMap(),
			itemsDone: this.isLoadedDrawingData,
			fromCache: this.itemLoadRenderedFromCache,
			indexMode: this.itemsIndexMode,
			itemDocs: this.itemDocs ? this.itemDocs.size : -1,
			indexDirty: this.itemsIndexState ? this.itemsIndexState.dirty : false,
			markers: this.markers ? this.markers.length : 0,
			files: this.state.files ? this.state.files.length : 0,
			project: this.currentProject ? (this.currentProject.title || '(no title)') : null,
		}));

		this.initializeMap();
		window.removeEventListener('keydown', this.handleKeyDown);
		window.removeEventListener('keyup', this.handleKeyUp);
		window.removeEventListener('mouseout', this.handleMouseOut);

		window.addEventListener('keydown', this.handleKeyDown);
		window.addEventListener('keyup', this.handleKeyUp);
		window.addEventListener('keypress', this.handleKeypress);
		window.removeEventListener('paste', this.handlePaste);
		window.addEventListener('paste', this.handlePaste);

		// 保存された設定を適用
		const savedColor = localStorage.getItem('selectedColor');
		const savedOpacity = localStorage.getItem('selectedOpacity');
		const savedLineWidth = localStorage.getItem('lineWidth');

		if (savedColor) this.setState({ selectedColor: savedColor });
		if (savedOpacity) this.setState({ selectedOpacity: parseInt(savedOpacity, 10) });
		if (savedLineWidth) this.setState({ lineWidth: parseInt(savedLineWidth, 10) });

		document.addEventListener('visibilitychange', this.handleVisibilityChange);
		window.addEventListener('online', this.handleOnline);

		window.addEventListener('mouseup', this.handleGlobalMouseUp);

		if (this.state.map) {
			this.state.map.on('click', this.hideCenterMarkMenu);
			this.state.map.on('wheel', this.hideCenterMarkMenu);
			this.state.map.on('drag', this.hideCenterMarkMenu);
		}
	}


	componentWillUnmount() {
		const { map } = this.state;
		if (map) {
			map.off('mousedown', this.startDrawing);
			map.off('mousemove', this.drawLine);
			map.off('mouseup', this.endDrawing);
			map.off('touchstart', this.startDrawing);
			map.off('touchmove', this.drawLine);
			map.off('touchend', this.endDrawing);
			map.off('mouseout', this.handleMouseOut);

//			map.off('dblclick', this.handleDoubleClick);

			map.off('moveend', this.updateCenterElevation);

			map.off('touchstart', this.handleTouchStart);
			map.off('touchend', this.handleTouchEnd);
		}
		window.removeEventListener('keydown', this.handleKeyDown);
		window.removeEventListener('keyup', this.handleKeyUp);
		window.removeEventListener('keypress', this.handleKeypress);
		window.removeEventListener('paste', this.handlePaste);
		//window.removeEventListener('mouseout', this.handleMouseOut);

		// 保留中の updatetime 後追い書き込みをフラッシュ（最後の編集を確実に反映）
		if (this.props.fm) {
			this.props.fm.flushProjectUpdatetime();
		}
		// 保留中の索引書き込みも済ませる
		this.flushItemsIndexRebuild();

		// リスナーの解除
		if (this.unsubscribeDocListener) {
			this.unsubscribeDocListener();
		}
		if (this.unsubscribeColListener) {
			this.unsubscribeColListener();
		}
		// 再試行タイマーの解除
		if (this.mapLoadWatchdog) clearTimeout(this.mapLoadWatchdog);
		if (this.itemLoadRetryTimer) clearTimeout(this.itemLoadRetryTimer);
		if (this.docListenerRetryTimer) clearTimeout(this.docListenerRetryTimer);
		if (this.colListenerRetryTimer) clearTimeout(this.colListenerRetryTimer);

		document.removeEventListener('visibilitychange', this.handleVisibilityChange);
		window.removeEventListener('online', this.handleOnline);

		window.removeEventListener('mouseup', this.handleGlobalMouseUp);

		  // Remove map click and scroll event listeners
		if (this.state.map) {
			this.state.map.off('click', this.hideCenterMarkMenu);
			this.state.map.off('wheel', this.hideCenterMarkMenu);
			this.state.map.off('drag', this.hideCenterMarkMenu);
		}
	}

	hideCenterMarkMenu = () => {
		if (this.state.showCenterMarkMenu) {
			this.setState({ showCenterMarkMenu: false });
		}
	}


	// グローバルマウスアップハンドラの追加
	handleGlobalMouseUp = (e) => {
		if (this.state.isDrawing) {
			const rect = this.mapContainerRef.current.getBoundingClientRect();
			const point = {
				x: e.clientX - rect.left,
				y: e.clientY - rect.top
			};
			
			// マップの座標に変換
			const lngLat = this.state.map.unproject([point.x, point.y]);
			
			this.endDrawing({
				lngLat: lngLat,
				originalEvent: e
			});
		}
	};

	handleMapMove = () => {
		// 開き得るポップアップはクリックされたマーカー(currentMarker)のものだけ。
		// move イベントは連発するため全マーカー走査はせず対象を限定する。
		const markerInstance = this.currentMarker;
		if (!markerInstance || !markerInstance.marker) return;
		const popup = markerInstance.marker.getPopup();
		if (popup && popup.isOpen()) {
			markerInstance.closePopup();
		}
	};

	handleMouseOut = (e) => {
		// 描画モードでない場合のみ終了処理を行う
		if (!this.state.isDrawingMode) {
			if (!this.state.isDrawing) return;
			if(this.isAltKeyPressed) {
				console.log('handleMouseOut');
				this.isAltKeyPressed = false;
				this.setState({ isDrawing: false });
				const { map} = this.state;
				map.dragPan.enable();
				const source = map.getSource(this.myDrawing);
				if(source) {
					const data = source._data;
					if (data && data.features) {
						source.setData(data);
					}
				}
				this.currentLine = [];
				this.endDrawing(e);
			}
		}
	}

	isOpenOtherPopup() {
		return (this.state.showChatPanel || this.state.showSearchPopup || this.state.showEditMarkerPopup || this.state.showAddMarkerPopup || this.state.showEditProjectPopup || this.state.showLabelAddPopup || this.state.showLabelEditPopup || this.state.showShortcutsPopup);
	}

	handleKeyDown = (e) => {
		const { map ,isDrawingMode} = this.state;

		if (this.isOpenOtherPopup() || e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'textarea') {
			return;
		}

		const key = e.key.toLowerCase();

		if(this.state.permission === 2) {
			/*if (e.key === 'Alt') {
				this.isAltKeyPressed = true;
				this.state.map.dragPan.disable();

				map.getCanvas().style.cursor = 'url(/img/pen.png) 0 32, auto';
			}
			else*/ if (e.key === ' ' || e.key === 'Spacebar') {
				this.isSpaceKeyPressed = true;
				this.state.map.dragPan.enable();
				//map.getCanvas().style.cursor = 'grab';
			}

			// Mac は Cmd (metaKey)、Win/Linux は Ctrl (ctrlKey) を受け付ける
			const cmdOrCtrl = e.ctrlKey || e.metaKey;
			if (cmdOrCtrl && (key === 'z' || e.code === 'KeyZ')) {
				e.preventDefault();
				this.undo();
			}
			if (cmdOrCtrl && (key === 'y' || e.code === 'KeyY')) {
				e.preventDefault();
				this.redo();
			}
			// Ctrl+V / Cmd+V の処理を追加
			if (cmdOrCtrl && key === 'v') {
				this.handlePasteMarker();
			}

			if (cmdOrCtrl && key === 'c') {
				if(this.currentMarker) {
					this.currentMarker.copyToClipboard();
				}
			}
		}		
	};


	// Ctrl+V / Cmd+V で画像(ファイル)が貼られたときの処理。
	// エクスプローラー等でコピーした写真ファイルは EXIF を保持したまま届くので、
	// 通常のファイルアップロードと同じ経路（EXIF GPS → 撮影地点に配置）に流す。
	// 画像以外（マーカーJSONテキスト等）は handleKeyDown 側の handlePasteMarker に任せる。
	handlePaste = (e) => {
		if (this.state.permission !== 2) return;
		if (this.isOpenOtherPopup()) return;
		const tag = e.target && e.target.tagName ? e.target.tagName.toLowerCase() : '';
		if (tag === 'input' || tag === 'textarea' || (e.target && e.target.isContentEditable)) return;
		if (!e.clipboardData) return;

		const files = [];
		const items = e.clipboardData.items ? Array.from(e.clipboardData.items) : [];
		for (const item of items) {
			if (item.kind !== 'file') continue;
			const file = item.getAsFile();
			if (!file) continue;
			const isImage = (file.type && file.type.startsWith('image/')) || /\.(png|jpe?g|gif)$/i.test(file.name || '');
			if (!isImage) continue;
			files.push(file);
		}
		if (files.length === 0) return;

		e.preventDefault();
		e.stopPropagation();

		// 画面キャプチャ等はファイル名が無い（image.png）ので一意な名前を付けて写真として登録する
		const named = files.map((file, i) => {
			if (file.name && file.name !== 'image.png') return file;
			const ext = (file.type && file.type.split('/')[1]) ? file.type.split('/')[1].replace('jpeg', 'jpg') : 'png';
			const stamp = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 14);
			return new File([file], `paste_${stamp}${files.length > 1 ? '_' + (i + 1) : ''}.${ext}`, { type: file.type, lastModified: file.lastModified || Date.now() });
		});
		this.handleFileUpload({ target: { files: named } });
	};

	checkClipboardPasteMarker = async () => {
		const clipboardText = await navigator.clipboard.readText();
		if(!clipboardText || clipboardText.length < 1)	return false;
		try {
			const clipboardData = JSON.parse(clipboardText);
			if (clipboardData.app === "CollaboMap" || clipboardData.app === "CollaboMap-Label") return true;
			else return false;
		}
		catch(error) {
		}
		return false;
	}
	// 新しい非同期関数を作成してクリップボードの処理を行う
	handlePasteMarker = async () => {
		try {
			const clipboardText = await navigator.clipboard.readText();
			if(!clipboardText || clipboardText.length < 1)	return;
			const clipboardData = JSON.parse(clipboardText);
			await navigator.clipboard.writeText("");
			if (clipboardData.app === "CollaboMap-Label") {
				if (!clipboardData.label) return;
				if (this.state.map) {
					this.state.map.flyTo({ center: [clipboardData.lng, clipboardData.lat] });
				}
				this.addLabelFeature({
					lng: clipboardData.lng,
					lat: clipboardData.lat,
					label: clipboardData.label,
					fontSize: clipboardData.fontSize || 20,
					color: clipboardData.color,
					haloColor: clipboardData.haloColor,
				});
				return;
			}
			if (clipboardData.app === "CollaboMap") {
				// マーカーデータの抽出
				const markerData = {
					lng: clipboardData.lng,
					lat: clipboardData.lat,
					elevation: clipboardData.elevation,
					name: clipboardData.name,
					reading: clipboardData.reading,
					note: clipboardData.note,
					iconNumber: clipboardData.iconNumber
				};
				// 同じ座標・名前・アイコンのマーカーが既にあれば重複として追加をキャンセル
				const isDuplicate = this.markers.some(({ marker }) =>
					marker.lng === markerData.lng &&
					marker.lat === markerData.lat &&
					marker.data && marker.data.name === markerData.name &&
					marker.data.iconNumber === markerData.iconNumber
				);
				if (isDuplicate) {
					const t = (key) => translator.t(key);
					toast.info(t('duplicate_marker_message'));
					return;
				}
				if (this.state.map) {
					this.state.map.flyTo({
						center: [clipboardData.lng, clipboardData.lat],
					});
				}
				this.handleAddMarker(markerData);
			}
		} catch (error) {
			console.error('Failed to paste marker:', error);
		}
	};

	handleKeyUp = (e) => {
		const { map ,isDrawingMode} = this.state;
		if (this.isOpenOtherPopup() || e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'textarea') {
			return;
		}

		if(this.state.permission === 2) {
			if (e.key === 'Alt') {
				this.isAltKeyPressed = false;
				if(!this.state.isDrawingMode) this.state.map.dragPan.enable();
				map.getCanvas().style.cursor = 'grab';
			}
			if (e.key === ' ' || e.key === 'Spacebar') {
				this.isSpaceKeyPressed = false;
				this.state.map.dragPan.disable();

				if(isDrawingMode === 1) map.getCanvas().style.cursor = 'url(/img/pen.png) 0 32, auto';
				else if(isDrawingMode === 2) map.getCanvas().style.cursor = 'url(/img/eraser.png) 0 32, auto';
				else if(isDrawingMode === 3) map.getCanvas().style.cursor = 'crosshair';
			}
		}
	};

	handleKeypress = (e) => {
		if (this.isOpenOtherPopup() || e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'textarea') {
			return;
		}
		const key = e.key.toLowerCase();

		//編集系機能
		if(this.state.permission === 2) {
			if (key === 'e') {
				this.clickEraserButton();
			}
			if (key === 'b') {
				this.clickPenButton();
			}
			if (key === 's') {
				this.clickShapeButton();
			}
			if (key === 'p') {
				this.togglePalettePopup();//setState({ showPalettePopup: true });
			}
			if (key === 'm') {
				if(this.checkMarkerLimit()) this.setState({ showAddMarkerPopup: true });
			}
			// 図形サブツール：同じツール選択中に押したら解除、そうでなければ選択
			if (key === 'c' || key === 'l' || key === 'k' || key === 'g' || key === 'a') {
				const keyToMode = { c: 'circle', l: 'line', k: 'measurement', g: 'grid', a: 'label' };
				const targetMode = keyToMode[key];
				if (this.state.isDrawingMode === 3 && this.state.shapeDrawingMode === targetMode) {
					// 同じツールなら図形モードごと解除
					this.clickShapeButton();
				} else {
					if (this.state.isDrawingMode !== 3) {
						this.clickShapeButton();
					}
					if (key === 'c') this.clickCircleButton();
					else if (key === 'l') this.clickLineButton();
					else if (key === 'k') this.clickMeasurementButton();
					else if (key === 'g') this.clickGridButton();
					else if (key === 'a') this.clickLabelButton();
				}
			}
		}

		//ヘルプ（一覧表示）
		if (key === '?') {
			this.setState({ showShortcutsPopup: true });
		}

		//一般機能
		if (key === 'd') {
			const { map, is3DEnabled, exaggeration } = this.state;
			if (!map) return;

			if (!is3DEnabled) {
				if (map.getPitch() === 0) map.setPitch(40);
				map.setTerrain({ source: 'terrain', exaggeration: exaggeration });
				this.setState({ is3DEnabled: true });
				setTimeout(() => {
					this.customScale.update();
				}, 100);
			} else {
				this.clickPoszeroButton();
			}
		}

	};

	//図形描画開始
	//直線：マウスダウンしてそのまま移動、離したら確定
	//円：マウスダウンしてそのまま移動、離したら確定
	//ポリゴン：マウスダウンして移動、マウスアップでポイント追加、
	startShape = (e) => {
		const { map } = this.state;
		if (this.state.isDrawingMode === 3) {
			//準備
			let source = map.getSource(this.myShape);
			if(!source || source === undefined) {
				source = this.addShapeSource(map,this.myShape);
				this.addShapeLayer(map,this.myShape);
				this.addLabelSourceAndLayer(map,this.myShape);
			}

			source = map.getSource(this.myDrawing);
			if(!source || source === undefined) {
				source = this.addDrawingSource(map,this.myDrawing);
				this.addDrawingLayer(map,this.myDrawing);
			}

			const { shapeDrawingMode } = this.state;
			const lngLat = e.lngLat;
			
			//直線
			if (shapeDrawingMode === 'line') {
				this.clickLineDrawing(lngLat);
			}

			//円
			else if (this.state.shapeDrawingMode === 'circle') {
				if(this.shapeDrawing) {
					this.finishCircleDrawing(lngLat);
				}
				else {
					this.shapeDrawing = true;
					this.startCircleDrawing(lngLat);
				}
			}

			//グリッド
			else if (shapeDrawingMode === 'grid') {
				if (this.shapeDrawing) {
					this.finishGridDrawing(lngLat);
				} else {
					this.shapeDrawing = true;
					this.startGridDrawing(lngLat);
				}
			}

			//ポリゴン
			else if (shapeDrawingMode === 'polygon') {
				if(!this.shapeDrawing) {
					this.startPolygonDrawing(lngLat);
				}
			}

			//計測
			if (shapeDrawingMode === 'measurement') {
				//計測の始点を決める
				this.clickMeasurement(lngLat);				
			}
			//タイマー発火で指定位置に移動する
			if (lngLat) {
				this.moveToCoordinateAfterDelay(lngLat);
			}

		}
	};

	endShapeAll() {
		this.endShape(null);
	}

	//クリック
	handleMapClick = (e) => {
		if (this.state.shapeDrawingMode !== 'label' && this.state.isDrawingMode === 3) {//図形
			return;
		}
		if (this.state.shapeDrawingMode === 'label' && this.state.isDrawingMode !== 3) {
			return;
		}
		// ラベルモード: 地図クリックで追加ダイアログを開く
		if (this.state.shapeDrawingMode === 'label') {
			if (this.state.showLabelAddPopup) return;
			// 既存ラベル（userLabel）をクリックした場合はレイヤ側のハンドラに任せる
			const { map } = this.state;
			if (map && this.myDrawing) {
				const layerId = this.myDrawing + '-user-label';
				if (map.getLayer(layerId)) {
					const feats = map.queryRenderedFeatures(e.point, { layers: [layerId] });
					if (feats && feats.some(f => f.properties && f.properties.userLabel === true)) {
						return;
					}
				}
			}
			this.setState({
				pendingLabelLngLat: { lng: e.lngLat.lng, lat: e.lngLat.lat },
				showLabelAddPopup: true,
			});
		}
	};

	//ダブルクリック　描画終了
	handleDoubleClick = (e) => {
		if (this.shapeDrawing && this.state.isDrawingMode === 3) {
			if(this.state.shapeDrawingMode === 'line') {
				this.finishLineDrawing(e.lngLat);
			}
			else if(this.state.shapeDrawingMode === 'polygon') {
				this.finishPolygonDrawing();
			}
			else if(this.state.shapeDrawingMode === 'measurement') {
				this.finishMeasurement(e.lngLat);
			}
			this.resetMapInteraction();
		}
		this.props.fm.checkAndSaveCurrentPosition(this.props.owneruid,this.props.uuid,this.state.map,this.currentProject);

	};

	//図形 マウスアップ
/*	endShape = (e) => {
		if (this.shapeDrawing && this.state.isDrawingMode === 3) {
		
			let type = null;
			let id = null;

			//直線
			if (this.state.shapeDrawingMode === 'line') {
				this.finishLineDrawing(e.lngLat);
				type = _drawingTag;
				id = this.myDrawing;
			}

			//円
			else if (this.state.shapeDrawingMode === 'circle') {
				this.finishCircleDrawing(e.lngLat);
				type = _shapeTag;
				id = this.myShape;
			}

			//ポリゴン
			else if (this.state.shapeDrawingMode === 'polygon') {
				this.addPointPolygon(e.lngLat);
				type = _shapeTag;
				id = this.myShape;
			}

			//計測
			else if (this.state.shapeDrawingMode === 'measurement') {
				this.updateMeasurement(e.lngLat,true);
				console.log('endShape:');
//				type = _drawingTag;
//				id = this.myDrawing;

			}

			this.props.fm.checkAndSaveCurrentPosition(this.props.owneruid,this.props.uuid,this.state.map,this.currentProject);

//			this.addToHistory();
		}
	};*/

	endShape = (e) => {
		if (this.shapeDrawing && this.state.isDrawingMode === 3) {
			// 円の場合は従来通りの処理
			if (this.state.shapeDrawingMode === 'circle') {
				this.finishCircleDrawing(e.lngLat);
				this.resetMapInteraction();
				return;
			}

			// グリッドの場合
			if (this.state.shapeDrawingMode === 'grid') {
				if (this.shapeDrawing) {
					this.finishGridDrawing(e.lngLat);
				}
				this.resetMapInteraction();
				return;
			}

			// その他の図形の場合は操作パネルを表示
			const point = this.state.map.project(e.lngLat);
			this.setState({
				showShapeOperationPanel: true,
				operationPanelPosition: { x: point.x, y: point.y }
			});

			if (this.state.shapeDrawingMode === 'line') {
				this.updateLineDrawing(e.lngLat);
			}
			else if (this.state.shapeDrawingMode === 'polygon') {
				this.addPointPolygon(e.lngLat);
			}
			else if (this.state.shapeDrawingMode === 'measurement') {
				this.updateMeasurement(e.lngLat, true);
			}
		}
	};

	//マップの操作状態をリセット
	resetMapInteraction = () => {
	const { map } = this.state;
	if (!map) return;

	// マーカーのポインターイベントを再有効化
	this.changeMarkersPointerEvents(true);

	// マップの操作を通常状態に戻す
	map.dragPan.enable();
	map.doubleClickZoom.enable();
	map.touchZoomRotate.enable();
	map.getCanvas().style.cursor = 'grab';

	// 図形描画モードをリセット
	this.shapeDrawing = false;
	};


	//線描画
	clickLineDrawing = (lngLat) => {
		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);

		const { shapePoints } = this.state;
		const newPoints = [...shapePoints, [lngLat.lng, lngLat.lat]];

		this.setState({ shapePoints: newPoints });

		if (newPoints.length > 0) {
			const lineFeature = {
				type: 'Feature',
				geometry: {
					type: 'LineString',
					coordinates: newPoints
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth
				}
			};
			this.updateShapeLineSource(lineFeature);
		}
	};



	updateLineDrawing = (lngLat) => {//マウスが動いてるとき
		const { shapePoints } = this.state;
		const newPoints = [...shapePoints, [lngLat.lng, lngLat.lat]];

		if (newPoints.length > 1) {
			const lineFeature = {
				type: 'Feature',
				geometry: {
					type: 'LineString',
					coordinates: newPoints
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth,
				}
			};
			this.updateShapeLineSource(lineFeature);//線更新
		}
	};

	//線更新
	updateShapeLineSource = (feature) => {
		const { map } = this.state;
		let source = map.getSource(this.myDrawing);
		
		if (source) {
			const geoJSON = source._data;

			if(this.shapeDrawing) {
				geoJSON.features[geoJSON.features.length - 1] = feature;
				console.log("updateShapeLineSource:1");
			}
			else {
				geoJSON.features.push(feature);
				this.shapeDrawing = true;
				console.log("updateShapeLineSource:2");
			}

			source.setData(geoJSON);
		}
	};

	// 新しいメソッド
	removeLastPoint = () => {
		const { shapePoints } = this.state;
		if (shapePoints.length > 1) {
			const newPoints = shapePoints.slice(0, -1);
			this.setState({ shapePoints: newPoints }, () => {
			// 現在の描画モードに応じて適切な更新処理を呼び出す
			if (this.state.shapeDrawingMode === 'line' || this.state.shapeDrawingMode === 'measurement') {
				const lineFeature = {
				type: 'Feature',
				geometry: {
					type: 'LineString',
					coordinates: newPoints
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth
				}
				};
				this.updateShapeLineSource(lineFeature);
			} else if (this.state.shapeDrawingMode === 'polygon') {
				const polygonFeature = {
					type: 'Feature',
					geometry: {
						type: 'Polygon',
						coordinates: [newPoints]
					},
					properties: {
						color: this.state.selectedColor,
						width: this.state.lineWidth
					}
				};
				this.updateShapeSource(polygonFeature);
			}
			});
		}
	};


	//線終了
	finishLineDrawing = (lngLat) => {
		const { shapePoints,map } = this.state;
		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);
		const newPoints = [...shapePoints, [lngLat.lng, lngLat.lat]];

		if (newPoints.length > 1) {
			const lineFeature = {
				type: 'Feature',
				geometry: {
				type: 'LineString',
				coordinates: newPoints
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth
				}
			};
			this.updateShapeLineSource(lineFeature);
			this.setState({ shapePoints: [], currentShape: null });

			// GeoJSONをFirestorageに保存
			let source = map.getSource(this.myDrawing);
			if (source) {
				this.drawUpdatetimerId = setTimeout(() => {
					const geoJSON = source._data;
					this.updateDrawingData(2,geoJSON,_drawingTag,lngLat.lng,lngLat.lat);
				}, _drawUpdateTimer);
			}
		}

		this.shapeDrawing = false;

		// タイマー発火で指定位置に移動する
		if (lngLat) {
			this.moveToCoordinateAfterDelay(lngLat);
		}
	};

	//計測線開始
	clickMeasurement = async(lngLat) => {
		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);
		const { shapePoints } = this.state;
	
		const elevation = await elevationService.getElevation(lngLat.lat, lngLat.lng);
		const newPoints = [ ...shapePoints,[lngLat.lng, lngLat.lat, elevation]];

		this.setState({ shapePoints: newPoints });

		if (newPoints.length > 0) {
			const lineFeature = {
				type: 'Feature',
				geometry: {
					type: 'LineString',
					coordinates: newPoints
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth
				}
			};
			this.updateShapeLineSource(lineFeature);
		}
	};

	//計測の線を更新
	updateMeasurement = async(lngLat,isAdd = false) => {//マウスが動いてるとき
		const { shapePoints } = this.state;
		const elevation = await elevationService.getElevation(lngLat.lat, lngLat.lng);
		const newPoints = [...shapePoints, [lngLat.lng, lngLat.lat,elevation]];

		let distance = 0;
		if (newPoints.length > 1) {
			distance = CommonUtils.calculateDistanceWithElevationArray(newPoints);
			const eleDiff =	CommonUtils.calculateDiffElevationArray(newPoints);
			const walkSpeed = FirebaseManager.getWalkSpeed(this.props.userSettings.walkingSpeed);
			const time = CommonUtils.calcTimeArray(newPoints,walkSpeed);

			const lineFeature = {
				type: 'Feature',
				geometry: {
					type: 'LineString',
					coordinates: newPoints
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth,
					distance:distance,
					time:time,
					altitudeDifferenceAscent:eleDiff.ascent,
					altitudeDifferenceDescent:eleDiff.descent,
				}
			};
			this.updateShapeLineSource(lineFeature);//線更新
			if(isAdd) {
				//console.log('updateMeasurement:' + distance + ":"  + time);
				this.setState({ shapePoints: newPoints, currentShape: null });
			}
			// タイマー発火で指定位置に移動する
			if (lngLat) {
				this.moveToCoordinateAfterDelay(lngLat);
			}

		}
	};

	//計測終了
	finishMeasurement = async(lngLat) => {
		const { shapePoints,map } = this.state;
		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);
/*		const elevation = await elevationService.getElevation(lngLat.lat, lngLat.lng);
		const newPoints = [...shapePoints, [lngLat.lng, lngLat.lat, elevation]];
*/
		let distance = 0;
		if (shapePoints.length > 1) {
			distance = CommonUtils.calculateDistanceWithElevationArray(shapePoints);

			const eleDiff =	CommonUtils.calculateDiffElevationArray(shapePoints);
			const walkSpeed = FirebaseManager.getWalkSpeed(this.props.userSettings.walkingSpeed);
			const time = CommonUtils.calcTimeArray(shapePoints,walkSpeed);
			console.log('finishMeasurement:' + distance + ":"  + time);

			const lineFeature = {
				type: 'Feature',
				geometry: {
					type: 'LineString',
					coordinates: shapePoints
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth,
					distance:distance,
					time:time,
					altitudeDifferenceAscent:eleDiff.ascent,
					altitudeDifferenceDescent:eleDiff.descent,
				}
			};

			// GeoJSONをFirestorageに保存
			let source = map.getSource(this.myDrawing);
			this.updateShapeLineSource(lineFeature);//線更新
			if (source) {
				this.drawUpdatetimerId = setTimeout(() => {
					const geoJSON = source._data;
					this.updateDrawingData(2,geoJSON,_drawingTag,lngLat.lng,lngLat.lat);
				}, _drawUpdateTimer);
			}
		}

		this.setState({ shapePoints: [], currentShape: null });
		this.shapeDrawing = false;
	};


	//グリッド開始
	startGridDrawing = (lngLat) => {
		const start = [lngLat.lng, lngLat.lat];
		this.setState({ currentShape: { start } });
		const rectFeature = this.buildRectFeature(start, start);
		this.startShapeSource(rectFeature);
	};

	//グリッド更新
	updateGridDrawing = (lngLat) => {
		const { currentShape } = this.state;
		if (currentShape && this.shapeDrawing) {
			const end = [lngLat.lng, lngLat.lat];
			const rectFeature = this.buildRectFeature(currentShape.start, end);
			this.updateShapeSource(rectFeature);
		}
	};

	//矩形フィーチャー生成
	buildRectFeature = (start, end) => {
		const [lng1, lat1] = start;
		const [lng2, lat2] = end;
		return {
			type: 'Feature',
			geometry: {
				type: 'Polygon',
				coordinates: [[
					[lng1, lat1],
					[lng2, lat1],
					[lng2, lat2],
					[lng1, lat2],
					[lng1, lat1]
				]]
			},
			properties: {
				color: this.state.selectedColor,
				width: this.state.lineWidth
			}
		};
	};

	//グリッド終了（ポップアップ表示）
	finishGridDrawing = (lngLat) => {
		const { currentShape } = this.state;
		if (!currentShape || !this.shapeDrawing) return;

		const start = currentShape.start;
		const end = [lngLat.lng, lngLat.lat];

		const widthMeters = turf.distance(
			turf.point(start),
			turf.point([end[0], start[1]]),
			{ units: 'meters' }
		);
		const heightMeters = turf.distance(
			turf.point(start),
			turf.point([start[0], end[1]]),
			{ units: 'meters' }
		);

		const rectFeature = this.buildRectFeature(start, end);
		this.updateShapeSource(rectFeature);

		this.setState({
			currentShape: null,
			pendingGridBounds: { start, end, widthMeters, heightMeters },
			showGridDivisionPopup: true
		});
		this.shapeDrawing = false;
	};

	//グリッドセグメント生成
	// 各セルの辺を個別の LineString Feature として返す（直線ツールと同じ myDrawing に入れる）
	// cols×rows → 水平(rows+1)×cols + 垂直(cols+1)×rows 本
	getHaloColor = (hexColor) => {
		const r = parseInt(hexColor.slice(1, 3), 16);
		const g = parseInt(hexColor.slice(3, 5), 16);
		const b = parseInt(hexColor.slice(5, 7), 16);
		const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
		return brightness > 128 ? '#000000' : '#ffffff';
	};

	gridRowLabel = (zeroBasedIndex) => {
		const n = zeroBasedIndex;
		if (n < 26) return String.fromCharCode(65 + n);
		const prefix = String.fromCharCode(65 + Math.floor((n - 26) / 26));
		const suffix = String.fromCharCode(65 + (n - 26) % 26);
		return prefix + suffix;
	};

	generateGridSegments = (start, end, cols, rows, style = {}) => {
		const [lng1, lat1] = start;
		const [lng2, lat2] = end;
		const { lineColor, lineWidth, lineOpacity } = style;
		const props = {
			color: lineColor || this.state.selectedColor,
			width: lineWidth !== undefined ? lineWidth : this.state.lineWidth,
			opacity: lineOpacity !== undefined ? lineOpacity : 1,
		};

		const lngs = Array.from({ length: cols + 1 }, (_, i) => lng1 + (lng2 - lng1) * i / cols);
		const lats = Array.from({ length: rows + 1 }, (_, j) => lat1 + (lat2 - lat1) * j / rows);
		const segments = [];

		// 水平セグメント
		for (let j = 0; j <= rows; j++) {
			for (let i = 0; i < cols; i++) {
				segments.push({
					type: 'Feature',
					geometry: {
						type: 'LineString',
						coordinates: [[lngs[i], lats[j]], [lngs[i + 1], lats[j]]]
					},
					properties: { ...props }
				});
			}
		}

		// 垂直セグメント
		for (let i = 0; i <= cols; i++) {
			for (let j = 0; j < rows; j++) {
				segments.push({
					type: 'Feature',
					geometry: {
						type: 'LineString',
						coordinates: [[lngs[i], lats[j]], [lngs[i], lats[j + 1]]]
					},
					properties: { ...props }
				});
			}
		}


		// グリッドラベル
		const labelMode = style.labelMode || 'exterior_aux';
		const offsetLng = Math.abs(lng2 - lng1) / cols * 0.3;
		const offsetLat = Math.abs(lat2 - lat1) / rows * 0.3;
		const lngLeft = Math.min(lng1, lng2) - offsetLng;
		const lngRight = Math.max(lng1, lng2) + offsetLng;
		const latTop = Math.max(lat1, lat2) + offsetLat;
		const latBottom = Math.min(lat1, lat2) - offsetLat;
		const haloColor = this.getHaloColor(props.color);
		const fontSize = style.fontSize || 28;
		const labelProps = { color: props.color, haloColor, gridLabel: true, fontSize };
		const cellLabelFontSize = Math.max(8, Math.round(fontSize / 1.2));

		// 外周ラベル（外周 / 外周＋補助ラベルモード）
		if (labelMode === 'exterior' || labelMode === 'exterior_aux') {
			// 行ラベル（アルファベット）：左外・右外
			for (let j = 0; j < rows; j++) {
				const midLat = (lats[j] + lats[j + 1]) / 2;
				const letter = this.gridRowLabel(j);
				segments.push({ type: 'Feature', geometry: { type: 'Point', coordinates: [lngLeft, midLat] }, properties: { ...labelProps, label: letter } });
				segments.push({ type: 'Feature', geometry: { type: 'Point', coordinates: [lngRight, midLat] }, properties: { ...labelProps, label: letter } });
			}
			// 列ラベル（数字）：上外・下外
			for (let i = 0; i < cols; i++) {
				const midLng = (lngs[i] + lngs[i + 1]) / 2;
				const num = String(i + 1);
				segments.push({ type: 'Feature', geometry: { type: 'Point', coordinates: [midLng, latTop] }, properties: { ...labelProps, label: num } });
				segments.push({ type: 'Feature', geometry: { type: 'Point', coordinates: [midLng, latBottom] }, properties: { ...labelProps, label: num } });
			}
		}

		// 補助ラベル（3マスごと）
		if (labelMode === 'exterior_aux') {
			for (let j = 3; j <= rows; j += 3) {
				for (let i = 3; i <= cols; i += 3) {
					const letter = this.gridRowLabel(j - 1);
					const cellLabel = `${letter}-${i}`;
					const labelLng = lngs[i] + (lngs[i - 1] - lngs[i]) * 0.5;
					const labelLat = lats[j] + (lats[j - 1] - lats[j]) * 0.5;
					segments.push({
						type: 'Feature',
						geometry: { type: 'Point', coordinates: [labelLng, labelLat] },
						properties: { color: props.color, haloColor, gridCellLabel: true, label: cellLabel, fontSize: cellLabelFontSize }
					});
				}
			}
		}

		// 内部ラベル（全マス）
		if (labelMode === 'interior') {
			for (let j = 1; j <= rows; j++) {
				for (let i = 1; i <= cols; i++) {
					const letter = this.gridRowLabel(j - 1);
					const cellLabel = `${letter}-${i}`;
					const labelLng = (lngs[i - 1] + lngs[i]) / 2;
					const labelLat = (lats[j - 1] + lats[j]) / 2;
					segments.push({
						type: 'Feature',
						geometry: { type: 'Point', coordinates: [labelLng, labelLat] },
						properties: { color: props.color, haloColor, gridCellLabel: true, label: cellLabel, fontSize: cellLabelFontSize }
					});
				}
			}
		}

		return segments;
	};

	//グリッド確定
	handleGridConfirm = (method, value, style = {}) => {
		const { pendingGridBounds, map, selectedColor, lineWidth, selectedOpacity } = this.state;
		if (!pendingGridBounds) return;

		// パレット設定を使用
		style = {
			...style,
			lineColor: selectedColor,
			lineWidth: lineWidth,
			lineOpacity: selectedOpacity / 100,
		};

		const { start, end, widthMeters, heightMeters } = pendingGridBounds;
		let cols, rows;

		let gridEnd = end;
		if (method === 'equal') {
			cols = value;
			rows = Math.max(1, Math.round(cols * heightMeters / widthMeters));
		} else {
			cols = Math.min(36, Math.ceil(widthMeters / value));
			rows = Math.min(36, Math.ceil(heightMeters / value));
			// 始点固定・指定メートルで終点を再計算
			const [lng1, lat1] = start;
			const [lng2, lat2] = end;
			gridEnd = [
				lng1 + (lng2 - lng1) * (cols * value) / widthMeters,
				lat1 + (lat2 - lat1) * (rows * value) / heightMeters,
			];
		}

		// プレビュー矩形を myShape から削除
		const shapeSource = map.getSource(this.myShape);
		if (shapeSource) {
			const shapeData = shapeSource._data;
			if (shapeData && shapeData.features && shapeData.features.length > 0) {
				shapeData.features.pop();
				shapeSource.setData(shapeData);
			}
		}

		// グリッド線を myDrawing に追加（直線ツールと同じ場所）
		const segments = this.generateGridSegments(start, gridEnd, cols, rows, style);
		const drawingSource = map.getSource(this.myDrawing);
		if (drawingSource) {
			const drawingData = drawingSource._data;
			segments.forEach(seg => drawingData.features.push(seg));
			drawingSource.setData(drawingData);

			this.drawUpdatetimerId = setTimeout(() => {
				const geoJSON = drawingSource._data;
				this.updateDrawingData(2, geoJSON, _drawingTag, start[0], start[1]);
			}, _drawUpdateTimer);
		}

		// 設定を記憶
		const prevSettings = this.state.gridSettings;
		const newGridSettings = {
			method,
			equalDivisions: method === 'equal' ? value : prevSettings.equalDivisions,
			distanceInterval: method === 'distance' ? value : prevSettings.distanceInterval,
			fontSize: style.fontSize || 28,
			labelMode: style.labelMode || 'exterior_aux',
		};
		localStorage.setItem('gridSettings', JSON.stringify(newGridSettings));
		this.setState({ showGridDivisionPopup: false, pendingGridBounds: null, gridSettings: newGridSettings });
		this.moveToCoordinateAfterDelay({ lng: start[0], lat: start[1] });
	};

	//グリッドキャンセル
	handleGridCancel = () => {
		const { map } = this.state;
		const source = map.getSource(this.myShape);
		if (source) {
			const data = source._data;
			if (data && data.features && data.features.length > 0) {
				data.features.pop();
				source.setData(data);
			}
		}
		this.setState({ showGridDivisionPopup: false, pendingGridBounds: null });
	};

	//円開始
	startCircleDrawing = (lngLat) => {
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);
		const center = [lngLat.lng, lngLat.lat];
		this.setState({
			currentShape: {
			center: center,
			radius: 0
			}
		});
		this.shapeDrawing = true;

		const circleFeature = {
			type: 'Feature',
			geometry: {
				type: 'GeometryCollection',
				geometries: [
					{
						type: 'Point',
						coordinates: center
					},
					turf.circle(center, 0, { steps: 32, units: 'meters' }).geometry
				]
			},
			properties: {
				color: this.state.selectedColor,
				width: this.state.lineWidth,
				radius: 0,
				centerPointColor: this.state.selectedColor,
				centerPointRadius: this.state.lineWidth
			}
		};		
		this.startShapeSource(circleFeature);
	};

	//円更新
	updateCircleDrawing = (lngLat) => {
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);
		const { currentShape } = this.state;
		if (currentShape && this.shapeDrawing) {
			const center = turf.point(currentShape.center);
			const edge = turf.point([lngLat.lng, lngLat.lat]);
			const radius = turf.distance(center, edge, { units: 'meters' });

			const circleFeature = {
				type: 'Feature',
				geometry: {
					type: 'GeometryCollection',
					geometries: [
						{
							type: 'Point',
							coordinates: currentShape.center
						},
						turf.circle(currentShape.center, radius, { steps: 32, units: 'meters' }).geometry
					]
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth,
					radius: radius,
					centerPointColor: this.state.selectedColor,
					centerPointRadius: this.state.lineWidth
				}
			};
			this.updateShapeSource(circleFeature);
		}
	};

	//円終了
	finishCircleDrawing = (lngLat) => {
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);
		const { currentShape, map } = this.state;
		if (currentShape && this.shapeDrawing) {
			const center = turf.point(currentShape.center);
			const edge = turf.point([lngLat.lng, lngLat.lat]);
			const radius = turf.distance(center, edge, { units: 'meters' });

			// ドラッグせずタップ/クリックした場合(離した点＝中心 → 半径ほぼ0)は
			// 円を確定・保存せずキャンセルする。仮描画中の末尾 feature を取り除く。
			if (radius < MIN_CIRCLE_RADIUS_M) {
				const source = map.getSource(this.myShape);
				if (source && source._data && Array.isArray(source._data.features)) {
					const geoJSON = source._data;
					geoJSON.features.pop();
					source.setData(geoJSON);
				}
				this.setState({ currentShape: null });
				this.shapeDrawing = false;
				return;
			}

			const area = CommonUtils.calculateCircleArea(radius);

			const circleFeature = {
				type: 'Feature',
				geometry: {
					type: 'GeometryCollection',
					geometries: [
						{
							type: 'Point',
							coordinates: currentShape.center,
						},
						turf.circle(currentShape.center, radius, { steps: 32, units: 'meters' }).geometry
					]
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth,
					radius: radius,
					area:area,
					centerPointColor: this.state.selectedColor,
					centerPointRadius: this.state.lineWidth
				}
			};

			this.updateShapeSource(circleFeature);
			this.setState({ currentShape: null });
			this.shapeDrawing = false;

			// GeoJSONをFirestorageに保存
			let source = map.getSource(this.myShape);
			if (source) {
				this.shapeUpdatetimerId = setTimeout(() => {
					const geoJSON = source._data;
					this.updateDrawingData(3, geoJSON, _shapeTag, center.geometry.coordinates[0], center.geometry.coordinates[1]);
				}, _drawUpdateTimer);
			}
			// タイマー発火で指定位置に移動する
			if (lngLat) {
				this.moveToCoordinateAfterDelay(lngLat);
			}

		}
	};

	//ポリゴン開始
	startPolygonDrawing = (lngLat) => {
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);
		this.setState({ shapePoints: [], currentShape: null });
		const start = [lngLat.lng, lngLat.lat];
		const newPoints = [start];
		this.setState({ shapePoints: newPoints });

		if (newPoints.length > 0) {
			const polygonFeature = {
				type: 'Feature',
				geometry: {
					type: 'Polygon',
					coordinates: [newPoints]
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth
				}
			};
			this.startShapeSource(polygonFeature);
			this.shapeDrawing = true;
		}
	};

	updatePolygonDrawing = (lngLat) => {
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);
		const { shapePoints } = this.state;
		if (shapePoints.length > 0) {
			const updatedPoints = [...shapePoints,[lngLat.lng, lngLat.lat]];
			const polygonFeature = {
				type: 'Feature',
				geometry: {
					type: 'Polygon',
					coordinates: [updatedPoints]
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth
				}
			};
			this.updateShapeSource(polygonFeature);
		}
	};

	//ポリゴン更新
	addPointPolygon = (lngLat) => {
		const { shapePoints,map } = this.state;

		if (shapePoints.length > 0) {
			const updatedPoints = [...shapePoints,[lngLat.lng, lngLat.lat]];
			this.setState({ shapePoints: updatedPoints });
			const polygonFeature = {
				type: 'Feature',
				geometry: {
					type: 'Polygon',
					coordinates: [updatedPoints]
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth
				}
			};
			this.updateShapeSource(polygonFeature);

			// タイマー発火で指定位置に移動する
			if (lngLat) {
				this.moveToCoordinateAfterDelay(lngLat);
			}

		}
	};

	//ポリゴン終了
	finishPolygonDrawing = () => {
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);
		const { shapePoints,map } = this.state;
		if (shapePoints.length > 2) {
			//const closedPoints = [...shapePoints, shapePoints[0]];
			const closedPoints = CommonUtils.removeDuplicateConsecutiveCoordinates([...shapePoints, shapePoints[0]]);

			const totalDistance = CommonUtils.calculateTotalDistance(closedPoints);
			const area = CommonUtils.calculatePolygonArea(closedPoints);
			const center = CommonUtils.calculateCentroid(closedPoints);
			const polygonFeature = {
				type: 'Feature',
				geometry: {
					type: 'Polygon',
					coordinates: [closedPoints]
				},
				geometries: [
					{
						type: 'Point',
						coordinates: center,
					},
				],
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth,
					area: area,
					totalDistance: totalDistance,
				}
			};
			this.updateShapeSource(polygonFeature);
			this.setState({ shapePoints: [], currentShape: null });
			this.shapeDrawing = false;

			// GeoJSONをFirestorageに保存
			let source = map.getSource(this.myShape);
			if (source) {
				this.shapeUpdatetimerId = setTimeout(() => {
					const geoJSON = source._data;
					this.updateDrawingData(3,geoJSON,_shapeTag,shapePoints[0][0],shapePoints[0][1]);
				}, _drawUpdateTimer);
			}

		}
	};

	//図形開始
	startShapeSource = (feature) => {
		const { map } = this.state;
		const source = map.getSource(this.myShape);
		if (source) {
			const geoJSON = source._data;
			geoJSON.features.push(feature);
			source.setData(geoJSON);
		}
	};


	//図形更新
	updateShapeSource = (feature) => {
		const { map } = this.state;
		const source = map.getSource(this.myShape);
		if (source) {
			const geoJSON = source._data;
			if(geoJSON.features.length < 1) {
				geoJSON.features.push(feature);
			}
			else {
				geoJSON.features[geoJSON.features.length - 1] = feature;
			}
			source.setData(geoJSON);
		}
	};

	//----------------------------------------
	//isDrawingMode 1:フリーハンド　2:消しゴム　3:図形

	//描画開始 mousedown touchstart
	startDrawing = (e) => {
		this.cancelCoordinatesTimer();//自動センタリングのタイマーを解除

		const originalEvent = e.originalEvent;

		// 印刷範囲枠の上をクリック/タップした場合は描画ツールを動作させない
		// （印刷ダイアログ表示中の印刷範囲ドラッグと描画ツールの競合を防ぐ）
		if (e.point && this.state.map && this.state.map.getLayer && this.state.map.getLayer('print-area-fill')) {
			try {
				const feats = this.state.map.queryRenderedFeatures(e.point, { layers: ['print-area-fill'] });
				if (feats && feats.length > 0) return;
			} catch (_) {}
		}

		if(this.state.isDrawingMode === 0) {
			this.state.map.touchZoomRotate.enable();
			this.state.map.dragPan.enable();
			this.state.map.doubleClickZoom.enable();
		}

	    // マウスイベントの場合
		if (originalEvent instanceof MouseEvent) {
			// 左ボタンでないばあい
			if (originalEvent.button !== 0) {
				return;
			}
		} 

		if(this.isSpaceKeyPressed) return;

		const { map} = this.state;
		if (!map) return;

		this.latestClickTime = new Date();
		
		if (!this.isAltKeyPressed && (this.state.isDrawingMode === 0)) return;//Alt押しながらで描ける

		if(this.props.fm.auth.currentUser) {//ログインしている
			this.myDrawing = _drawingTag  + '_' + this.props.fm.auth.currentUser.uid;
			this.myShape = _shapeTag  + '_' + this.props.fm.auth.currentUser.uid;
		}
		else return;


		// タッチしている指やペンの数を取得
		let touchCount = 0;
		if (originalEvent.touches) {
			touchCount = originalEvent.touches.length;
		}
//		const testLabel = document.getElementById('testLabel');
//		testLabel.innerText = `Touch count startDrawing: ${touchCount}`;

		//タッチ点が１より大きければズームやパンを有効にする
		if(touchCount > 1) {
			map.touchZoomRotate.enable();
			map.dragPan.enable();
			return;
		}
		else {
			map.touchZoomRotate.disable();
			map.dragPan.disable();
			originalEvent.preventDefault();//イベントを下のビューに伝播させない
			originalEvent.stopPropagation();
		}

		this.changeMarkersPointerEvents(false);//描画中、マーカーを一時的にUI無効にする

		this.addToHistory();
		this.lastUpdate = new Date();

		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);

		if (this.state.isDrawingMode === 3) {//図形
			this.startShape(e);			
			return;
		}

		const newLine = [e.lngLat.toArray()];
		let source = map.getSource(this.myDrawing);

		if(!source || source === undefined) {
			source = this.addDrawingSource(map,this.myDrawing);
			this.addDrawingLayer(map,this.myDrawing);
		}

		const data = source._data;

		if (data && data.features) {
			data.features.push({
				type: 'Feature',
				geometry: {
					type: 'LineString',
					coordinates: newLine
				},
				properties: {
					color: this.state.selectedColor,
					width: this.state.lineWidth,
				}
			});
			source.setData(data);
		}
		this.currentLine = newLine;
		this.setState({ isDrawing: true });
	};

	//描画中 mousemove
	drawLine = (e) => {
		const { map ,isDrawingMode} = this.state;

		const originalEvent = e.originalEvent;

	    // マウスイベントの場合
		if (map && originalEvent instanceof MouseEvent) {
			// なんらかの描画中でボタンが押されていないばあい
			if ((isDrawingMode === 1 || isDrawingMode === 2) && originalEvent.buttons !== 1) {
				this.endDrawing(e);
			}
        
			if((isDrawingMode !== 0)) {
				if(this.isSpaceKeyPressed) {
//				console.log(originalEvent.buttons);
					if(originalEvent.buttons === 0) {
						map.getCanvas().style.cursor = 'grab';
					}
					else if(originalEvent.buttons >= 1  ) {   
						map.getCanvas().style.cursor = 'grabbing';//ここが効いてないっぽい　わからん
					}
				}
				else {
					if(isDrawingMode === 1) map.getCanvas().style.cursor = 'url(/img/pen.png) 0 32, auto';
					else if(isDrawingMode === 2) map.getCanvas().style.cursor = 'url(/img/eraser.png) 0 32, auto';
					else if(isDrawingMode === 3) map.getCanvas().style.cursor = 'crosshair';
				}
			}

			if(this.isAltKeyPressed) {
				map.getCanvas().style.cursor = 'url(/img/pen.png) 0 32, auto';
			}
		}
		
		if(this.isSpaceKeyPressed) return;

		if (!this.state.isDrawing && !this.shapeDrawing) return;

		this.latestClickTime = new Date();
		this.lastUpdate = new Date();

		// タッチしている指やペンの数を取得
		let touchCount = 0;
		if (originalEvent.touches) {
			touchCount = originalEvent.touches.length;
		}

//		const testLabel = document.getElementById('testLabel');
//		testLabel.innerText = `Touch count drawLine: ${touchCount}`;

		if(touchCount > 1) {
			map.touchZoomRotate.enable();
			map.dragPan.enable();
			return;
		}
		else {
			map.touchZoomRotate.disable();
			map.dragPan.disable();
			originalEvent.preventDefault();//イベントを下のビューに伝播させない
			originalEvent.stopPropagation();
		}

		if (isDrawingMode === 3 && this.shapeDrawing) {
			if (this.state.shapeDrawingMode === 'line') {
				this.updateLineDrawing(e.lngLat);
			}
			else if(this.state.currentShape) {
				if (this.state.shapeDrawingMode === 'circle') {
					this.updateCircleDrawing(e.lngLat);
				} else if (this.state.shapeDrawingMode === 'grid') {
					this.updateGridDrawing(e.lngLat);
				}
			}
			else if (this.state.shapeDrawingMode === 'polygon') {
				this.updatePolygonDrawing(e.lngLat);
			}
			else if (this.state.shapeDrawingMode === 'measurement') {
				this.updateMeasurement(e.lngLat);
			}

			return;
		}

		// フリーハンド描画処理
		if (isDrawingMode === 1) {
			// 描画中のラインのみのソースを作成
			if (!map.getSource('currentDrawing')) {
				map.addSource('currentDrawing', {
					type: 'geojson',
					data: {
						type: 'FeatureCollection',
						features: [{
							type: 'Feature',
							geometry: {
								type: 'LineString',
								coordinates: []
							},
							properties: {
								color: this.state.selectedColor,
								width: this.state.lineWidth,
							}
						}]
					}
				});

				map.addLayer({
					id: 'currentDrawing',
					type: 'line',
					source: 'currentDrawing',
					layout: {
						'line-cap': 'round',
						'line-join': 'round'
					},
					paint: {
						'line-color': ['get', 'color'],
						'line-width': ['get', 'width']
					}
				});
			}

			this.currentLine = [...this.currentLine, e.lngLat.toArray()];
			
			// 描画中のラインのみを更新
			const currentDrawingSource = map.getSource('currentDrawing');
			if (currentDrawingSource) {
				currentDrawingSource.setData({
					type: 'FeatureCollection',
					features: [{
						type: 'Feature',
						geometry: {
							type: 'LineString',
							coordinates: this.currentLine
						},
						properties: {
							color: this.state.selectedColor,
							width: this.state.lineWidth,
						}
					}]
				});
			}
			return;
		}


		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);
		if (this.shapeUpdatetimerId) clearTimeout(this.shapeUpdatetimerId);

		//消しゴムモード
		if (isDrawingMode === 2) {
			const source = map.getSource(this.myDrawing);
			if(!source) return;

			const data = source._data;
			const newLine = [...this.currentLine, e.lngLat.toArray()];

			const zoomLevel = map.getZoom();
			const epsilon = 10.25 / 2 ** zoomLevel; //ズームレベルから計算する

			const sourcesToProcess = [this.myDrawing, this.myShape];

			sourcesToProcess.forEach(sourceId => {
			//console.log(sourceId);
				const source = map.getSource(sourceId);
				if (source) {
					const data = source._data;

					if (data && data.features) {
					const erasedDocIds = new Set(this.state.erasedLinesDocIds);
					data.features = data.features.filter(feature => {
						let shouldKeepFeature = true;
						const originalGeometry = JSON.parse(JSON.stringify(feature.geometry));

						if (feature.geometry.type === 'LineString') {
							const lengthA = feature.geometry.coordinates.length;
							feature.geometry.coordinates = feature.geometry.coordinates.filter(coord => {
								return !newLine.some(newCoord => {
									return Math.abs(newCoord[0] - coord[0]) < epsilon && Math.abs(newCoord[1] - coord[1]) < epsilon;
								});
							});
							const lengthB = feature.geometry.coordinates.length;
							shouldKeepFeature = feature.geometry.coordinates.length > 1;

							//ポイント数が減ったら再計算する
							if(shouldKeepFeature && lengthA !== lengthB) {
								if(feature.properties.distance && feature.properties.time) {
									feature.properties.distance = CommonUtils.calculateDistanceWithElevationArray(feature.geometry.coordinates);
									const eleDiff =	CommonUtils.calculateDiffElevationArray(feature.geometry.coordinates);
									const walkSpeed = FirebaseManager.getWalkSpeed(this.props.userSettings.walkingSpeed);
									feature.properties.time = CommonUtils.calcTimeArray(feature.geometry.coordinates,walkSpeed);
									feature.properties.altitudeDifferenceAscent = eleDiff.ascent;
									feature.properties.altitudeDifferenceDescent = eleDiff.descent;

									console.log('LineString: length:' + lengthA + ":" + lengthB + ":" + feature.properties.distance);
								}
							}
							// ゴミデータ削除
							if (feature.properties.distance !== undefined && 
								feature.properties.distance === 0) {
								shouldKeepFeature = false;
							}
						}
						else if (feature.geometry.type === 'Polygon') {
							const lengthA = feature.geometry.coordinates[0].length;
							feature.geometry.coordinates = feature.geometry.coordinates.map(ring => 
								ring.filter(coord => {
									return !newLine.some(newCoord => {
										return Math.abs(newCoord[0] - coord[0]) < epsilon && Math.abs(newCoord[1] - coord[1]) < epsilon;
									});
								})
							);
							const lengthB = feature.geometry.coordinates[0].length;
							shouldKeepFeature = feature.geometry.coordinates[0].length >= 3;

							//ポイント数が減ったら再計算する
							if(shouldKeepFeature && lengthA !== lengthB) {
								if(feature.properties.area && feature.properties.totalDistance) {
									feature.properties.totalDistance = CommonUtils.calculateTotalDistance(feature.geometry.coordinates[0]);
									feature.properties.area = CommonUtils.calculatePolygonArea(feature.geometry.coordinates[0]);
								}
							}
						}
						else if (feature.geometry.type === 'GeometryCollection') {
						// GeometryCollection処理 (円・グリッド等)
						// 点から線分への距離（グリッド線判定用）
						const ptSegDist = (px, py, x1, y1, x2, y2) => {
							const dx = x2 - x1, dy = y2 - y1;
							const lenSq = dx*dx + dy*dy;
							if (lenSq === 0) return Math.sqrt((px-x1)**2 + (py-y1)**2);
							const t = Math.max(0, Math.min(1, ((px-x1)*dx + (py-y1)*dy) / lenSq));
							return Math.sqrt((px-(x1+t*dx))**2 + (py-(y1+t*dy))**2);
						};
							feature.geometry.geometries = feature.geometry.geometries.map(geom => {
								if (geom.type === 'Point') {
								// 中心点が消しゴムの範囲内にある場合、円全体を削除
								if (newLine.some(newCoord => {
									return Math.abs(newCoord[0] - geom.coordinates[0]) < epsilon && 
											Math.abs(newCoord[1] - geom.coordinates[1]) < epsilon;
									})) {
										shouldKeepFeature = false;
									}
								} else if (geom.type === 'LineString') {
									// グリッド線：消しゴムがセグメントに触れたら feature 全体を削除
									const coords = geom.coordinates;
									for (let ci = 0; ci < coords.length - 1 && shouldKeepFeature; ci++) {
										const [x1, y1] = coords[ci], [x2, y2] = coords[ci + 1];
										if (newLine.some(([px, py]) => ptSegDist(px, py, x1, y1, x2, y2) < epsilon)) {
											shouldKeepFeature = false;
										}
									}
								} else if (geom.type === 'Polygon') {
									// 円周の座標を処理
									const lengthA = geom.coordinates[0].length;
									geom.coordinates = geom.coordinates.map(ring => 
										ring.filter(coord => {
											return !newLine.some(newCoord => {
												return Math.abs(newCoord[0] - coord[0]) < epsilon && 
													Math.abs(newCoord[1] - coord[1]) < epsilon;
											});
										})
									);
									const lengthB = geom.coordinates[0].length;
									if (geom.coordinates[0].length <= 3) {
										shouldKeepFeature = false;
									}
									console.log('GeometryCollection: length:' + lengthA + ":" + lengthB);
									//ポイント数が減ったら再計算する
									if(shouldKeepFeature && lengthA !== lengthB) {
										if(feature.properties.area && feature.properties.radius) {
											feature.properties.area = CommonUtils.calculatePolygonArea(geom.coordinates[0]);
										}
									}
								}
								return geom;
							});
						}
						else if (feature.geometry.type === 'Point' && (feature.properties.gridLabel || feature.properties.gridCellLabel)) {
							const [px, py] = feature.geometry.coordinates;
							if (newLine.some(([nx, ny]) => Math.abs(nx - px) < epsilon && Math.abs(ny - py) < epsilon)) {
								shouldKeepFeature = false;
							}
						}

						if (JSON.stringify(originalGeometry) !== JSON.stringify(feature.geometry)) {
							erasedDocIds.add(data.id);
						}

						return shouldKeepFeature;
					});

					this.setState({ erasedLinesDocIds: erasedDocIds });
					source.setData(data);
					}
				}
			});
		}


	};

	//描画終了 mouseup
	endDrawing = (e) => {
		const {map,isDrawingMode} = this.state;

		if((!this.state.isDrawing && !this.shapeDrawing) || this.isSpaceKeyPressed) {
			map.dragPan.enable();
			return;
		}
		this.latestClickTime = new Date();
		this.lastUpdate = new Date();

		//イベントを下のビューに伝播させない
		const originalEvent = e.originalEvent;
		// タッチしている指やペンの数を取得
		let touchCount = 0;
		if (originalEvent.touches) {
			touchCount = originalEvent.touches.length;
		}

		if(touchCount > 1 || (isDrawingMode === 1 && this.currentLine.length < 3)) {
			map.touchZoomRotate.enable();
			map.dragPan.enable();
			this.currentLine = [];
			return;
		}
		else {
			map.touchZoomRotate.disable();
			map.dragPan.disable();
			originalEvent.preventDefault();
			originalEvent.stopPropagation();
		}

		//図形の場合はendShape
		if (isDrawingMode === 3 && this.shapeDrawing) {//図形
			this.endShape(e);
			return;
		}

		// GeoJSONをFirestorageに保存
		let source = map.getSource(this.myShape);
		if (source) {
			this.shapeUpdatetimerId = setTimeout(() => {
				const geoJSON = source._data;
				this.updateDrawingData(3,geoJSON,_shapeTag,e.lngLat.lng,e.lngLat.lat);
			}, _drawUpdateTimer);
		}
		this.props.fm.checkAndSaveCurrentPosition(this.props.owneruid,this.props.uuid,this.state.map,this.currentProject);
			
		this.endDrawingFunc(e.lngLat);

		// タイマー発火で指定位置に移動する
		if (e.lngLat) {
			this.moveToCoordinateAfterDelay(e.lngLat);
		}
	};


	// タイマーIDを保持する変数を追加
	showCoordinatesTimerId = null;

	// タイマー発火で指定位置に移動する
	moveToCoordinateAfterDelay = (lngLat, delay = 1000) => {//500ミリ秒から1秒に変更
		// 既存のタイマーがあれば中止
		this.cancelCoordinatesTimer();
		
		const { map } = this.state;
		if (!map || !lngLat) return;
		
		// 外側12%にない場合はタイマーを設定しない
		if (!this.isCoordinateOutsideViewport(lngLat, 0.12)) {
			return;
		}

		const centerLngLat = map.getCenter();

		// 新しいタイマーを設定
		this.showCoordinatesTimerId = setTimeout(() => {
			map.flyTo({
//				center: [lngLat.lng, lngLat.lat],
//				center: [(lngLat.lng + centerLngLat.lng) / 2, (lngLat.lat + centerLngLat.lat) / 2],
				center: [centerLngLat.lng + ((lngLat.lng  - centerLngLat.lng) / 1.5), centerLngLat.lat + ((lngLat.lat - centerLngLat.lat)) / 1.5],
				zoom: map.getZoom(),  // 現在のズームレベルを維持
				speed: 1.5,           // アニメーションの速度
				curve: 1,             // アニメーションのイージング（1はリニア）
				essential: true       // この移動はユーザー操作に不可欠（true）
			});
			
			if(this.state.showShapeOperationPanel) {
				let center = {
					lng: (lngLat.lng + centerLngLat.lng) / 2,
					lat: (lngLat.lat + centerLngLat.lat) / 2
				};
				const centerPixel = map.project(center);
				this.setState({
					showShapeOperationPanel: true,
					operationPanelPosition: { x: centerPixel.x, y: centerPixel.y }
				});
			}

			// 座標情報を一時的に表示
/*			const t = (key) => translator.t(key);
			const coordinateMessage = `${t('Coordinates')}: ${lngLat.lng.toFixed(6)}, ${lngLat.lat.toFixed(6)}`;
			toast.info(coordinateMessage, {
				position: "top-center",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});*/
		}, delay);
	};

	// タイマーを中止する関数
	cancelCoordinatesTimer = () => {
		if (this.showCoordinatesTimerId) {
			clearTimeout(this.showCoordinatesTimerId);
			this.showCoordinatesTimerId = null;
		}
	};

	// 座標が画面の外側の指定割合範囲内にあるかをチェックするヘルパー関数
	isCoordinateOutsideViewport = (lngLat, marginRatio = 0.2) => {
		const { map } = this.state;
		if (!map || !lngLat) return false;
		
		// 座標をスクリーン座標に変換
		const point = map.project([lngLat.lng, lngLat.lat]);
		
		// マップコンテナのサイズを取得
		let width, height;
		try {
			const container = map.getContainer();
			if (container) {
				const rect = container.getBoundingClientRect();
				width = rect.width;
				height = rect.height;
			}
		} catch (error) {
			console.warn('コンテナサイズ取得エラー:', error);
		}

		// サイズが有効な場合はこれを使用
		if (width <= 0 || height <= 0) {
			return true;
		}

		// 外側マージンの範囲を計算
		const marginX = width * marginRatio;
		const marginY = height * marginRatio;
		
		// 内側の有効範囲（外側20%を除いた80%の範囲）
		const innerLeft = marginX;
		const innerRight = width - marginX;
		const innerTop = marginY;
		const innerBottom = height - marginY;
		
		// 座標が内側範囲外（つまり外側20%の範囲内）にあるかチェック
		const isOutside = (
			point.x < innerLeft ||
			point.x > innerRight ||
			point.y < innerTop ||
			point.y > innerBottom
		);
		
		return isOutside;
	};

	saveGeoJSONToFirestorage = async (header,geoJSON) => {
		const fileName = `${header}_${this.props.fm.auth.currentUser.uid}.geojson`;
		const filePath = `files/${this.props.owneruid}/${this.props.uuid}/${this.props.fm.auth.currentUser.uid}/open/${fileName}`;
		const fileBlob = new Blob([JSON.stringify(geoJSON)], { type: 'application/json' });
		const fileUrl = await this.props.fm.uploadFile(filePath, fileBlob);
		return fileUrl;
	}
	getGeoJson(typeNumber,uid) {
		const { map} = this.state;
		let type = 'drawing_';
		if(typeNumber === 3) type = 'shape_';
		const source = map.getSource(type + uid);
		if(!source) return null;

		return source._data;
	}

	// ダウンロード用の手書き/図形 GeoJSON を返す。地図上のソースを優先し（未保存の編集も含む最新）、
	// まだ読み込まれていない・空のときは Storage の geojsonUrl から直接取得する。
	// 以前は地図上のソースだけを見ていたため、読み込み前（モバイル回線・タブ再読み込み直後など）に
	// ZIP を作ると手書きが黙って抜けていた。取得できなければ null。
	getGeoJsonForDownload = async (data) => {
		const onMap = this.getGeoJson(data.type, data.owneruid);
		if (onMap && typeof onMap === 'object' && Array.isArray(onMap.features) && onMap.features.length > 0) return onMap;
		if (!data.geojsonUrl) return onMap || null;
		try {
			// ユーザー操作のダウンロードなので、表示用の読み込みより長めに待つ
			const response = await fetchWithTimeout(data.geojsonUrl, 20000, { cache: 'no-cache' });
			if (!response.ok) throw new Error(`geojson fetch failed: ${response.status}`);
			const geoJSON = await response.json();
			return data.type === 2 ? CommonUtils.cleanupDuplicateLineStrings(geoJSON) : geoJSON;
		} catch (e) {
			console.error('[download] geojson fetch failed:', data.type, data.owneruid, e);
			DiagLog.add(`[download] geojson fetch failed type=${data.type} ${(e && e.code) || (e && e.message) || e}`);
			return onMap || null;
		}
	}


	endDrawingFunc = (lngLat = null) => {
		if (this.drawUpdatetimerId) clearTimeout(this.drawUpdatetimerId);

		const { map,erasedLinesDocIds,isDrawingMode} = this.state;
		map.dragPan.enable();
		
		this.setState({ isDrawing: false });
		this.changeMarkersPointerEvents(true);

		const source = map.getSource(this.myDrawing); //myDrawing:"drawing_uid"
		if(!source) return;

		const geoJSON = source._data;
		let newLine;
		if(lngLat)
			newLine = [...this.currentLine, lngLat.toArray()];
		else 
			newLine = [...this.currentLine];

		if (isDrawingMode === 2) {//消しゴムモード
			erasedLinesDocIds.forEach(docId => {
				if (docId && docId !== undefined) {
					this.drawUpdatetimerId = setTimeout(() => {
						this.updateDrawingData(2,geoJSON,_drawingTag,newLine[0][0],newLine[0][1]);
					}, _drawUpdateTimer);
				}
			});
            this.setState({ erasedLinesDocIds: new Set() });
			// GeoJSONをFirestorageに保存
			this.drawUpdatetimerId = setTimeout(() => {
				this.updateDrawingData(2,geoJSON,_drawingTag,newLine[0][0],newLine[0][1]);
			}, _drawUpdateTimer);

			return;
		}
		else {
			// 新しい線を追加
			// 描画中のラインを本体のソースに追加
			const mainSource = map.getSource(this.myDrawing);
			if (!mainSource) return;

			const data = mainSource._data;

			// 点の数を間引く
			newLine = CommonUtils.dynamicPointReduction(newLine, {
				n: 5,    // 直線部分は最大1/10まで間引く
				minReduction: 2,     // カーブ部分は最小1/3まで間引く
				curvatureThreshold: 0.1,  // 曲率の閾値
				smoothingFactor: 0.3     // スムージングの強さ
			});

			// 描画中のラインのデータのみをクリア
			const currentDrawingSource = map.getSource('currentDrawing');
			if (currentDrawingSource) {
				currentDrawingSource.setData({
					type: 'FeatureCollection',
					features: []
				});
			}

			if (newLine.length > 1) {
				const feature = {
					type: 'Feature',
					geometry: {
						type: 'LineString',
						coordinates: newLine
					},
					properties: {
						color: this.state.selectedColor,
						width: this.state.lineWidth,
					}
				};

//				if(!data.features) data.features = [];//解決にはなってない
				data.features.push(feature);
				mainSource.setData(data);

				// GeoJSONの保存を遅延実行
				this.drawUpdatetimerId = setTimeout(() => {
					this.updateDrawingData(2, data, _drawingTag, newLine[0][0], newLine[0][1]);
				}, _drawUpdateTimer);
			}
		}

		this.currentLine = [];
	}

	//描画データのアップデート
	updateDrawingData = async (type,geoJSON,header,lng,lat) => {
		// 図形(type 3)保存時、半径0の退化円が混ざっていれば除去する保険
		if (type === 3) {
			geoJSON = CommonUtils.stripZeroRadiusCircles(geoJSON, MIN_CIRCLE_RADIUS_M);
		}
		const fileUrl = await this.saveGeoJSONToFirestorage(header,geoJSON);
		console.log('fileUrl:' + fileUrl);

		// Firestoreにインデックスを保存
		const collectionPath = `userdata/${this.props.owneruid}/projects/${this.props.uuid}/items`;
		const documentId = header + '_' + this.props.fm.auth.currentUser.uid;
		const lineData = {
			type: type,
			owneruid: this.props.fm.auth.currentUser.uid,
			instanceid: this.instanceID,
			ownername: this.props.myName,
			ownercolor: this.props.myColor,
			lng: lng,
			lat: lat,
			geojsonUrl: fileUrl,
			createtime: new Date(),
			updatetime: new Date(),
			creater:'collaboMap',
			title:this.currentProject.title,
		};

		try {
			await this.props.fm.setDocument(collectionPath, documentId, lineData);
			this.updateProjectCoordinate();

			console.log('GeoJSON and index successfully saved to Firebase!');
		} catch (error) {
			console.error('Failed to save GeoJSON and index to Firebase:', error);
		}
	}

	//描画中、マーカーを一時的にUI無効にする
	changeMarkersPointerEvents(enable) {
		this.markers.forEach(markerObj => {
			const markerElement = markerObj.marker.marker.getElement();
			markerElement.style.pointerEvents = enable ? 'auto' : 'none';
			const popup = markerObj.marker.marker.getPopup();
			if (popup) {
				const popupElement = popup._content;
				if (popupElement) {
					popupElement.style.pointerEvents = enable ? 'auto' : 'none';
				}
			}
		});
	}

	handleCompassButton = () => {
		const { map } = this.state;
		if (!map) return;

		map.resetNorth();
		map.setPitch(0);
	};

	updateUI= () => {
		if(this.currentProject) {
			this.updateSignedIn(this.currentProject);
		}
	}

	//--------プロジェクト設定を読む
	setProjectListener(map) {
		// ドキュメントリスナーの設定
		const docPath = `userdata/${this.props.owneruid}/projects/${this.props.uuid}`;
		if (this.unsubscribeDocListener) {
			this.unsubscribeDocListener();
			this.unsubscribeDocListener = null;
		}
		DiagLog.add(`[project] subscribe ${docPath}`);
		this.unsubscribeDocListener = this.props.fm.subscribeToDocument(docPath, (doc) => {
			this.docListenerRetryCount = 0;
			const isFromCache = doc.metadata ? doc.metadata.fromCache : true;
			if (!isFromCache) this.firestoreServerSeen = true;//サーバまで到達できたことの証跡
			DiagLog.add(`[project] snapshot exists=${doc.exists()} fromCache=${isFromCache}`);
			if (doc.exists()) {
				const currentProject = doc.data();

				this.currentProject = currentProject;
				this.props.updateProjectInfo(currentProject);
				this.updateSignedIn(this.currentProject);

				// 索引読み込みの判断用。キャッシュ由来の snapshot は索引情報を持つときだけ採用する
				// （古い「索引なし」を信じて全件読みに行かないため）
				if (this.resolveProjectDoc && (!isFromCache || currentProject.itemsIndex)) {
					this.resolveProjectDoc(currentProject);
					this.resolveProjectDoc = null;
				}

				// MGRS/UTM グリッド設定の復元（プロジェクトに保存があれば優先）
				if (currentProject.gridOverlay) {
					CommonUtils.setGridOverlay(currentProject.gridOverlay);
					this.updateMgrsUtmGrid();
				}

				if (currentProject.exaggeration !== undefined) {
					setTimeout(() => {
						this.createTerrainControl(currentProject.exaggeration);
						this.setState({ exaggeration: currentProject.exaggeration });
					}, 500);
				}
				else {
					setTimeout(() => {
						currentProject.exaggeration = 1;
						this.createTerrainControl(currentProject.exaggeration);				
						this.setState({ exaggeration: currentProject.exaggeration });
					}, 500);
					currentProject.exaggeration = 1;
				}

				currentProject.title = doc.data().title ? doc.data().title : "no title";
				currentProject.ownername = doc.data().ownername ? doc.data().ownername : "no name";
				
				console.log('unsubscribeDocListener:' + currentProject.title);
				this.setState({
					projectTitle: currentProject.title,
					ownerName: currentProject.title.ownername,
				});
				this.thumbnailUrl = currentProject.thumbnailUrl;
				
				//閲覧履歴更新
				if(this.props.fm && this.props.fm.auth && this.props.fm.auth.currentUser) {
					if(this.props.fm.auth.currentUser.uid !== currentProject.owneruid) {//自分の地図ではない場合
						const myCollectionPath = `userdata/${this.props.fm.auth.currentUser.uid}/projects/`;

						let data = null;
						data = {
							title:currentProject.title,
							memo:currentProject.memo,
							tags: currentProject.tags,
							ownername: currentProject.ownername,
							ownercolor: currentProject.ownercolor,
							owneruid: currentProject.owneruid,
							instanceid: this.instanceID,
							basemap: currentProject.basemap,
							exaggeration:currentProject.exaggeration,
							permission: currentProject.permission,
							// 履歴コピーは閲覧時点のオリジナル設定のスナップショットとして保持する。
							// (以前は false 固定だったが、検索フィルタや「一般公開」バッジ表示で実値が必要)
							issearchable: !!currentProject.issearchable,
							iscopyable: !!currentProject.iscopyable,
							createtime:  currentProject.createtime,
							updatetime: new Date(),
						};

						// 履歴コピーの read は最初の snapshot だけ行い（getDocument 1回で存在確認も兼ねる）、
						// 以降はその結果を使い回す。オーナーの編集や索引書き込みで snapshot が飛ぶたびに
						// 2 read 消費していたのを止める。内容が変わらなければ write も省略する。
						const hc = this.historyCopyState;
						const { updatetime: _ignoredUpdatetime, ...payloadForCompare } = data;
						const payload = JSON.stringify(payloadForCompare);
						const writeCopy = () => {
							if (hc.lastPayload === payload) return;
							hc.lastPayload = payload;
							const p = hc.exists
								? this.props.fm.updateDocument(myCollectionPath, this.props.uuid, data)
								: this.props.fm.setDocument(myCollectionPath, this.props.uuid, data);
							Promise.resolve(p)
								.then(() => { hc.exists = true; })
								.catch(error => {
									hc.lastPayload = '';//次の snapshot で書き直す
									console.error('Failed to write history copy:', error);
								});
						};
						if (hc.known) {
							writeCopy();
						}
						else {
							this.props.fm.getDocument(myCollectionPath, this.props.uuid)
							.then(myData => {
								hc.known = true;
								hc.exists = true;
								this.setState({ isfavorite: !!(myData && myData.isfavorite) });
								writeCopy();
							})
							.catch(error => {
								if (error && error.message === 'No such document!') {
									hc.known = true;
									hc.exists = false;
									this.setState({ isfavorite: false });
									writeCopy();
								}
								else {
									console.error('Failed to getDocument:', error);
								}
							});
						}
					}
					else {
						if(currentProject.isfavorite) {
							this.setState({isfavorite:true});
						}
						else {
							this.setState({isfavorite:false});
						}
					}
				}


				if(map && (this.currentMap !== doc.data().basemap || this.currentOverlay !== doc.data().overlay)) {
					this.currentMap = doc.data().basemap;
					this.currentOverlay = doc.data().overlay;
					if (map.getSource('terrain')) map.removeSource('terrain');

					if (doc.data().customLayers) {
						if (doc.data().customLayers.overlays) {
							Object.keys(doc.data().customLayers.overlays).forEach(key => {
								if (this.customOverlays[key]) {
									this.customOverlays[key] = {
										...this.customOverlays[key],
										...doc.data().customLayers.overlays[key]
									};
								}
							});
						}
						if (doc.data().customLayers.maps) {
							Object.keys(doc.data().customLayers.maps).forEach(key => {
								if (this.customMaps[key]) {
									this.customMaps[key] = {
										...this.customMaps[key],
										...doc.data().customLayers.maps[key]
									};
								}
							});
						}
					}

					// 組み込みオーバーレイ (CommonUtils.overlays) の保存値は読み込まない。
					// 過去バージョンで保存された name/url/mz が現コードと食い違うと
					// 特殊プロトコル判定がマッチせず、生の標高タイルがそのまま表示される
					// 等のバグに繋がる。組み込みは常にコード定義を真とする。
					// （カスタムオーバーレイの保存値は customLayers.overlays 経由で別途復元される）

					//データに不備がある場合
					if (typeof this.currentMap  !== 'string') {
						console.log('doc.data().language:' + doc.data().language);
						if(!doc.data().language || doc.data().language === undefined || doc.data().language === 'ja') {
							this.currentOverlay = 'slopemap';
							this.currentMap = 'pale';
						}
						else {
							this.currentOverlay = 'null';
							this.currentMap = 'osm';
						}
						//不備を修正
						if(this.props.fm && this.props.fm.auth.currentUser && this.props.fm.auth.currentUser.uid === this.props.owneruid) {
							this.props.fm.updateLayerSetting(this.props.owneruid,this.props.uuid,this.currentOverlay,this.currentMap);
						}

					}
					//標高データ 地理院データかS3データか選ぶ。条件を変更した。日本語→地図の種類
					if(this.currentMap !== "otm" && this.currentMap !== "osm") {
//					if(!doc.data().language || doc.data().language === undefined || doc.data().language === 'ja') {
						map.addSource('terrain',this.gsiTerrainSourceKokudo);
					}
					else {
						map.addSource('terrain',this.gsiTerrainSourceS3);
					}
//					this.removeSourceAndLayer(map,'overlay_docomo');
//					this.addSourceAndLayer(map,'overlay_docomo','raster',this.tileUrlDocomo,256,3,15,0.3,'');

//					this.removeSourceAndLayer(map,'overlay_rakuten');
//					this.addSourceAndLayer(map,'overlay_rakuten','raster',this.tileUrlRakuten,256,3,15,0.3,'');

					this.setupOverlay(map,this.currentOverlay);
					this.setupBaseMap(map,this.currentMap);
					const urlParams = new URLSearchParams(window.location.search);
					setTimeout(() => {
						const is3D = urlParams.get('is3D') === 'true';
						if(is3D) {
							const { map, exaggeration } = this.state;
							map.setTerrain({ source: 'terrain', exaggeration: exaggeration });
							this.customScale.setVisibility(false);
						}
						this.setState({ is3DEnabled: is3D });
					}, 500);

					const searchkey = urlParams.get('searchkey');
					if (searchkey && searchkey.trim() !== '') {
						// まず検索ポップアップを表示して、キーワードをセット
						this.setState({ 
							showSearchPopup: true,
							searchKeyword: searchkey 
						}, () => {
							// ポップアップが表示された後で検索を実行
							setTimeout(() => {
							this.triggerSearch(searchkey);
							}, 100); // 少し遅延させてUIが更新されてから検索を実行
						});
					}
				}
				
			} else {
				console.log("No such document!");
			}
		}, (error) => {
			// エラーコールバックが無いと、ストリームが死んでも無言のまま復帰しない。
			// このリスナーが止まると背景地図(basemap設定)も出なくなるので再購読する。
			console.error('[project] listener error:', error && error.code, error);
			if (error && error.code === 'permission-denied') return;//閲覧権限が無い場合は再購読しない
			if (this.docListenerRetryCount >= LISTENER_RETRY_DELAYS.length) return;
			const delay = LISTENER_RETRY_DELAYS[this.docListenerRetryCount++];
			if (this.docListenerRetryTimer) clearTimeout(this.docListenerRetryTimer);
			this.docListenerRetryTimer = setTimeout(() => this.setProjectListener(map), delay);
		});
	}

// MapManager.jsクラス内に以下のメソッドを追加
	triggerSearch = (keyword) => {
		// 少し遅延させて、UIが確実に更新されてから検索フォームを操作
		setTimeout(() => {
			// 検索フォームに擬似的なEnterキー入力イベントを送信
			const searchInput = document.querySelector('.search-box input[type="search"]');
			if (searchInput) {
			// 検索入力欄の値を確実に設定（Reactの仮想DOMと実際のDOMを同期させるため）
			const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
				window.HTMLInputElement.prototype, 'value'
			).set;
			nativeInputValueSetter.call(searchInput, keyword);
			
			// 入力イベントを発火させて変更を検知させる
			const inputEvent = new Event('input', { bubbles: true });
			searchInput.dispatchEvent(inputEvent);
			
			// Enterキープレスイベントをシミュレート
			const enterEvent = new KeyboardEvent('keypress', {
				key: 'Enter',
				code: 'Enter',
				keyCode: 13,
				which: 13,
				bubbles: true
			});
			searchInput.dispatchEvent(enterEvent);
			}
			// searchkeyパラメータを削除
			const url = new URL(window.location);
			url.searchParams.delete('searchkey');
			window.history.replaceState({}, '', url);
		}, 300); // 300ms待機して確実にUIが更新されてから実行
	};

	setupOverlay(map,label) {
		let layerSetting = CommonUtils.overlays[label];
		if(layerSetting === undefined) layerSetting = this.customOverlays[label];
		if(layerSetting === undefined) return;

		let url = layerSetting.url;
		if(layerSetting.proxy) {
			url = `https://asia-northeast1-collabomap-1bcb9.cloudfunctions.net/proxyTile?baseUrl=${encodeURIComponent(layerSetting.url)}&z={z}&x={x}&y={y}`
		}

		this.removeSourceAndLayer(map,'overlay');
		if(label && label !== 'null') {
			// 乗算合成モード: ベース地図タイルとオーバーレイタイルをタイル単位で
			// Canvas 2D で multiply 合成する multiply:// プロトコルでラップする。
			// オーバーレイがカスタムプロトコル処理を必要とする場合は、内側 URL に該当スキームを
			// 付与して multiply ハンドラ側でハンドラ経由取得するよう委ねる。
			let useMultiply = (CommonUtils.overlayBlendMode === 'multiply');
			let baseSetting = null;
			if (useMultiply) {
				baseSetting = (CommonUtils.maps && CommonUtils.maps[this.currentMap])
					|| (this.customMaps && this.customMaps[this.currentMap]);
				if (!baseSetting || !baseSetting.url) useMultiply = false;
			}
			if (useMultiply) {
				let baseUrl = baseSetting.url;
				if (baseSetting.proxy) {
					baseUrl = `https://asia-northeast1-collabomap-1bcb9.cloudfunctions.net/proxyTile?baseUrl=${encodeURIComponent(baseSetting.url)}&z={z}&x={x}&y={y}`;
				}
				const overlayMz = layerSetting.mz != null ? layerSetting.mz : 18;
				const innerOverlayUrl = this.transformOverlayUrlForCustomProtocol(url, layerSetting);
				url = `multiply://blend/{z}/{x}/{y}.png?overlay=${encodeURIComponent(innerOverlayUrl)}&base=${encodeURIComponent(baseUrl)}&overlayMz=${overlayMz}`;
				// ベース地図の解像度・最大ズームに合わせる:
				//  - tileSize: ベースのものを使い、合成キャンバスもベース解像度で生成
				//  - maxzoom: ベースの maxzoom まで multiply タイルを生成（オーバーレイは内部でオーバーゾーム）
				//  - minzoom: オーバーレイの minzoom 未満では multiply タイルは要求せず、ベース単独表示
				const ts = baseSetting.ts || layerSetting.ts;
				const minz = Math.max(layerSetting.minz || 0, baseSetting.minz || 0);
				const mz = baseSetting.mz != null ? baseSetting.mz : (layerSetting.mz || 18);
				this.addSourceAndLayerBottom(map,layerSetting.name,'overlay','raster',url,ts,minz,mz,layerSetting.op/100,layerSetting.cp || '',layerSetting.bp,layerSetting.cc);
			} else {
				this.addSourceAndLayerBottom(map,layerSetting.name,'overlay','raster',url,layerSetting.ts,layerSetting.minz,layerSetting.mz,layerSetting.op/100,layerSetting.cp || '',layerSetting.bp,layerSetting.cc);
			}
		}
	}

	// addSourceAndLayerBottom と同じ判定で、オーバーレイ URL に対応するカスタムスキームを付与する。
	// multiply 合成時、内側オーバーレイ URL に使うことで、multiply ハンドラがカスタムプロトコル
	// 経由（WebGL 等の前処理込み）で処理済み画像を取得できるようになる。
	transformOverlayUrlForCustomProtocol(url, layerSetting) {
		const name = layerSetting.name;
		const bp = layerSetting.bp;
		const cc = layerSetting.cc;
		if (bp === 1 || cc === 1) {
			return url.replace('https://', 'customtile://') + '&bp=' + bp + '&cc=' + cc;
		}
		if (name === '色別傾斜区分図')   return url.replace('https://', 'slopemap_b://');
		if (name === '高低傾斜強調図')   return url.replace('https://', 'slopemap_c://');
		if (name === '雪崩傾斜タイプB') return url.replace('https://', 'slopezone1map_b://');
		if (typeof name === 'string' && name.startsWith('高精細傾斜量図')) {
			return url.replace('https://', 'keisyaka://');
		}
		if ((typeof name === 'string' && name.startsWith('赤色立体地図_高精細')) || cc === 2) {
			return url.replace('https://', 'sekisyoku://');
		}
		return url;
	}

	setupBaseMap(map,label) {
		let layerSetting = CommonUtils.maps[label];
		if(layerSetting === undefined) layerSetting = this.customMaps[label];
		if(layerSetting === undefined) return;

		let url = layerSetting.url;
		if(layerSetting.proxy) {
			url = `https://asia-northeast1-collabomap-1bcb9.cloudfunctions.net/proxyTile?baseUrl=${encodeURIComponent(layerSetting.url)}&z={z}&x={x}&y={y}`
		}

		this.removeSourceAndLayer(map,'baseMap');
		if(label && label !== 'null') {
			this.addSourceAndLayerBottom(map,layerSetting.name,'baseMap','raster',url,layerSetting.ts,layerSetting.minz,layerSetting.mz,layerSetting.op/100,layerSetting.cp || '',layerSetting.bp,layerSetting.cc);
		}
	}


	updateSignedIn(data) {
		/*if(data == null) {
			data = this.state.currentProjectData;
		}
		else {
			this.setState({currentProjectData:data});
		}*/

		if(this.props.isSignedIn && data) {
			if(!this.props.fm.auth.currentUser) {
				this.setState({'permission':0});
			}
			else {//ログインしている
				if(data.owneruid === this.props.fm.auth.currentUser.uid) {
					this.setState({'permission':2});
					this.myDrawing = _drawingTag  + '_' + this.props.fm.auth.currentUser.uid;
					this.myShape = _shapeTag  + '_' + this.props.fm.auth.currentUser.uid;
				}
				else if(data.permission === 0) {
					this.setState({'permission':0});
				}
				else if(data.permission === 1) {
					this.setState({'permission':1});
				}
				else if(data.permission === 2) {
					this.setState({'permission':2});
				}
			}
		}
		else {
			this.setState({'permission':0});
		}
	}

	//--------------------地図初期化
	initializeMap() {
		if (this.state.map) {
			DiagLog.add('[map] initializeMap skipped (map already exists)');
			return;
		}
		if(this.isInitializeMap) {
			DiagLog.add('[map] initializeMap skipped (already initializing)');
			return;
		}
		DiagLog.add(`[map] initializeMap start uuid=${this.props.uuid} owneruid=${this.props.owneruid}`);
		let gsiTerrainSource = this.gsiTerrainSourceS3;
		if(this.state.isjapan) gsiTerrainSource = this.gsiTerrainSourceKokudo;
		else gsiTerrainSource = this.gsiTerrainSourceS3;

		this.isInitializeMap = true;
		const styleNull = {
			version: 8,
			sources: {
			},
			layers: [
			],
			// 「～」等の全角記号を含む日本語グリフが必要なため GSI の Noto フォントを使用
			// （かな・漢字は localIdeographFontFamily でローカル描画されるが、
			//   全角記号・英数字はグリフサーバーから取得される）
			glyphs: "https://maps.gsi.go.jp/xyz/noto-jp/{fontstack}/{range}.pbf",
			sky: this.skyLayer,
		};

		const timer = setTimeout(() => {
			const map = new maplibregl.Map({
				maxZoom: 22,
				container: this.mapContainerRef.current,
				style: styleNull,
				maxPitch: 85,
				hash: true,
				center: [137.969392, 36.238642],
				zoom: 8,
			});

			// 読み込みがどこで止まったか特定できるよう、地図の状態を記録する
			DiagLog.add('[map] maplibre map created');
			map.on('error', (e) => DiagLog.add(`[map] map error: ${(e && e.error && e.error.message) || 'unknown'}`));
			map.once('styledata', () => DiagLog.add('[map] styledata'));
			map.once('idle', () => DiagLog.add('[map] idle'));
			// データ読み込みは map の load イベントからしか始まらないので、
			// load が来ないまま止まっているケースをログに残す
			this.mapLoadWatchdog = setTimeout(() => {
				if (!this.map) {
					DiagLog.add(`[map] WARNING: load not fired after 10s (styleLoaded=${map.isStyleLoaded()} loaded=${map.loaded()})`);
				}
			}, 10000);

			// カスタムタイルの色と座標変換が必要なもの用のカスタムプロトコルを追加
			registerCustomProtocol('customtile', (params) => {
				const url = params.url.replace('customtile://', 'https://');

				const urlObj = new URL(url);
				const basePosType = urlObj.searchParams.get('bp');
				const colorConversion = urlObj.searchParams.get('cc');

				// URLからz, x, yを抽出する関数
				const extractZXY = (url) => {
					// パターン1: /z/x/y.png 形式
					const patternMatch = url.match(/\/(\d+)\/(\d+)\/(\d+)/);
					if (patternMatch) {
						return patternMatch.slice(1, 4).map(Number);
					}
					
					const z = urlObj.searchParams.get('z');
					const x = urlObj.searchParams.get('x');
					const y = urlObj.searchParams.get('y');
					
					if (z && x && y) {
						return [z, x, y].map(Number);
					}
					
					throw new Error('Invalid tile URL format: ' + url);
				};
				let [zoom, x, origY] = extractZXY(url);
	//			console.log(`zoom:${zoom} x:${x} y:${origY}`);
				// basePosTypeが1の場合、y座標を変換
				let y = origY;
				if (basePosType) {
					const ymax = 1 << (zoom-1);
					y = ymax - origY - 1;
				}
				console.log(`a zoom:${zoom} x:${x} origY:${origY} y:${y} basePosType:${basePosType} colorConversion:${colorConversion}`);

				
				// 変換後のy座標でURLを再構築
				const convertedUrl = url.replace(`/${origY}`, `/${y}`);


				return fetch(convertedUrl)
					.then(response => response.blob())
					.then(blob => createImageBitmap(blob))
					.then(imageBitmap => {
						const canvas = document.createElement('canvas');
						canvas.width = imageBitmap.width;
						canvas.height = imageBitmap.height;
						const context = canvas.getContext('2d');
						context.drawImage(imageBitmap, 0, 0);

						const urlObj = new URL(convertedUrl);
						const colorConversion = urlObj.searchParams.get('cc');

						const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
						if(colorConversion) {
							const data = imageData.data;

							for (let i = 0; i < data.length; i += 4) {
								if (data[i] === 255 && data[i+1] === 255 && data[i+2] === 255) {
									data[i] = 255;   // 赤
									data[i+1] = 0;   // 緑
									data[i+2] = 0;   // 青
								}
							}
						}
						context.putImageData(imageData, 0, 0);

						return createImageBitmap(canvas);
					})
					.then(processedImageBitmap => {
						return {
							data: processedImageBitmap,
							cacheControl: params.cacheControl,
							expires: params.expires
						};
					})
					.catch(error => {
						console.error(error);
						throw error;
					});
			});

			// オーバーレイをベース地図に乗算合成して1枚のタイルとして返すカスタムプロトコル。
			// URL 形式: multiply://blend/{z}/{x}/{y}.png?overlay=ENCODED_OVERLAY_TEMPLATE&base=ENCODED_BASE_TEMPLATE
			// MapLibre が外側の {z}/{x}/{y} を置換した後にハンドラが呼ばれる。エンコード済みの内側テンプレートには
			// %7Bz%7D 等が残っているので、ハンドラ側でパスから取り出した z/x/y をそこに差し込む。
			maplibregl.addProtocol('multiply', async (params) => {
				try {
					const url = params.url.replace('multiply://', 'http://');
					const urlObj = new URL(url);
					const m = urlObj.pathname.match(/\/(\d+)\/(\d+)\/(\d+)/);
					if (!m) throw new Error('multiply protocol: missing z/x/y in path: ' + params.url);
					const z = parseInt(m[1], 10);
					const x = parseInt(m[2], 10);
					const y = parseInt(m[3], 10);
					const overlayTemplate = urlObj.searchParams.get('overlay');
					const baseTemplate = urlObj.searchParams.get('base');
					if (!overlayTemplate || !baseTemplate) {
						throw new Error('multiply protocol: missing overlay or base param');
					}
					const overlayMz = parseInt(urlObj.searchParams.get('overlayMz') || '99', 10);

					const fillTemplate = (tpl, zz, xx, yy) => tpl
						.replace(/\{z\}/g, String(zz))
						.replace(/\{x\}/g, String(xx))
						.replace(/\{y\}/g, String(yy));
					const baseUrl = fillTemplate(baseTemplate, z, x, y);

					const fetchImage = async (u) => {
						const res = await fetch(u);
						if (!res.ok) throw new Error(`fetch failed ${res.status} ${u}`);
						const blob = await res.blob();
						return await createImageBitmap(blob);
					};
					// オーバーレイ URL がカスタムスキーム (sekisyoku://, keisyaka://, ...) なら
					// 該当ハンドラを呼んで処理済み画像を取得。http(s) なら通常 fetch。
					const fetchOverlayImage = async (u) => {
						// スキーム抽出: アンダースコア (slopezone1map_b 等) を含むカスタムスキームに対応するため
						// 正規表現ではなく "://" の前部分を直接取り出す。
						const idx = u.indexOf('://');
						const scheme = idx > 0 ? u.slice(0, idx) : null;
						if (scheme && scheme !== 'http' && scheme !== 'https') {
							const handler = customProtocolHandlers[scheme];
							if (!handler) throw new Error('multiply: no handler for scheme ' + scheme);
							const result = await handler({ url: u });
							const data = result && result.data;
							if (data instanceof ImageBitmap) return data;
							if (data) return await createImageBitmap(data);
							throw new Error('multiply: handler returned no data for ' + u);
						}
						return await fetchImage(u);
					};

					// オーバーレイは maxzoom を超えた要求や 404 が返った場合に
					// 親タイルから該当サブ領域を切り出してフォールバックする。
					// dz=0 が現在ズーム、dz が増えるほど親方向。
					const initialDz = Math.max(0, z - overlayMz);
					const fetchOverlayWithParentFallback = async () => {
						const MAX_FALLBACK_DEPTH = 8;
						let lastErr = null;
						for (let dzTry = initialDz; dzTry <= initialDz + MAX_FALLBACK_DEPTH; dzTry++) {
							const oz = z - dzTry;
							if (oz < 0) break;
							const ox = x >> dzTry;
							const oy = y >> dzTry;
							const u = fillTemplate(overlayTemplate, oz, ox, oy);
							try {
								const img = await fetchOverlayImage(u);
								return { img, dz: dzTry, ox, oy };
							} catch (e) {
								lastErr = e;
							}
						}
						if (lastErr) console.warn('[multiply] overlay fetch failed (all fallbacks exhausted)', lastErr);
						return null;
					};

					const [baseImg, overlayResult] = await Promise.all([
						fetchImage(baseUrl),
						fetchOverlayWithParentFallback(),
					]);

					// 出力タイルはベース解像度で作成（合成タイルがベース地図と同じシャープさを保つため）
					const w = baseImg.width;
					const h = baseImg.height;
					const canvas = document.createElement('canvas');
					canvas.width = w;
					canvas.height = h;
					const ctx = canvas.getContext('2d');
					ctx.globalCompositeOperation = 'source-over';
					ctx.drawImage(baseImg, 0, 0, w, h);

					if (overlayResult) {
						const { img: overlayImg, dz, ox, oy } = overlayResult;
						// 親タイルから自タイル相当のサブ領域をスケールして重ねる
						const denom = 1 << dz;
						const subX = x - (ox << dz);
						const subY = y - (oy << dz);
						const sx = (subX / denom) * overlayImg.width;
						const sy = (subY / denom) * overlayImg.height;
						const sw = overlayImg.width / denom;
						const sh = overlayImg.height / denom;
						ctx.globalCompositeOperation = 'multiply';
						ctx.drawImage(overlayImg, sx, sy, sw, sh, 0, 0, w, h);
					}

					const data = await createImageBitmap(canvas);
					return {
						data,
						cacheControl: params.cacheControl,
						expires: params.expires,
					};
				} catch (err) {
					console.error('[multiply protocol]', err);
					throw err;
				}
			});

			//色別傾斜区分図用のカスタムプロトコル
			registerCustomProtocol('slopemap_b', (params) => {
				const url = params.url.replace('slopemap_b://', 'https://');
				return fetch(url)
					.then(response => response.blob())
					.then(blob => createImageBitmap(blob))
					.then(imageBitmap => {
						const canvas = document.createElement('canvas');
						canvas.width = imageBitmap.width;
						canvas.height = imageBitmap.height;
						const context = canvas.getContext('2d');
						context.drawImage(imageBitmap, 0, 0);

						const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
						const data = imageData.data;

						for (let i = 0; i < data.length; i += 4) {
							const gray = data[i];
							if(gray !== 0) {
								if (gray < 0x1b) {//70°以上
									[data[i], data[i+1], data[i+2], data[i+3]] = [0, 0, 0, 0xff]; 
								}
								else if (gray < 0x36) {//60°以上
									[data[i], data[i+1], data[i+2], data[i+3]] = [0xff, 0, 0, 0xff]; 
								}
								else if (gray < 0x53) {//50-60°
									[data[i], data[i+1], data[i+2], data[i+3]] = [0xff, 0, 0x99, 0xff]; 
								}
								else if (gray < 0x73) {//40-50°
									[data[i], data[i+1], data[i+2], data[i+3]] = [0x66, 0, 0xff, 0xff]; 
								}
								else if (gray < 0x94) {//30-40°
									[data[i], data[i+1], data[i+2], data[i+3]] = [0x33, 0x66, 0xff, 0xff]; 
								}
								else if (gray < 0xb7) {//20-30°は緑
									[data[i], data[i+1], data[i+2], data[i+3]] = [0, 0xff, 0, 0xff]; 
								}
								else if (gray < 0xda) {//10-20°は緑
									[data[i], data[i+1], data[i+2], data[i+3]] = [0, 0xff, 0, 0x66]; 
								}
								else {
									[data[i], data[i+1], data[i+2], data[i+3]] = [0, 0, 0, 0]; 
								}
							}
						}
						context.putImageData(imageData, 0, 0);

						return createImageBitmap(canvas);
					})
					.then(processedImageBitmap => {
						return {
							data: processedImageBitmap,
							cacheControl: params.cacheControl,
							expires: params.expires
						};
					})
					.catch(error => {
						console.error(error);
						throw error;
					});
			});
						//高低傾斜強調図用のカスタムプロトコル
			registerCustomProtocol('slopemap_c', (params) => {
				const url = params.url.replace('slopemap_c://', 'https://');
				return fetch(url)
					.then(response => response.blob())
					.then(blob => createImageBitmap(blob))
					.then(imageBitmap => {
						const canvas = document.createElement('canvas');
						canvas.width = imageBitmap.width;
						canvas.height = imageBitmap.height;
						const context = canvas.getContext('2d');
						context.drawImage(imageBitmap, 0, 0);

						const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
						const data = imageData.data;

						for (let i = 0; i < data.length; i += 4) {
							const gray = data[i];
							if(gray !== 0) {
								if (gray < 0x1b) {//70°以上
									[data[i], data[i+1], data[i+2], data[i+3]] = [0, 0, 0, 0xff]; 
								}
								else if (gray < 0x36) {//60°以上
									[data[i], data[i+1], data[i+2], data[i+3]] = [0xff, 0, 0, 0xff]; 
								}
								else if (gray < 0x53) {//50-60°
									[data[i], data[i+1], data[i+2], data[i+3]] = [0xff, 0, 0x99, 0xff]; 
								}
								else if (gray > 0xb7 && gray < 0xda) {//10-20°は緑
									[data[i], data[i+1], data[i+2], data[i+3]] = [0, 0xff, 0, 0xff]; 
								}
								else if(gray > 0xb7){
									[data[i], data[i+1], data[i+2], data[i+3]] = [0, 0xff, 0, 0x66];
								}
								else {
									[data[i], data[i+1], data[i+2], data[i+3]] = [0, 0, 0, 0];
								}
							}
						}
						context.putImageData(imageData, 0, 0);

						return createImageBitmap(canvas);
					})
					.then(processedImageBitmap => {
						return {
							data: processedImageBitmap,
							cacheControl: params.cacheControl,
							expires: params.expires
						};
					})
					.catch(error => {
						console.error(error);
						throw error;
					});
			});

			//雪崩傾斜タイプBのカスタムプロトコル
			registerCustomProtocol('slopezone1map_b', async (params) => {
				try {
					// 1枚目の画像を取得
					const url1 = params.url.replace('slopezone1map_b://', 'https://');
					const response1 = await fetch(url1);
					const bitmap1 = await createImageBitmap(await response1.blob());

					// 2枚目の画像を取得
					const url2 = url1.replace('slopezone1map', 'slopemap');
					const response2 = await fetch(url2);
					const bitmap2 = await createImageBitmap(await response2.blob());

					// キャンバスの設定
					const canvas = document.createElement('canvas');
					canvas.width = bitmap1.width;
					canvas.height = bitmap1.height;
					const context = canvas.getContext('2d');

					// 画像の描画と処理
					context.drawImage(bitmap1, 0, 0);
					const imageData1 = context.getImageData(0, 0, canvas.width, canvas.height);
					
					context.drawImage(bitmap2, 0, 0);
					const imageData2 = context.getImageData(0, 0, canvas.width, canvas.height);

					const data1 = imageData1.data;
					const data2 = imageData2.data;

					// ピクセル処理
					for (let i = 0; i < data2.length; i += 4) {
						const gray = data2[i];
						if (gray !== 0) {
							if (gray < 0x64 && gray > 0x46 && 
								!(data1[i] === 0xff && data1[i+1] === 0x28 && data1[i+2] === 0x00)) {
								[data1[i], data1[i+1], data1[i+2], data1[i+3]] = [80, 0, 0, 0xff];
							} else if (gray <= 0x46) {
								[data1[i], data1[i+1], data1[i+2], data1[i+3]] = [0, 0, 0, 0xff];
							} else if (data1[i+3] === 0 && gray < 0x9c) {
								[data1[i], data1[i+1], data1[i+2], data1[i+3]] = [0xff, 0xff, 0x66, 0xff];
							}
						}
					}

					context.putImageData(imageData1, 0, 0);
					const processedBitmap = await createImageBitmap(canvas);

					return {
						data: processedBitmap,
						cacheControl: params.cacheControl,
						expires: params.expires
					};
				} catch (error) {
					console.error('Error in slopezone1map_b protocol:', error);
					throw error;
				}
			});

			//高精細傾斜量図
			registerCustomProtocol('keisyaka', async (params) => {
			try {
				const url = params.url.replace('keisyaka://', 'https://');

				// window.tileMosaicEnabled で単タイル / 3x3モザイクを切替
				const useMosaic = (typeof window === 'undefined') ? true : (window.tileMosaicEnabled !== false);
				const mosaic = await fetchTileMosaic9(url, { single: !useMosaic });
				const tileSize = mosaic.tileSize;
				const zoom = mosaic.zoom;
				const isMosaic = mosaic.isMosaic;
				const metersPerPixel = (40075016.686 * Math.cos(0)) / Math.pow(2, zoom + 8);

				const mosaicCtx = mosaic.canvas.getContext('2d');
				const imageData = mosaicCtx.getImageData(0, 0, mosaic.canvas.width, mosaic.canvas.height);
				const data = imageData.data;
				const mw = mosaic.canvas.width;
				const mh = mosaic.canvas.height;

				// 標高データを 1 次元 Float32 配列に展開（2次元配列より GC 圧が低い）
				const elevation = new Float32Array(mw * mh);
				const isValid = new Uint8Array(mw * mh);
				for (let y = 0; y < mh; y++) {
					for (let x = 0; x < mw; x++) {
						const idx = (y * mw + x) * 4;
						const r = data[idx], g = data[idx + 1], b = data[idx + 2];
						const flat = y * mw + x;
						if (r === 128 && g === 0 && b === 0) {
							isValid[flat] = 0;
							elevation[flat] = 0;
						} else {
							let alt = (r * 65536 + g * 256 + b) * 0.01;
							if (alt > 8849.0) alt = 0.0;
							isValid[flat] = 1;
							elevation[flat] = alt;
						}
					}
				}

				// モザイク時: 中央タイル領域 [tileSize, 2*tileSize) を出力
				// 単タイル時: 自タイル全域 [0, tileSize) を出力（外周はサンプル不可なので 0 度扱い）
				const yMin = isMosaic ? tileSize : 0;
				const xMin = isMosaic ? tileSize : 0;

				// 出力は中央タイル相当
				const outCanvas = (typeof OffscreenCanvas !== 'undefined')
					? new OffscreenCanvas(tileSize, tileSize)
					: (() => { const c = document.createElement('canvas'); c.width = c.height = tileSize; return c; })();
				const outCtx = outCanvas.getContext('2d');
				const outImageData = outCtx.createImageData(tileSize, tileSize);

				for (let oy = 0; oy < tileSize; oy++) {
					for (let ox = 0; ox < tileSize; ox++) {
						const y = oy + yMin;
						const x = ox + xMin;
						const flat = y * mw + x;
						const idx = (oy * tileSize + ox) * 4;

						if (!isValid[flat]) {
							outImageData.data[idx] = 0;
							outImageData.data[idx + 1] = 0;
							outImageData.data[idx + 2] = 0;
							outImageData.data[idx + 3] = 255;
							continue;
						}

						// 単タイル時の外周ピクセルは隣接サンプルが範囲外。範囲外参照を中心ピクセルにクランプ。
						const left  = (x > 0)       ? elevation[flat - 1]  : elevation[flat];
						const right = (x < mw - 1)  ? elevation[flat + 1]  : elevation[flat];
						const up    = (y > 0)       ? elevation[flat - mw] : elevation[flat];
						const down  = (y < mh - 1)  ? elevation[flat + mw] : elevation[flat];

						const dx = (right - left) / (2 * metersPerPixel);
						const dy = (down - up) / (2 * metersPerPixel);
						const slope = Math.sqrt(dx * dx + dy * dy);
						const slopeDeg = Math.atan(slope) * (180 / Math.PI);

						const slopeScaled = Math.min(slopeDeg, 60) / 60; // 0..1
						const lightness = 0.9 - 0.7 * Math.pow(slopeScaled, 0.8); // 緩やか:0.9 / 急:0.2

						const gray = Math.round(255 * lightness);
						outImageData.data[idx] = gray;
						outImageData.data[idx + 1] = gray;
						outImageData.data[idx + 2] = gray;
						outImageData.data[idx + 3] = 255;
					}
				}

/*						const data2 = outputData.data;
						for (let i = 0; i < data2.length; i += 4) {
							const gray = data2[i];
							if(gray !== 0) {
								if (gray < 0x1b) {//70°以上
									[data2[i], data2[i+1], data2[i+2], data2[i+3]] = [0, 0, 0, 0xff]; 
								}
								else if (gray < 0x36) {//60°以上
									[data2[i], data2[i+1], data2[i+2], data2[i+3]] = [0xff, 0, 0, 0xff]; 
								}
								else if (gray < 0x53) {//50-60°
									[data2[i], data2[i+1], data2[i+2], data2[i+3]] = [0xff, 0, 0x99, 0xff]; 
								}
								else if (gray < 0x73) {//40-50°
									[data2[i], data2[i+1], data2[i+2], data2[i+3]] = [0x66, 0, 0xff, 0xff]; 
								}
								else if (gray < 0x94) {//30-40°
									[data2[i], data2[i+1], data2[i+2], data2[i+3]] = [0x33, 0x66, 0xff, 0xff]; 
								}
								else if (gray < 0xb7) {//20-30°は緑
									[data2[i], data2[i+1], data2[i+2], data2[i+3]] = [0, 0xff, 0, 0xff]; 
								}
								else if (gray < 0xda) {//10-20°は緑
									[data2[i], data2[i+1], data2[i+2], data2[i+3]] = [0, 0xff, 0, 0x66]; 
								}
								else {
									[data2[i], data2[i+1], data2[i+2], data2[i+3]] = [0, 0, 0, 0]; 
								}
							}
						}*/


				// 処理結果を出力Canvasに反映
				outCtx.putImageData(outImageData, 0, 0);
				const processedBitmap = await createImageBitmap(outCanvas);

				return {
					data: processedBitmap,
					cacheControl: params.cacheControl,
					expires: params.expires
				};
				} catch (error) {
					console.error('Error in keisyaka protocol:', error);
					throw error;
				}
			});



// タイル ImageBitmap の LRU キャッシュ。
// モザイクモードでは隣接タイルの mosaic フェッチ範囲が大幅に重なる
// (中央タイル毎に 9 枚要求、隣接 mosaic 同士で約 6/9 が共有) ため、
// キャッシュにより実フェッチ数を約 1/3 に削減できる。
//
// 値は Promise<ImageBitmap | null>。同 URL の同時フェッチは Promise 共有でデデュープ。
const TILE_BITMAP_CACHE_MAX = 64;
const tileBitmapCache = new Map();

function fetchTileImageCached(url) {
	if (!url) return Promise.resolve(null);
	if (tileBitmapCache.has(url)) {
		// LRU bump (最後尾へ)
		const p = tileBitmapCache.get(url);
		tileBitmapCache.delete(url);
		tileBitmapCache.set(url, p);
		return p;
	}
	const promise = (async () => {
		try {
			const r = await fetch(url);
			if (!r.ok) {
				tileBitmapCache.delete(url); // 失敗エントリは残さない (再試行可能に)
				return null;
			}
			return await createImageBitmap(await r.blob());
		} catch (e) {
			tileBitmapCache.delete(url);
			return null;
		}
	})();
	tileBitmapCache.set(url, promise);
	while (tileBitmapCache.size > TILE_BITMAP_CACHE_MAX) {
		const oldestKey = tileBitmapCache.keys().next().value;
		tileBitmapCache.delete(oldestKey);
		// 明示的な close() は他ハンドラが ImageBitmap を保持中に評価される競合を生むため避ける。
		// 参照が無くなった ImageBitmap は GC で解放される。
	}
	return promise;
}

// 中央タイル+周囲8タイルを取得し3x3モザイクキャンバスに合成する。
// タイル境界で開度・傾斜量計算が打ち切られるアーティファクトを解消するため。
// URL は GSJ/GSI 系の `/{z}/{y}/{x}.png` パターンに対応 (URL の y/x は呼出側に合わせる)。
//
// 単タイルモード (opts.single=true) では中央タイルのみ取得して同じ形式で返す。
// パフォーマンスが厳しい環境で `window.tileMosaicEnabled = false` にすると単タイルに切替可能。
//
// @param {string} url - 中央タイルのURL（既に z/y/x が展開されたもの）
// @param {object} [opts]
// @param {boolean} [opts.swapXY=false] - URL の最後2階層が /x/y/.png 形式の場合 true
// @param {boolean} [opts.single=false] - 中央タイルのみ取得 (3x3モザイク化しない)
// @returns {Promise<{canvas, tileSize, zoom, isMosaic}>}
async function fetchTileMosaic9(url, opts) {
	const swapXY = !!(opts && opts.swapXY);
	const single = !!(opts && opts.single);
	const match = url.match(/^(.*?)\/(\d+)\/(\d+)\/(\d+)\.png(\?.*)?$/);
	if (!match) {
		throw new Error('fetchTileMosaic9: invalid URL pattern: ' + url);
	}
	const prefix = match[1];
	const z = parseInt(match[2], 10);
	const a = parseInt(match[3], 10); // URL pos 3
	const b = parseInt(match[4], 10); // URL pos 4
	const suffix = match[5] || '';
	// GSJ/GSI: /{z}/{y}/{x}.png なので a=y, b=x。swapXY=true なら a=x, b=y。
	const yC = swapXY ? b : a;
	const xC = swapXY ? a : b;
	const tilesPerSide = 1 << z;

	const buildUrl = (xN, yN) => {
		if (yN < 0 || yN >= tilesPerSide) return null;
		const wrappedX = ((xN % tilesPerSide) + tilesPerSide) % tilesPerSide;
		const p3 = swapXY ? wrappedX : yN;
		const p4 = swapXY ? yN : wrappedX;
		return `${prefix}/${z}/${p3}/${p4}.png${suffix}`;
	};

	// キャッシュ層経由で取得 (隣接モザイク間で重複を排除)
	const fetchOne = (u) => fetchTileImageCached(u);

	if (single) {
		const center = await fetchOne(buildUrl(xC, yC));
		if (!center) throw new Error('fetchTileMosaic9: center tile load failed: ' + url);
		const tileSize = center.width;
		let canvas;
		if (typeof OffscreenCanvas !== 'undefined') {
			canvas = new OffscreenCanvas(tileSize, tileSize);
		} else {
			canvas = document.createElement('canvas');
			canvas.width = tileSize;
			canvas.height = tileSize;
		}
		canvas.getContext('2d').drawImage(center, 0, 0);
		return { canvas, tileSize, zoom: z, isMosaic: false };
	}

	const positions = [
		[-1, -1], [0, -1], [1, -1],
		[-1,  0], [0,  0], [1,  0],
		[-1,  1], [0,  1], [1,  1],
	];

	const tiles = await Promise.all(
		positions.map(([dx, dy]) => fetchOne(buildUrl(xC + dx, yC + dy)))
	);
	const center = tiles[4];
	if (!center) {
		throw new Error('fetchTileMosaic9: center tile load failed: ' + url);
	}
	const tileSize = center.width;
	const compositeSize = tileSize * 3;

	let canvas;
	if (typeof OffscreenCanvas !== 'undefined') {
		canvas = new OffscreenCanvas(compositeSize, compositeSize);
	} else {
		canvas = document.createElement('canvas');
		canvas.width = compositeSize;
		canvas.height = compositeSize;
	}
	const ctx = canvas.getContext('2d');
	// 取得失敗スロットは標高タイルの「無効データ」マーカー (128, 0, 0) で埋める
	ctx.fillStyle = 'rgb(128, 0, 0)';
	ctx.fillRect(0, 0, compositeSize, compositeSize);
	for (let i = 0; i < 9; i++) {
		if (tiles[i]) {
			const [dx, dy] = positions[i];
			ctx.drawImage(tiles[i], (dx + 1) * tileSize, (dy + 1) * tileSize);
		}
	}
	return { canvas, tileSize, zoom: z, isMosaic: true };
}

// グローバル切替フラグ。トラフィック制限などでモザイクが重い場合は false に設定可能。
//   window.tileMosaicEnabled = false  // 単タイル処理に切替
//   window.tileMosaicEnabled = true   // 9タイルモザイク (既定)
if (typeof window !== 'undefined' && window.tileMosaicEnabled === undefined) {
	window.tileMosaicEnabled = true;
}

// 正確な赤色立体地図WebGL実装（地上開度・地下開度対応版）
// グローバルなWebGLコンテキストキャッシュ
let globalGLContext = null;
let globalGLResources = null;

// リソースマネージャー
class WebGLResourceManager {
    constructor() {
        this.contexts = new Map();
        this.maxContexts = 4;
    }

    getContext(width, height) {
        const key = `${width}x${height}`;
        
        if (this.contexts.has(key)) {
            return this.contexts.get(key);
        }

        if (this.contexts.size >= this.maxContexts) {
            const firstKey = this.contexts.keys().next().value;
            const oldContext = this.contexts.get(firstKey);
            if (oldContext.canvas && oldContext.canvas.getContext) {
                const gl = oldContext.canvas.getContext('webgl2');
                if (gl) {
                    const loseContext = gl.getExtension('WEBGL_lose_context');
                    if (loseContext) {
                        loseContext.loseContext();
                    }
                }
            }
            this.contexts.delete(firstKey);
        }

        const canvas = new OffscreenCanvas(width, height);
        const gl = canvas.getContext('webgl2', {
            preserveDrawingBuffer: false,
            premultipliedAlpha: false,
            alpha: true, // 効果強度をアルファチャネルにエンコードするため
            antialias: false,
            depth: false,
            stencil: false,
            powerPreference: 'high-performance'
        });

        if (!gl) {
            return null;
        }

        const context = { canvas, gl, width, height };
        this.contexts.set(key, context);
        return context;
    }

    cleanup() {
        for (const [key, context] of this.contexts) {
            if (context.gl) {
                const loseContext = context.gl.getExtension('WEBGL_lose_context');
                if (loseContext) {
                    loseContext.loseContext();
                }
            }
        }
        this.contexts.clear();
    }
}

const resourceManager = new WebGLResourceManager();

registerCustomProtocol('sekisyoku', async (params) => {
    try {
        // 標高タイル画像を取得
        const url = params.url.replace('sekisyoku://', 'https://');
        
        // グローバル変数から尾根谷強度を取得（デフォルト: 4.0）
        let ridgeValleyIntensity = window.sekisyokuRidgeValleyIntensity || 8.0;
        
        /*// デバッグ用：URLにハードコードされた値があれば優先
        if (url.includes('intensity=')) {
            const match = url.match(/intensity=([0-9.]+)/);
            if (match) {
                ridgeValleyIntensity = parseFloat(match[1]);
            }
        }
        
        console.log(`赤色立体地図処理開始 - 尾根谷強度: ${ridgeValleyIntensity}, URL: ${url}`);
        */
        // window.tileMosaicEnabled で単タイル / 3x3モザイクを切替可能。
        // モザイクはタイル境界アーティファクトを解消する代わりに帯域が9倍。
        const useMosaic = (typeof window === 'undefined') ? true : (window.tileMosaicEnabled !== false);
        const mosaic = await fetchTileMosaic9(url, { single: !useMosaic });
        const tileSize = mosaic.tileSize;
        const textureSize = mosaic.canvas.width;
        const zoom = mosaic.zoom;

        // WebGLコンテキストを取得（出力サイズは中央1タイル分）
        const context = resourceManager.getContext(tileSize, tileSize);
        if (!context) {
            //console.warn('WebGL2が利用できません。CPUフォールバックを使用します。');
            return await fallbackCpuProcessing(params);
        }

        const { gl, canvas } = context;

        // 頂点シェーダー
        const vertexShaderSource = `#version 300 es
            precision highp float;
            in vec2 a_position;
            in vec2 a_texCoord;
            out vec2 v_texCoord;
            
            void main() {
                gl_Position = vec4(a_position, 0.0, 1.0);
                v_texCoord = a_texCoord;
            }
        `;

        // フラグメントシェーダー（正確な赤色立体地図実装）
        const fragmentShaderSource = `#version 300 es
            precision highp float;
            
            uniform sampler2D u_texture;
            uniform vec2 u_textureSize;
            uniform float u_metersPerPixel;
            uniform float u_ridgeValleyIntensity;
            uniform int u_openDistance;
            
            in vec2 v_texCoord;
            out vec4 fragColor;
            
            const float PI = 3.14159265359;
            const float globalMinRidgeValley = -30.0;
            const float globalMaxRidgeValley = 30.0;
            
            // 標高データの取得
            float getElevation(vec2 coord) {
                if (coord.x < 0.0 || coord.x > 1.0 || coord.y < 0.0 || coord.y > 1.0) {
                    return -999.0;
                }
                
                vec4 rgba = texture(u_texture, coord);
                
                // 無効データ判定
                if (rgba.r == 128.0/255.0 && rgba.g == 0.0 && rgba.b == 0.0) {
                    return -999.0;
                }
                
                // RGB to elevation
                float r = rgba.r * 255.0;
                float g = rgba.g * 255.0;
                float b = rgba.b * 255.0;

				float altitude = (r * 256.0 * 256.0 + g * 256.0 + b) * 0.01;
                
				if(altitude > 8849.0) altitude = 0.0;

                return altitude;
            }
            
            // 傾斜量計算
            float calculateSlope(vec2 coord) {
                vec2 pixelSize = 1.0 / u_textureSize;
                
                float center = getElevation(coord);
                float left = getElevation(coord + vec2(-pixelSize.x, 0.0));
                float right = getElevation(coord + vec2(pixelSize.x, 0.0));
                float top = getElevation(coord + vec2(0.0, -pixelSize.y));
                float bottom = getElevation(coord + vec2(0.0, pixelSize.y));
                if (center < -900.0) {
                    return 0.0;
                }

                if (left < -900.0) left = center;
                if (right < -900.0) right = center;
                if (top < -900.0) top = center;
                if (bottom < -900.0) bottom = center;
                
                float dx = (right - left) / (2.0 * u_metersPerPixel);
                float dy = (bottom - top) / (2.0 * u_metersPerPixel);
                
                float slope = sqrt(dx * dx + dy * dy);
                return atan(slope) * 180.0 / PI;
            }
            
            // 地上開度・地下開度計算
            vec2 calculateOpenness(vec2 coord) {
                vec2 pixelSize = 1.0 / u_textureSize;
                float currentElevation = getElevation(coord);

                if (currentElevation < -900.0) return vec2(0.0, 0.0);

                float posOpenSum = 0.0;
                float negOpenSum = 0.0;
                int validDirections = 0;

                // 8方向の処理
                for (int dirIdx = 0; dirIdx < 8; dirIdx++) {
                    vec2 dir = vec2(0.0);
                    if (dirIdx == 0) dir = vec2(-1.0, -1.0);
                    else if (dirIdx == 1) dir = vec2(-1.0, 0.0);
                    else if (dirIdx == 2) dir = vec2(-1.0, 1.0);
                    else if (dirIdx == 3) dir = vec2(0.0, -1.0);
                    else if (dirIdx == 4) dir = vec2(0.0, 1.0);
                    else if (dirIdx == 5) dir = vec2(1.0, -1.0);
                    else if (dirIdx == 6) dir = vec2(1.0, 0.0);
                    else if (dirIdx == 7) dir = vec2(1.0, 1.0);

                    // 対角方向は単位ベクトル長が √2 倍 → 距離補正に使う
                    float dirLen = length(dir);

                    float maxPosAngle = -90.0; // 地上開度用 -90
                    float maxNegAngle = -90.0; // 地下開度用 -90

                    // 指定距離まで各方向をサンプリング（2ピクセル刻み）
                    for (int dist = 1; dist <= u_openDistance * 2; dist++) {
                        vec2 sampleCoord = coord + dir * pixelSize * float(dist) * 2.0;

                        // 境界チェック
                        if (sampleCoord.x < 0.0 || sampleCoord.x > 1.0 ||
                            sampleCoord.y < 0.0 || sampleCoord.y > 1.0) {
                            break;
                        }

                        float sampleElevation = getElevation(sampleCoord);
                        if (sampleElevation < -900.0) break;

                        float heightDiff = sampleElevation - currentElevation;
                        // 距離は「2ピクセルのステップ × dist × 方向ベクトル長」で実距離となる。
                        // 旧コードでは方向ベクトル長を考慮せず対角方向の角度が過大評価されていた。
                        float horizontalDist = float(dist) * 2.0 * dirLen * u_metersPerPixel;

                        // 仰角を計算（度単位）
                        float angle = atan(heightDiff / horizontalDist) * 180.0 / PI;

                        // 地上開度：最大仰角
                        maxPosAngle = max(maxPosAngle, angle);

                        // 地下開度：負の標高差の最大俯角
                        maxNegAngle = max(maxNegAngle, -angle);
                    }

                    posOpenSum += max(0.0, 90.0 - maxPosAngle);
                    negOpenSum += max(0.0, 90.0 - maxNegAngle);
                    validDirections++;
                }
                
                if (validDirections > 0) {
                    return vec2(posOpenSum / float(validDirections), negOpenSum / float(validDirections));
                }
                
                return vec2(0.0, 0.0);
            }
            
            // 外周ピクセル補間
            bool isBorderPixel(vec2 coord) {
                vec2 pixelCoord = coord * u_textureSize;
                return (pixelCoord.x <= 1.0 || pixelCoord.x >= u_textureSize.x - 1.0 || 
                        pixelCoord.y <= 1.0 || pixelCoord.y >= u_textureSize.y - 1.0);
            }
            
            vec3 interpolateFromNeighbors(vec2 coord) {
                vec2 pixelSize = 1.0 / u_textureSize;
                float slopeSum = 0.0;
                float ridgeSum = 0.0;
                float count = 0.0;
                
                for (int dy = -1; dy <= 1; dy++) {
                    for (int dx = -1; dx <= 1; dx++) {
                        if (dx == 0 && dy == 0) continue;
                        
                        vec2 sampleCoord = coord + vec2(float(dx), float(dy)) * pixelSize;
                        vec2 samplePixelCoord = sampleCoord * u_textureSize;
                        
                        if (samplePixelCoord.x > 1.0 && samplePixelCoord.x < u_textureSize.x - 1.0 && 
                            samplePixelCoord.y > 1.0 && samplePixelCoord.y < u_textureSize.y - 1.0) {
                            
                            float slope = calculateSlope(sampleCoord);
                            vec2 openness = calculateOpenness(sampleCoord);
                            float ridge = (openness.x - openness.y) / 4.0;//調整 4.0
                            
                            if (slope >= 0.0) {
                                slopeSum += slope;
                                ridgeSum += ridge;
                                count += 1.0;
                            }
                        }
                    }
                }
                
                if (count > 0.0) {
                    return vec3(slopeSum / count, ridgeSum / count, 1.0);
                }
                return vec3(0.0, 0.0, 0.0);
            }
            
            void main() {
                // 無効データチェック → 透明（ベースをそのまま見せる）
                float elevation = getElevation(v_texCoord);
                if (elevation < -900.0) {
                    fragColor = vec4(0.0, 0.0, 0.0, 0.0);
                    return;
                }

                float slope;
                float ridgeValley;

                if (isBorderPixel(v_texCoord)) {
                    // 外周ピクセルの場合は補間
                    vec3 interpolated = interpolateFromNeighbors(v_texCoord);
                    slope = interpolated.x;
                    ridgeValley = interpolated.y;
                } else {
                    // 内部ピクセルの場合は直接計算
                    slope = calculateSlope(v_texCoord);
                    vec2 openness = calculateOpenness(v_texCoord);
                    ridgeValley = (openness.x - openness.y) / 4.0;
                }

                // 傾斜量 → 赤色シフト強度 [0..1]
                float maxSlopeAngle = 60.0;
                float slopeNorm = clamp(slope / maxSlopeAngle, 0.0, 1.0);

                // 尾根谷度を [0..1] に正規化（0=谷, 0.5=平, 1=尾根）
                float adjustedRidgeValley = ridgeValley * u_ridgeValleyIntensity;
                float rvNorm = clamp(
                    (adjustedRidgeValley - globalMinRidgeValley) / (globalMaxRidgeValley - globalMinRidgeValley),
                    0.0, 1.0
                );

                // 明度カーブ:
                //   尾根 (rvNorm=1.0)  → brightness = 1.0  (乗算: 無変化、ベース最も明るく見える)
                //   平地 (rvNorm=0.5)  → brightness ≈ 0.78 (中間)
                //   谷   (rvNorm=0.0)  → brightness = 0.55 (乗算: 強く減光、谷が暗く見える)
                // 乗算合成では「無変化」より明るくはできないため、平地を一律でやや減光し
                // 尾根を相対的に明るく見せることで明暗のコントラストを作る。
                const float minBrightness = 0.55;
                float brightness = mix(minBrightness, 1.0, rvNorm);

                // 急斜面で R を保ち G/B を抑える → 乗算で base から青緑を抜き赤シフト
                vec3 multiplier = vec3(brightness,
                                       brightness * (1.0 - slopeNorm),
                                       brightness * (1.0 - slopeNorm));

                // 有効データなら alpha=1。乗算は overlay.a を考慮して
                // result = base × mix(1, multiplier, overlay.a) を出すので alpha=1 で全効果が反映される。
                fragColor = vec4(multiplier, 1.0);
            }
        `;

        // シェーダーのコンパイル関数
        function createShader(gl, type, source) {
            const shader = gl.createShader(type);
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
                const error = gl.getShaderInfoLog(shader);
                console.error('Shader compile error:', error);
                gl.deleteShader(shader);
                throw new Error('Shader compilation failed: ' + error);
            }
            
            return shader;
        }

        function createProgram(gl, vertexShader, fragmentShader) {
            const program = gl.createProgram();
            gl.attachShader(program, vertexShader);
            gl.attachShader(program, fragmentShader);
            gl.linkProgram(program);
            
            if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
                const error = gl.getProgramInfoLog(program);
                console.error('Program link error:', error);
                gl.deleteProgram(program);
                throw new Error('Program linking failed: ' + error);
            }
            
            return program;
        }

        // シェーダープログラムの作成
        const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource);
        const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderSource);
        const program = createProgram(gl, vertexShader, fragmentShader);

        // モザイク時: テクスチャ中央 1/3..2/3 を出力。単タイル時: 全域 0..1。
        const T0 = mosaic.isMosaic ? (1.0 / 3.0) : 0.0;
        const T1 = mosaic.isMosaic ? (2.0 / 3.0) : 1.0;
        const positions = new Float32Array([
            -1.0, -1.0,  T0, T1,
             1.0, -1.0,  T1, T1,
            -1.0,  1.0,  T0, T0,
             1.0,  1.0,  T1, T0,
        ]);

        const positionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, positions, gl.STATIC_DRAW);

        const vao = gl.createVertexArray();
        gl.bindVertexArray(vao);

        const positionLocation = gl.getAttribLocation(program, 'a_position');
        const texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');

        gl.enableVertexAttribArray(positionLocation);
        gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 16, 0);

        gl.enableVertexAttribArray(texCoordLocation);
        gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 16, 8);

        // テクスチャの作成
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);

        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, mosaic.canvas);

        // 定数計算
        const metersPerPixel = (40075016.686 * Math.cos(0)) / Math.pow(2, zoom + 8);
        // CPU フォールバックと公式を統一。低ズームほど広い範囲を見て大局的な地形を拾う。
        const openDistance = Math.max(5, Math.min(30, Math.floor(20 * Math.pow(2, 14 - zoom))));

        // レンダリング設定: 出力は中央 1 タイル、テクスチャは 3x3 モザイク
        gl.useProgram(program);
        gl.viewport(0, 0, tileSize, tileSize);

        // ユニフォーム設定
        gl.uniform1i(gl.getUniformLocation(program, 'u_texture'), 0);
        gl.uniform2f(gl.getUniformLocation(program, 'u_textureSize'), textureSize, textureSize);
        gl.uniform1f(gl.getUniformLocation(program, 'u_metersPerPixel'), metersPerPixel);
        gl.uniform1f(gl.getUniformLocation(program, 'u_ridgeValleyIntensity'), ridgeValleyIntensity);
        gl.uniform1i(gl.getUniformLocation(program, 'u_openDistance'), openDistance);

        // クリアして描画
        gl.clearColor(0.0, 0.0, 0.0, 1.0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        
        gl.bindVertexArray(vao);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);

        // 結果をImageBitmapに変換
        const processedBitmap = await createImageBitmap(canvas);

        // リソースクリーンアップ
        gl.deleteTexture(texture);
        gl.deleteBuffer(positionBuffer);
        gl.deleteVertexArray(vao);
        gl.deleteProgram(program);
        gl.deleteShader(vertexShader);
        gl.deleteShader(fragmentShader);

        return {
            data: processedBitmap,
            cacheControl: params.cacheControl,
            expires: params.expires
        };

    } catch (error) {
        console.error('WebGL処理でエラーが発生しました:', error);
        return await fallbackCpuProcessing(params);
    }
});

// CPUフォールバック処理（元のアルゴリズムと同等）
async function fallbackCpuProcessing(params) {
    try {
        const url = params.url.replace('sekisyoku://', 'https://');
        let ridgeValleyIntensity = window.sekisyokuRidgeValleyIntensity || 4.0;
        
        if (url.includes('intensity=')) {
            const match = url.match(/intensity=([0-9.]+)/);
            if (match) {
                ridgeValleyIntensity = parseFloat(match[1]);
            }
        }
        
        console.log(`CPUフォールバック処理 - 尾根谷強度: ${ridgeValleyIntensity}`);

        // window.tileMosaicEnabled で単タイル / 3x3モザイクを切替
        const useMosaic = (typeof window === 'undefined') ? true : (window.tileMosaicEnabled !== false);
        const mosaic = await fetchTileMosaic9(url, { single: !useMosaic });
        const tileSize = mosaic.tileSize;
        const zoom = mosaic.zoom;
        const isMosaic = mosaic.isMosaic;
        const metersPerPixel = (40075016.686 * Math.cos(0)) / Math.pow(2, zoom + 8);
        const openDistance = Math.max(5, Math.min(30, Math.floor(20 * Math.pow(2, 14 - zoom))));

        const mosaicCtx = mosaic.canvas.getContext('2d');
        const imageData = mosaicCtx.getImageData(0, 0, mosaic.canvas.width, mosaic.canvas.height);
        const data = imageData.data;
        const width = mosaic.canvas.width;   // = 3*tileSize (mosaic) or tileSize (single)
        const height = mosaic.canvas.height;

        // 標高データ配列
        const elevation = new Array(height).fill().map(() => new Array(width).fill(0));
        const isValid = new Array(height).fill().map(() => new Array(width).fill(true));

        // 標高データ変換
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const idx = (y * width + x) * 4;
                const r = data[idx];
                const g = data[idx + 1];
                const b = data[idx + 2];

                if (r === 128 && g === 0 && b === 0) {
                    isValid[y][x] = false;
                    elevation[y][x] = 0;
                } else {
                    elevation[y][x] = (r * 256 * 256 + g * 256 + b) * 0.01;
                }
				if(elevation[y][x] > 8849.0) elevation[y][x] = 0.0;

            }
        }

        // 傾斜量、地上開度、地下開度を計算
        const slopes = new Array(height).fill().map(() => new Array(width).fill(0));
        const positiveOpenness = new Array(height).fill().map(() => new Array(width).fill(0));
        const negativeOpenness = new Array(height).fill().map(() => new Array(width).fill(0));

        const directions = [
            [-1, -1], [-1, 0], [-1, 1],
            [0, -1],           [0, 1],
            [1, -1],  [1, 0],  [1, 1]
        ];

        // モザイク時: 中央タイル領域 [tileSize, 2*tileSize) のみ計算（周囲は隣接データとして使う）
        // 単タイル時: 内側 [1, tileSize-1) のみ計算（外周は後で interpolation）
        const yMin = isMosaic ? tileSize : 1;
        const yMax = isMosaic ? (2 * tileSize) : (tileSize - 1);
        const xMin = isMosaic ? tileSize : 1;
        const xMax = isMosaic ? (2 * tileSize) : (tileSize - 1);

        for (let y = yMin; y < yMax; y++) {
            for (let x = xMin; x < xMax; x++) {
                if (!isValid[y][x]) continue;

                // 傾斜量の計算
                const dx = (elevation[y][x + 1] - elevation[y][x - 1]) / (2 * metersPerPixel);
                const dy = (elevation[y + 1][x] - elevation[y - 1][x]) / (2 * metersPerPixel);
                const slope = Math.sqrt(dx * dx + dy * dy);
                slopes[y][x] = Math.atan(slope) * (180 / Math.PI);

                // 地上開度と地下開度の計算
                let posOpenSum = 0;
                let negOpenSum = 0;
                let validDirections = 0;

                for (const [dirY, dirX] of directions) {
                    // 対角方向は単位ベクトル長 √2 → 距離補正に使う
                    const dirLen = Math.sqrt(dirY * dirY + dirX * dirX);
                    let maxPosAngle = -90;
                    let maxNegAngle = -90;

                    for (let dist = 1; dist <= openDistance; dist++) {
                        const sampleY = y + dirY * dist;
                        const sampleX = x + dirX * dist;

                        if (sampleY < 0 || sampleY >= height ||
                            sampleX < 0 || sampleX >= width ||
                            !isValid[sampleY][sampleX]) {
                            break;
                        }

                        const heightDiff = elevation[sampleY][sampleX] - elevation[y][x];
                        // 対角方向は実距離が √2 倍なので方向ベクトル長を掛ける
                        const horizontalDist = dist * dirLen * metersPerPixel;
                        const angle = Math.atan(heightDiff / horizontalDist) * (180 / Math.PI);

                        maxPosAngle = Math.max(maxPosAngle, angle);
                        maxNegAngle = Math.max(maxNegAngle, -angle);
                    }

                    posOpenSum += Math.max(0, 90 - maxPosAngle);
                    negOpenSum += Math.max(0, 90 - maxNegAngle);
                    validDirections++;
                }

                if (validDirections > 0) {
                    positiveOpenness[y][x] = posOpenSum / validDirections;
                    negativeOpenness[y][x] = negOpenSum / validDirections;
                }
            }
        }

        // 尾根谷度の計算（中央タイル領域のみ）
        const ridgeValleyness = new Array(height).fill().map(() => new Array(width).fill(0));
        const globalMinRidgeValley = -30;
        const globalMaxRidgeValley = 30;

        for (let y = yMin; y < yMax; y++) {
            for (let x = xMin; x < xMax; x++) {
                if (isValid[y][x]) {
                    ridgeValleyness[y][x] = (positiveOpenness[y][x] - negativeOpenness[y][x]) / 2;
                }
            }
        }
        // 単タイルモード時のみ外周ピクセルを内側ピクセルから補間
        if (!isMosaic) {
            for (let y = 0; y < tileSize; y++) {
                for (let x = 0; x < tileSize; x++) {
                    if (y === 0 || y === tileSize - 1 || x === 0 || x === tileSize - 1) {
                        let nearestSlope = 0, nearestRidge = 0, validCount = 0;
                        for (let dy = -1; dy <= 1; dy++) {
                            for (let dx = -1; dx <= 1; dx++) {
                                const ny = y + dy, nx = x + dx;
                                if (ny >= 1 && ny < tileSize - 1 && nx >= 1 && nx < tileSize - 1 && isValid[ny][nx]) {
                                    nearestSlope += slopes[ny][nx];
                                    nearestRidge += ridgeValleyness[ny][nx];
                                    validCount++;
                                }
                            }
                        }
                        if (validCount > 0) {
                            slopes[y][x] = nearestSlope / validCount;
                            ridgeValleyness[y][x] = nearestRidge / validCount;
                        }
                    }
                }
            }
        }

        // 赤色立体地図の生成
        const maxSlopeAngle = 60;

        // 出力は中央タイル相当 (tileSize × tileSize) のみ
        const outCanvas = (typeof OffscreenCanvas !== 'undefined')
            ? new OffscreenCanvas(tileSize, tileSize)
            : (() => { const c = document.createElement('canvas'); c.width = c.height = tileSize; return c; })();
        const outCtx = outCanvas.getContext('2d');
        const outImageData = outCtx.createImageData(tileSize, tileSize);
        const minBrightness = 0.55;

        for (let oy = 0; oy < tileSize; oy++) {
            for (let ox = 0; ox < tileSize; ox++) {
                const y = oy + yMin;
                const x = ox + xMin;
                const idx = (oy * tileSize + ox) * 4;

                if (!isValid[y][x]) {
                    // 無効データ → 透明（ベースを通す）
                    outImageData.data[idx] = 0;
                    outImageData.data[idx + 1] = 0;
                    outImageData.data[idx + 2] = 0;
                    outImageData.data[idx + 3] = 0;
                    continue;
                }

                const slopeNorm = Math.max(0, Math.min(1, slopes[y][x] / maxSlopeAngle));
                const ridgeValley = ridgeValleyness[y][x] * ridgeValleyIntensity;
                const rvNorm = Math.max(0, Math.min(1,
                    (ridgeValley - globalMinRidgeValley) / (globalMaxRidgeValley - globalMinRidgeValley)));

                // 尾根=1.0 / 平地≈0.78 / 谷=0.55 のカーブで明暗コントラスト
                const brightness = minBrightness + (1.0 - minBrightness) * rvNorm;
                const r = brightness;
                const g = brightness * (1 - slopeNorm);
                const b = brightness * (1 - slopeNorm);

                outImageData.data[idx]     = Math.round(r * 255);
                outImageData.data[idx + 1] = Math.round(g * 255);
                outImageData.data[idx + 2] = Math.round(b * 255);
                outImageData.data[idx + 3] = 255;
            }
        }

        outCtx.putImageData(outImageData, 0, 0);
        const processedBitmap = await createImageBitmap(outCanvas);

        return {
            data: processedBitmap,
            cacheControl: params.cacheControl,
            expires: params.expires
        };
    } catch (error) {
        console.error('CPUフォールバック処理でもエラーが発生しました:', error);
        throw error;
    }
}

// 尾根谷強度を設定する関数（グローバル）
window.setSekisyokuRidgeValleyIntensity = function(intensity) {
    window.sekisyokuRidgeValleyIntensity = intensity || 4.0;
    console.log(`赤色立体地図の尾根谷強度を ${intensity} に設定しました`);
    
    // マップを再描画してパラメータを反映
    if (window.map && typeof window.map.triggerRepaint === 'function') {
        window.map.triggerRepaint();
    }
};

// マップの再描画を強制する関数
window.refreshSekisyokuMap = function() {
    if (window.map) {
        // キャッシュをクリアして再描画
        const style = window.map.getStyle();
        window.map.setStyle(style);
        console.log('赤色立体地図を再描画しました');
    }
};

// 初期値設定
window.sekisyokuRidgeValleyIntensity = 4.0;

// クリーンアップ関数（必要に応じて呼び出し）
window.cleanupWebGLResources = function() {
    resourceManager.cleanup();
};

// 赤色立体地図カスタムプロトコル
/*maplibregl.addProtocol('sekisyoku', async (params) => {
    try {
        // 標高タイル画像を取得
        const url = params.url.replace('sekisyoku://', 'https://');
        const response = await fetch(url);
        const bitmap = await createImageBitmap(await response.blob());

        // ズームレベルをURLから抽出
        const zoomMatch = url.match(/\/(\d+)\/\d+\/\d+\.png/);
        const zoom = zoomMatch ? parseInt(zoomMatch[1], 10) : 14;

        // 1ピクセルが表す距離（メートル）を計算
        const metersPerPixel = (40075016.686 * Math.cos(0)) / Math.pow(2, zoom + 8);

        // 開度計算パラメータ
        const openDistance = Math.max(5, Math.min(30, Math.floor(20 * Math.pow(2, 14 - zoom)))); // ズームレベルに応じて調整
        
        // 尾根谷強度パラメータ（グローバル変数またはURLパラメータから取得可能）
        const ridgeValleyIntensity = 4;

        // キャンバスの設定
        const canvas = document.createElement('canvas');
        canvas.width = bitmap.width;
        canvas.height = bitmap.height;
        const context = canvas.getContext('2d');

        // 画像の描画と処理
        context.drawImage(bitmap, 0, 0);
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        // 1. 標高データを格納する2D配列
        const elevation = new Array(canvas.height).fill().map(() => new Array(canvas.width).fill(0));
        const isValid = new Array(canvas.height).fill().map(() => new Array(canvas.width).fill(true));

        // 2. ピクセルごとに標高値を計算
        for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
                const idx = (y * canvas.width + x) * 4;
                const r = data[idx];
                const g = data[idx + 1];
                const b = data[idx + 2];

                if (r === 128 && g === 0 && b === 0) {
                    isValid[y][x] = false;
                    elevation[y][x] = 0;
                } else {
                    elevation[y][x] = (r * 256 * 256 + g * 256 + b) * 0.01;
                }
            }
        }

        // 3. 傾斜量、地上開度、地下開度を計算
        const slopes = new Array(canvas.height).fill().map(() => new Array(canvas.width).fill(0));
        const positiveOpenness = new Array(canvas.height).fill().map(() => new Array(canvas.width).fill(0));
        const negativeOpenness = new Array(canvas.height).fill().map(() => new Array(canvas.width).fill(0));

        // 8方向の単位ベクトル
        const directions = [
            [-1, -1], [-1, 0], [-1, 1],
            [0, -1],           [0, 1],
            [1, -1],  [1, 0],  [1, 1]
        ];

        // 各ピクセルで傾斜量と開度を計算
        for (let y = 1; y < canvas.height - 1; y++) {
            for (let x = 1; x < canvas.width - 1; x++) {
                if (!isValid[y][x]) continue;

                // 傾斜量の計算
                const dx = (elevation[y][x + 1] - elevation[y][x - 1]) / (2 * metersPerPixel);
                const dy = (elevation[y + 1][x] - elevation[y - 1][x]) / (2 * metersPerPixel);
                const slope = Math.sqrt(dx * dx + dy * dy);
                slopes[y][x] = Math.atan(slope) * (180 / Math.PI);

                // 地上開度（positive openness）と地下開度（negative openness）の計算
                let posOpenSum = 0;
                let negOpenSum = 0;
                let validDirections = 0;

                for (const [dirY, dirX] of directions) {
                    let maxPosAngle = -90; // 地上開度用（最大値を求める）
                    let maxNegAngle = -90; // 地下開度用（最大値を求める）
                    
                    // 指定距離まで各方向をサンプリング
                    for (let dist = 1; dist <= openDistance; dist++) {
                        const sampleY = y + dirY * dist;
                        const sampleX = x + dirX * dist;
                        
                        if (sampleY < 0 || sampleY >= canvas.height || 
                            sampleX < 0 || sampleX >= canvas.width || 
                            !isValid[sampleY][sampleX]) {
                            break;
                        }

                        const heightDiff = elevation[sampleY][sampleX] - elevation[y][x];
                        const horizontalDist = dist * metersPerPixel;
                        
                        // 仰角を計算（度単位）
                        const angle = Math.atan(heightDiff / horizontalDist) * (180 / Math.PI);
                        
                        // 地上開度：最大仰角
                        maxPosAngle = Math.max(maxPosAngle, angle);
                        
                        // 地下開度：負の標高差の最大俯角
                        maxNegAngle = Math.max(maxNegAngle, -angle);
                    }
                    
                    posOpenSum += Math.max(0, 90 - maxPosAngle); // 90度から引いて開度に変換
                    negOpenSum += Math.max(0, 90 - maxNegAngle);
                    validDirections++;
                }

                if (validDirections > 0) {
                    positiveOpenness[y][x] = posOpenSum / validDirections;
                    negativeOpenness[y][x] = negOpenSum / validDirections;
                }
            }
        }

        // 4. 尾根谷度の計算（地上開度 - 地下開度）/ 2
        const ridgeValleyness = new Array(canvas.height).fill().map(() => new Array(canvas.width).fill(0));
        
        // グローバル統計値を使用してタイル間の一貫性を保つ
        const globalMinRidgeValley = -30; // 経験的な最小値
        const globalMaxRidgeValley = 30;  // 経験的な最大値
        
        for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
                if (isValid[y][x]) {
                    ridgeValleyness[y][x] = (positiveOpenness[y][x] - negativeOpenness[y][x]) / 2;
                }
            }
        }

        // 5. 外周ピクセルの補間
        for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
                if (y === 0 || y === canvas.height - 1 || x === 0 || x === canvas.width - 1) {
                    // 外周ピクセル：有効な内側ピクセルの値をコピー
                    let nearestSlope = 0;
                    let nearestRidge = 0;
                    let validCount = 0;
                    
                    for (let dy = -1; dy <= 1; dy++) {
                        for (let dx = -1; dx <= 1; dx++) {
                            const ny = y + dy;
                            const nx = x + dx;
                            if (ny >= 1 && ny < canvas.height - 1 && 
                                nx >= 1 && nx < canvas.width - 1 && 
                                isValid[ny][nx]) {
                                nearestSlope += slopes[ny][nx];
                                nearestRidge += ridgeValleyness[ny][nx];
                                validCount++;
                            }
                        }
                    }
                    
                    if (validCount > 0) {
                        slopes[y][x] = nearestSlope / validCount;
                        ridgeValleyness[y][x] = nearestRidge / validCount;
                    }
                }
            }
        }

        // 6. 赤色立体地図の生成
        const outputData = context.createImageData(canvas.width, canvas.height);
        const maxSlopeAngle = 60; // 最大傾斜角度（度）
        
        for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
                const idx = (y * canvas.width + x) * 4;
                
                if (!isValid[y][x]) {
                    // 無効ピクセルは黒
                    outputData.data[idx] = 0;
                    outputData.data[idx + 1] = 0;
                    outputData.data[idx + 2] = 0;
                    outputData.data[idx + 3] = 255;
                    continue;
                }

                // 傾斜量を赤色の彩度にマッピング（0-60度 → 0-255）
                const slopeValue = Math.min(slopes[y][x], maxSlopeAngle);
                const saturation = Math.floor((slopeValue / maxSlopeAngle) * 255);
                
                // 尾根谷度を明度にマッピング（グローバル範囲を使用）
                const ridgeValley = ridgeValleyness[y][x] * ridgeValleyIntensity;
                const normalizedRV = Math.max(0, Math.min(1, 
                    (ridgeValley - globalMinRidgeValley) / (globalMaxRidgeValley - globalMinRidgeValley)));
                
                // 明度を計算（0.3-0.8の範囲でより安定した明度）
                const brightness = 0.3 + (normalizedRV * 0.5);
                
                // HSV → RGB変換（H=0は赤色）
                const h = 0; // 赤色固定
                const s = saturation / 255;
                const v = brightness;
                
                const c = v * s;
                const x_hsv = c * (1 - Math.abs(((h / 60) % 2) - 1));
                const m = v - c;
                
                let r, g, b;
                if (h >= 0 && h < 60) {
                    r = c; g = x_hsv; b = 0;
                } else if (h >= 60 && h < 120) {
                    r = x_hsv; g = c; b = 0;
                } else if (h >= 120 && h < 180) {
                    r = 0; g = c; b = x_hsv;
                } else if (h >= 180 && h < 240) {
                    r = 0; g = x_hsv; b = c;
                } else if (h >= 240 && h < 300) {
                    r = x_hsv; g = 0; b = c;
                } else {
                    r = c; g = 0; b = x_hsv;
                }
                
                outputData.data[idx] = Math.floor((r + m) * 255);
                outputData.data[idx + 1] = Math.floor((g + m) * 255);
                outputData.data[idx + 2] = Math.floor((b + m) * 255);
                outputData.data[idx + 3] = 255;
            }
        }

        // 7. 処理結果をCanvasに描画
        context.putImageData(outputData, 0, 0);
        const processedBitmap = await createImageBitmap(canvas);

        return {
            data: processedBitmap,
            cacheControl: params.cacheControl,
            expires: params.expires
        };
    } catch (error) {
        console.error('Error in sekisyoku protocol:', error);
        throw error;
    }
});

// 尾根谷強度を設定する関数
window.setSekisyokuRidgeValleyIntensity = function(intensity) {
    window.sekisyokuRidgeValleyIntensity = intensity;
    console.log(`赤色立体地図の尾根谷強度を ${intensity} に設定しました`);
};
*/
			const navControl = new maplibregl.NavigationControl();
			map.addControl(navControl, 'top-right');
			map.on('load', () => {

	//			this.setScreeSize();
				DiagLog.add('[map] load fired');
				this.map = map;//setStateの反映を待たずに参照できるようにする
				this.setState({ map });

				map.on('moveend', this.updateCenterElevation);

				map.on('mousedown', this.startDrawing);
				map.on('mousemove', this.drawLine);
				map.on('mouseup', this.endDrawing);
				map.on('move', this.handleMapMove);

				map.on('touchstart', this.startDrawing);
				map.on('touchmove', this.drawLine);
				map.on('touchend', this.endDrawing);
				map.on('mouseout', this.handleMouseOut);
				map.on('click', this.handleMapClick);

//				map.on('dblclick', this.handleDoubleClick);

				map.on('touchstart', this.handleTouchStart);
				map.on('touchend', this.handleTouchEnd);

				const geolocate = new maplibregl.GeolocateControl({
					positionOptions: {
						enableHighAccuracy: true,
					},
					trackUserLocation: true,
					showUserHeading: true,
				});

				map.addControl(geolocate, 'top-right');

				// 位置情報が更新されたときのイベントリスナー
				geolocate.on('geolocate', (e) => {
					const lon = e.coords.longitude;
					const lat = e.coords.latitude;
					const position = [lon, lat];
					this.setState({ currentLocation: position });
					console.log(position);
				});

				let exaggeration = this.state.exaggeration;
				if(exaggeration === null || exaggeration === undefined) {
					exaggeration = 1;
					this.setState({ exaggeration: exaggeration });
				}

				//3D表示コントローラーと状態管理
				this.createTerrainControl(exaggeration);
/*				this.terrainControl = new maplibregl.TerrainControl({
					source: 'terrain',
					exaggeration: this.state.exaggeration,
				});
				map.addControl(this.terrainControl, 'top-right');
*/
				// スケールコントロールを作成
				this.customScale = new CustomScaleControl({
					maxWidth: 150,
					unit: 'metric'
				})

				map.addControl(this.customScale);
				this.customScale.setPosition((mapWidth, mapHeight, scaleWidth, scaleHeight,correctionX,correctionY) => {
					// 中央下部に配置
					const x = mapWidth / 2 - scaleWidth / 2 - correctionX;
					const y = mapHeight / 2 - scaleHeight + (mapHeight * 0.40) - correctionY; // 位置調整
					return { x, y };
				});

				// TerrainControlの変更を監視
				map.on('terrain', () => {
					const currentTerrain = map.getTerrain();
					const is3DEnabled = !!currentTerrain;
					this.setState({ is3DEnabled }, () => {
						const urlParams = new URLSearchParams(window.location.search);
						urlParams.set('is3D', is3DEnabled);
						window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`);

						if (this.customScale) {
							this.customScale.setVisibility(!is3DEnabled);
							if(!is3DEnabled) {
								this.customScale.update();
							}
						}
					});
				});
				this.toggleDistanceLayer();

				//map,fm, ownerUid,myName,myColor, projectId
				this.fileHandler = new FileHandler(map,this,this.props.fm,this.props.owneruid,this.props.uuid);

				this.setProjectListener(map);// プロジェクトのドキュメントリスナー
				this.readItemData();//アイテムを読む

				setTimeout(() => {
					this.updateCenterElevation();
				}, 1000);

				map.on('click', this.hideCenterMarkMenu);
				map.on('wheel', this.hideCenterMarkMenu);
				map.on('drag', this.hideCenterMarkMenu);

				// MGRS/UTM グリッド初期化と表示範囲変化時の再生成
				this.setupMgrsUtmGrid(map);
				map.on('moveend', this.scheduleGridUpdate);

			});

		//---------
		}, 100); // 100ミリ秒の遅延 リストから遷移してきたとき、遅延させないと画面中央の座標が実際より下にずれてしまう
		return () => clearTimeout(timer);
	}

	handleTouchStart = (e) => {
		if (e.originalEvent.touches.length > 1) {
			// マルチタッチの場合、ダブルタップ検出をキャンセル
			clearTimeout(this.tapTimeout);
			this.lastTap = 0;
		}
	};

	handleTouchEnd = (e) => {
		const currentTime = new Date().getTime();
		const tapLength = currentTime - this.lastTap;
		clearTimeout(this.tapTimeout);

		if (this.lastTap && tapLength < 500) {
			// ダブルタップ検出
//			this.handleDoubleClick(e);
		} else {
			this.tapTimeout = setTimeout(() => {
				// シングルタップとして処理
			}, 300);
		}

		this.lastTap = currentTime;
	};

	//---------プロジェクト内のデータ(items)を読み込む
	// リスナーを先に張ってから初回読み込みを行う。初回読み込み(getDocs)は SDK が
	// 再試行してくれないので、失敗したら loadInitialItems() でバックオフ再試行する。
	readItemData(){
		this.itemCollectionPath = `userdata/${this.props.owneruid}/projects/${this.props.uuid}/items`;

		DiagLog.add(`[items] readItemData start ${this.itemCollectionPath} owner=${this.isProjectOwner()}`);
		if (!this.isProjectOwner()) {
			// オーナー以外は索引ファイル経由（Firestore を全件読まない）。索引が無ければ全件読みにフォールバック
			this.readItemDataViaIndex();
			return;
		}
		this.itemDocs = new Map();
		this.startFullItemLoad();
	}

	//---------従来の読み込み: リスナーを張ってから getDocs で全件読む
	startFullItemLoad() {
		this.itemsIndexMode = false;
		this.itemListenerStartTime = new Date();
		this.setState({ itemsLoadSource: 'firestore', itemsIndexTime: null });
		this.subscribeItemListener();
		this.loadInitialItems(0);
	}

	//---------アイテムのリアルタイムリスナーを購読する（エラー時は再購読）
	subscribeItemListener() {
		if (!this.itemCollectionPath) return;
		if (this.unsubscribeColListener) {
			this.unsubscribeColListener();
			this.unsubscribeColListener = null;
		}

		this.unsubscribeColListener = this.props.fm.subscribeToCollectionWithUpdateTime(this.itemCollectionPath, this.itemListenerStartTime, async (snapshot) => {
			this.colListenerRetryCount = 0;
			snapshot.docChanges().forEach(async (change) => {
				const data = change.doc.data();
				const docId = change.doc.id;
//const testLabel = document.getElementById('testLabel');
//testLabel.innerText = `readItemData: ${docId} / ${change.type} / ${data.type}`;

				// オーナー: 索引の元になる鏡像を更新し、初回読み込み完了後の変更なら索引の再作成を予約する。
				// item の書き込みは必ず updatetime を含むので、自分の変更もこのリスナーで観測できる
				if (this.itemDocs) {
					if (change.type === "removed" || (data && data.isRemove)) this.itemDocs.delete(docId);
					else this.setItemDocIfNewer(docId, data);
					if (this.isLoadedDrawingData) this.scheduleItemsIndexRebuild(`listener:${change.type}`);
				}

				if (change.type === "added" || change.type === "modified") {
					if(!data.isRemove) {
						// processProjectItem は失敗を throw するので、リスナー経路では
						// ここで捕まえて未処理のPromise拒否にしない
						Promise.resolve(this.processProjectItem(docId,data,change.type))
							.catch((e) => console.error('[items] live update failed:', docId, data && data.type, e));
					}
				}
				else if (change.type === "removed") {
					const map = this.getMap();

					if (data.type === 1 || data.type === 5) {//マーカー、写真
						this.removeMarkerFromMap(docId);
					}
					else if (data.type === 2) {//フリーハンド
						this.rebuidDrawLayer(map,docId);
					}
					else if (data.type === 3) {//図形
						this.rebuidShapeLayer(map,docId);
					}
					else if (data.type === 4) {//ファイル
						if (this.fileHandler) this.fileHandler.removeDataFromMap(docId);
					}
				}
			});
		}, (error) => {
			console.error('[items] listener error:', error && error.code, error);
			if (error && error.code === 'permission-denied') return;//閲覧権限が無い場合は再購読しない
			if (this.colListenerRetryCount >= LISTENER_RETRY_DELAYS.length) return;
			const delay = LISTENER_RETRY_DELAYS[this.colListenerRetryCount++];
			if (this.colListenerRetryTimer) clearTimeout(this.colListenerRetryTimer);
			this.colListenerRetryTimer = setTimeout(() => this.subscribeItemListener(), delay);
		});
	}

	//---------アイテムの初回読み込み。何度呼んでも安全（重複描画しない）
	async loadInitialItems(attempt = 0) {
		if (this.isLoadedDrawingData) return;//サーバから全件読めていれば何もしない
		if (!this.itemCollectionPath) return;
		if (this.itemLoadRetryTimer) {
			clearTimeout(this.itemLoadRetryTimer);
			this.itemLoadRetryTimer = null;
		}

		let total = 0, failed = 0, fromCache = false, lastError = null;
		const t0 = Date.now();
		try {
			let querySnapshot;
			DiagLog.add(`[items] getDocs start (attempt=${attempt + 1})`);
			const donePending = DiagLog.beginPending(`getDocs (attempt=${attempt + 1})`);
			try {
				querySnapshot = await withTimeout(this.props.fm.getCollection(this.itemCollectionPath), ITEM_LOAD_TIMEOUT_MS, 'getDocs');
				if (querySnapshot.metadata && !querySnapshot.metadata.fromCache) this.firestoreServerSeen = true;
				DiagLog.add(`[items] getDocs resolved in ${Date.now() - t0}ms`);
			} catch (e) {
				if (e && e.code === 'timeout') {
					this.getDocsTimeoutCount = (this.getDocsTimeoutCount || 0) + 1;
					// ハングした場合でも画面を空のままにしないよう、キャッシュから読んで表示する
					DiagLog.add(`[items] getDocs timed out (${this.getDocsTimeoutCount}) -> fallback to cache`);
					try {
						querySnapshot = await this.props.fm.getCollectionFromCache(this.itemCollectionPath);
						DiagLog.add(`[items] cache read ok docs=${querySnapshot.docs.length}`);
					} catch (cacheErr) {
						DiagLog.add(`[items] cache read failed: ${(cacheErr && cacheErr.code) || cacheErr}`);
						throw e;
					}
					// 2回続けてハングしたらトランスポートが固まっているとみなし、接続を張り直す
					if (this.getDocsTimeoutCount === 2 && !this.firestoreServerSeen) {
						this.resetFirestoreNetworkOnce();
					}
				}
				else {
					throw e;
				}
			}
			finally {
				donePending();
			}

			total = querySnapshot.docs.length;
			// 1=マーカー 2=描画 3=図形 4=ファイル 5=写真。どの種類が欠けたか分かるように残す
			const typeCounts = {};
			querySnapshot.docs.forEach((d) => {
				const ty = (d.data() || {}).type;
				typeCounts[ty] = (typeCounts[ty] || 0) + 1;
			});
			DiagLog.add(`[items] types ${JSON.stringify(typeCounts)}`);
			// 永続キャッシュから返った場合、リスナーは updatetime>=起動時刻 しか拾わないので
			// 内容が古い可能性がある。表示はするが「完了」にはせずサーバ読みを試み続ける。
			fromCache = querySnapshot.metadata ? querySnapshot.metadata.fromCache : true;
			// 索引の元データ。キャッシュ由来のスナップショットは古い可能性があるので入れない
			if (this.itemDocs && !fromCache) {
				querySnapshot.docs.forEach((d) => this.setItemDocIfNewer(d.id, d.data()));
			}

			// 1件の例外で全件巻き添えにならないよう、アイテム単位で捕捉する。
			// さらに1件でも決着しないと Promise.all が終わらずリトライごと止まるため、
			// アイテム単位にもタイムアウトを掛けて必ず決着させる。
			const failedTypes = [];
			await Promise.all(querySnapshot.docs.map(async (doc) => {
				const data = doc.data();
				const docId = doc.id;
				const doneItemPending = DiagLog.beginPending(`item type=${data && data.type} ${docId}`);
				try {
					await withTimeout(this.processProjectItem(docId, data), ITEM_PROCESS_TIMEOUT_MS, `item ${docId}`);
				} catch (e) {
					failed++;
					lastError = e;
					failedTypes.push(`${data && data.type}:${(e && e.code) || (e && e.message) || 'err'}`);
					console.error('[items] item failed:', docId, data && data.type, e);
				}
				finally {
					doneItemPending();
				}
			}));
			if (failed > 0) DiagLog.add(`[items] failed items = ${failedTypes.join(', ')}`);

			if (failed === 0) {
				if (fromCache) {
					// キャッシュが空の場合は0件のスナップショットが返る（エラーにならない）。
					// 実際に何か描けたときだけ「表示済み」とみなす（空表示のまま失敗を握りつぶさない）
					if (total > 0) this.itemLoadRenderedFromCache = true;
				}
				else {
					this.addToHistory();
					this.isLoadedDrawingData = true;
					this.checkItemsIndexAfterLoad();
				}
			}
		} catch (error) {
			lastError = error;
			failed = -1;//コレクション取得そのものが失敗（＝全件読めていない）
			console.error('Error fetching project items:', error && error.code, error);
		}

		console.log(`[items] attempt=${attempt + 1} total=${total} failed=${failed} fromCache=${fromCache} done=${this.isLoadedDrawingData} ms=${Date.now() - t0}`, (lastError && lastError.code) || '');

		if (!this.isLoadedDrawingData) this.scheduleItemLoadRetry(attempt);
	}

	//---------初回読み込みのバックオフ再試行を予約する
	scheduleItemLoadRetry(attempt) {
		if (this.itemLoadRetryTimer) {
			clearTimeout(this.itemLoadRetryTimer);
			this.itemLoadRetryTimer = null;
		}
		if (attempt >= ITEM_LOAD_RETRY_DELAYS.length) {
			console.warn('[items] gave up after', attempt + 1, 'attempts');
			// キャッシュから表示できている場合は画面が空ではないのでトーストは出さない
			if (!this.itemLoadRenderedFromCache) {
				const t = (key) => translator.t(key);
				toast.error(t('data_load_failed'), {
					autoClose: false,
					onClick: () => this.loadInitialItems(0),
				});
			}
			return;
		}
		DiagLog.add(`[items] retry scheduled in ${ITEM_LOAD_RETRY_DELAYS[attempt]}ms`);
		this.itemLoadRetryTimer = setTimeout(() => this.loadInitialItems(attempt + 1), ITEM_LOAD_RETRY_DELAYS[attempt]);
	}

	//---------Firestoreの接続を張り直す（トランスポートが固まった場合の回復）。1回だけ試す
	async resetFirestoreNetworkOnce() {
		if (this.firestoreNetworkReset) return;
		this.firestoreNetworkReset = true;
		const donePending = DiagLog.beginPending('firestore network reset');
		try {
			DiagLog.add('[items] resetting firestore network');
			await this.props.fm.resetFirestoreNetwork();
			DiagLog.add('[items] firestore network reset done');
		} catch (e) {
			DiagLog.add(`[items] firestore network reset failed: ${(e && e.code) || e}`);
		} finally {
			donePending();
		}
	}

	//---------読み込みが未完了なら即座に再読み込みする（オンライン復帰・タブ復帰用）
	retryItemLoadIfIncomplete() {
		if (this.isLoadedDrawingData) return;
		if (!this.itemCollectionPath) return;
		if (this.itemsIndexMode) {
			// 索引経由のときは Firestore を全件読み直さず、失敗した item だけやり直す
			if (this.pendingIndexItems && this.pendingIndexItems.length > 0) this.processIndexItems(this.pendingIndexItems, 0);
			return;
		}
		this.loadInitialItems(0);
	}

	//=========アイテム索引(items_index.json)=========
	// オーナーが items 全件を1つの JSON にまとめて Storage に置き、オーナー以外はそれを読む。
	// 詳細は src/ItemsIndex.js のコメントを参照。

	isProjectOwner() {
		const fm = this.props.fm;
		return !!(fm && fm.auth && fm.auth.currentUser && fm.auth.currentUser.uid === this.props.owneruid);
	}

	// 鏡像には updatetime が新しい方を残す（遅れて届いた getDocs の結果でリスナーの新しい値を潰さない）
	setItemDocIfNewer(docId, data) {
		if (!this.itemDocs || !data) return;
		const cur = this.itemDocs.get(docId);
		if (cur && updatetimeMillis(cur) > updatetimeMillis(data)) return;
		this.itemDocs.set(docId, data);
	}

	// オーナーの初回読み込み完了後: 索引が無い / 古い / 件数が合わない なら作り直す
	// （既存プロジェクトの初回作成、オーナー不在中の共同編集者による変更・削除をここで吸収する）
	async checkItemsIndexAfterLoad() {
		if (!this.itemDocs || !this.isProjectOwner()) return;
		let proj = this.currentProject;
		if (!proj) {
			try { proj = await withTimeout(this.projectDocPromise, PROJECT_DOC_WAIT_MS, 'project doc'); } catch (e) { proj = null; }
		}
		const idx = proj && proj.itemsIndex;
		const count = liveItemCount(this.itemDocs);
		const newest = maxUpdatetimeMillis(this.itemDocs);
		const idxTime = idx && idx.time ? updatetimeMillis({ updatetime: idx.time }) : 0;
		const stale = !idx || idx.version !== ITEMS_INDEX_VERSION || !idx.url || idx.count !== count || newest > idxTime;
		DiagLog.add(`[items] index check stale=${stale} idx=${idx ? `v${idx.version} n=${idx.count} t=${idxTime}` : 'none'} live n=${count} newest=${newest}`);
		if (stale) this.scheduleItemsIndexRebuild('after-load', { immediate: true });
	}

	scheduleItemsIndexRebuild(reason, { immediate = false } = {}) {
		if (!this.itemDocs || !this.isProjectOwner()) return;
		const st = this.itemsIndexState;
		st.dirty = true;
		DiagLog.add(`[items] index rebuild scheduled (${reason})${immediate ? ' immediate' : ''}`);
		if (st.inFlight) return;// 完了後に dirty を見てもう一度書く
		if (immediate) {
			this.flushItemsIndexRebuild();
			return;
		}
		if (st.timer) clearTimeout(st.timer);
		st.timer = setTimeout(() => { st.timer = null; this.rebuildItemsIndex(); }, ITEMS_INDEX_DEBOUNCE_MS);
		// 連続編集（描画など）でデバウンスが伸び続けても、最低この間隔で1回は書く
		if (!st.maxTimer) {
			st.maxTimer = setTimeout(() => { st.maxTimer = null; this.rebuildItemsIndex(); }, ITEMS_INDEX_MAX_WAIT_MS);
		}
	}

	// 保留中の索引書き込みを即時実行する（アンマウント・タブ非表示時）
	flushItemsIndexRebuild() {
		const st = this.itemsIndexState;
		if (!st) return;
		if (st.timer) { clearTimeout(st.timer); st.timer = null; }
		if (st.maxTimer) { clearTimeout(st.maxTimer); st.maxTimer = null; }
		if (st.dirty && !st.inFlight) this.rebuildItemsIndex();
	}

	async rebuildItemsIndex() {
		const st = this.itemsIndexState;
		if (!this.isProjectOwner() || !this.isLoadedDrawingData || !this.itemDocs) return;
		if (st.inFlight) { st.dirty = true; return; }
		if (st.timer) { clearTimeout(st.timer); st.timer = null; }
		if (st.maxTimer) { clearTimeout(st.maxTimer); st.maxTimer = null; }
		st.inFlight = true;
		st.dirty = false;
		const t0 = Date.now();
		const donePending = DiagLog.beginPending('items index write');
		let ok = false;
		try {
			// 索引時刻は鏡像を読む前に取る。書き込み中に届いた変更は updatetime >= 索引時刻 になるので
			// 閲覧者のリスナーが拾い直せる
			const generatedAt = new Date();
			const owneruid = this.props.owneruid;
			const uuid = this.props.uuid;
			const json = buildItemsIndexJson({ owneruid, uuid, itemDocs: this.itemDocs, generatedAt });
			const blob = new Blob([JSON.stringify(json)], { type: 'application/json' });
			const url = await this.props.fm.uploadFile(itemsIndexStoragePath(owneruid, uuid), blob, 'application/json');
			await this.props.fm.updateDocument(`userdata/${owneruid}/projects/`, uuid, {
				itemsIndex: { version: ITEMS_INDEX_VERSION, url, time: generatedAt, count: json.count },
			});
			ok = true;
			DiagLog.add(`[items] index written count=${json.count} bytes=${blob.size} ms=${Date.now() - t0}`);
		} catch (e) {
			st.dirty = true;// 次の変更時（またはフラッシュ時）に再試行する
			DiagLog.add(`[items] index write failed: ${(e && e.code) || (e && e.message) || e}`);
			console.error('[items] index write failed:', e);
		} finally {
			st.inFlight = false;
			donePending();
		}
		if (ok && st.dirty && this.isLoadedDrawingData) {
			// 書き込み中に届いた変更をまとめてもう一度
			this.scheduleItemsIndexRebuild('after-write');
		}
	}

	//---------閲覧者: 索引ファイル経由で読み込む。使えなければ従来の全件読みへ
	async readItemDataViaIndex() {
		DiagLog.add('[items] viewer: waiting project doc for index');
		let proj = (this.currentProject && this.currentProject.itemsIndex) ? this.currentProject : null;
		if (!proj) {
			try { proj = await withTimeout(this.projectDocPromise, PROJECT_DOC_WAIT_MS, 'project doc'); } catch (e) { proj = null; }
		}
		const idx = proj && proj.itemsIndex;
		if (!idx || idx.version !== ITEMS_INDEX_VERSION || !idx.url || !idx.time) {
			DiagLog.add(`[items] index unavailable (${idx ? `v${idx.version}` : 'none'}) -> full load`);
			this.startFullItemLoad();
			return;
		}
		const t0 = Date.now();
		const donePending = DiagLog.beginPending('items index fetch');
		let entries;
		try {
			const res = await fetchWithTimeout(idx.url, ITEMS_INDEX_FETCH_TIMEOUT_MS, { cache: 'no-store' });
			if (!res.ok) throw Object.assign(new Error(`index fetch ${res.status}`), { code: `http-${res.status}` });
			entries = parseItemsIndexJson(await res.json(), { uuid: this.props.uuid });
		} catch (e) {
			donePending();
			DiagLog.add(`[items] index failed: ${(e && e.code) || (e && e.message) || e} -> full load`);
			this.startFullItemLoad();
			return;
		}
		donePending();
		const idxTime = updatetimeMillis({ updatetime: idx.time });
		DiagLog.add(`[items] index fetched count=${entries.length} t=${idxTime} ms=${Date.now() - t0}`);
		this.itemsIndexMode = true;
		// 索引以降の変更（共同編集者の追加など）はリスナーで拾う。時計ずれ分の余裕を持たせる
		this.itemListenerStartTime = new Date(idxTime - ITEMS_INDEX_LISTENER_MARGIN_MS);
		this.setState({ itemsLoadSource: 'index', itemsIndexTime: new Date(idxTime) });
		await this.processIndexItems(entries, 0);
	}

	//---------索引の item を描画する。失敗分だけバックオフ再試行する（Firestore の read は発生しない）
	async processIndexItems(entries, attempt) {
		if (this.itemLoadRetryTimer) { clearTimeout(this.itemLoadRetryTimer); this.itemLoadRetryTimer = null; }
		const failedEntries = [];
		const failedTypes = [];
		await Promise.all(entries.map(async ({ id, data }) => {
			const doneItemPending = DiagLog.beginPending(`index item type=${data && data.type} ${id}`);
			try {
				await withTimeout(this.processProjectItem(id, data), ITEM_PROCESS_TIMEOUT_MS, `item ${id}`);
			} catch (e) {
				failedEntries.push({ id, data });
				failedTypes.push(`${data && data.type}:${(e && e.code) || (e && e.message) || 'err'}`);
				console.error('[items] index item failed:', id, data && data.type, e);
			} finally {
				doneItemPending();
			}
		}));
		// 初回パスの後にリスナーを張る。開始時刻が索引時刻より前なので取りこぼしは無く、
		// リスナーの新しい内容を索引の古い内容で上書きする競合も避けられる
		if (!this.unsubscribeColListener) this.subscribeItemListener();
		DiagLog.add(`[items] index done attempt=${attempt + 1} total=${entries.length} failed=${failedEntries.length}${failedEntries.length ? ' ' + failedTypes.join(', ') : ''}`);
		if (failedEntries.length === 0) {
			this.pendingIndexItems = null;
			if (!this.isLoadedDrawingData) {
				this.addToHistory();
				this.isLoadedDrawingData = true;
			}
			return;
		}
		this.pendingIndexItems = failedEntries;
		if (attempt >= ITEM_LOAD_RETRY_DELAYS.length) {
			console.warn('[items] index items gave up after', attempt + 1, 'attempts');
			const t = (key) => translator.t(key);
			toast.error(t('data_load_failed'), {
				autoClose: false,
				onClick: () => this.processIndexItems(this.pendingIndexItems || [], 0),
			});
			return;
		}
		DiagLog.add(`[items] index retry scheduled in ${ITEM_LOAD_RETRY_DELAYS[attempt]}ms`);
		this.itemLoadRetryTimer = setTimeout(() => this.processIndexItems(failedEntries, attempt + 1), ITEM_LOAD_RETRY_DELAYS[attempt]);
	}

	//更新データがこちらのデータより新しいかチェックする
	checkLastUpdate(updatetime) {
		if(!this.latestClickTime) return true;
		const updateTime = updatetime.toDate(); // JavaScriptのDate型に変換
		console.log('checkLastUpdate:' + updateTime.getTime() + ':' + this.latestClickTime.getTime());
		if(updateTime.getTime() > this.latestClickTime.getTime()) return true;
		return false;
	}

	async processProjectItem(docId,data,changeType) {

		//マーカー
		if (data.type === 1) {
			new Marker(this.getMap(), data.lng, data.lat, data.elevation,data, 60, docId,this,
				(marker) => {
					this.addMarkerToMap(marker, docId);
				},
				(marker) => {
					this.updateFirebaseMarker(marker,docId);
				},
				(marker) => {
					marker.currentLocation = this.state.currentLocation;
				},
			);
		}
		else if (data.type === 5) {
			// 写真マーカーの処理
			try {
				const iconResponse = await fetchWithTimeout(data.iconurl);
				if(!iconResponse.ok) {
					throw new Error(`photo icon fetch failed: ${iconResponse.status}`);
				}
				const iconBlob = await iconResponse.blob();
				const iconDataUrl = URL.createObjectURL(iconBlob);

				const marker = this.findMarkerByDocId(docId);
				DiagLog.add(`[photo] listener ${changeType} ${docId} found=${!!marker} note=${data.note ? data.note.length : 0} dto=${typeof data.dateTimeOriginal}:${data.dateTimeOriginal && data.dateTimeOriginal.seconds ? 'ts' : data.dateTimeOriginal}`);
				if(!marker || marker === undefined) {
					new Marker(this.getMap(), data.lng, data.lat, data.elevation, {
							...data,
							iconDataUrl: iconDataUrl,
							photoUrl: data.fileurl
						}, 60, docId, this,
						(marker) => {//地図に表示
							this.addMarkerToMap(marker, docId);
						},
						(marker) => {//変更
							this.updateFirebasePhoto(marker, docId);
						},
						(marker) => {//クリック
							marker.currentLocation = this.state.currentLocation;
							this.showPhotoViewer(marker);
						},
					);
				}
				else {
					marker.update(data);
					marker.updatePhotoIcon(data.note);
					this.updatePhotoMarkers();
				}
				
			} catch (error) {
				console.error('Failed to load photo marker:', error);
				throw error;//呼び出し元(loadInitialItems)で失敗件数に計上して再試行させる
			}
		}
		//フリーハンド描画
		else if (data.type === 2) {
			if(this.props.fm.auth.currentUser !== null && this.props.fm.auth.currentUser.uid !== null) {
				if(data.owneruid === this.props.fm.auth.currentUser.uid && data.instanceid === this.instanceID) {
					this.lastUpdate = new Date();
					this.updateFiles({id:docId,data:data});
					return;
				}
				if (this.props.fm.auth.currentUser && data.owneruid === this.props.fm.auth.currentUser.uid &&  this.state.isDrawing) return
				if(data.owneruid === this.props.fm.auth.currentUser.uid && !this.checkLastUpdate(data.updatetime)) return;
			}

			try {
				const response = await fetchWithTimeout(data.geojsonUrl);
				if(!response.ok) {
					throw new Error(`drawing geojson fetch failed: ${response.status}`);
				}
				const geoJSON = await response.json();
				geoJSON.id = docId;
				geoJSON.data = data;
				this.updateMapWithGeoJSON_drawing(geoJSON);
				this.updateFiles({id:docId,data:data});
			} catch (error) {
				console.error('Failed to load GeoJSON:', error);
				throw error;//呼び出し元(loadInitialItems)で失敗件数に計上して再試行させる
			}
			//this.addLineToMap(data, docId);
		}
		//図形
		else if (data.type === 3) {
			if(this.props.fm.auth.currentUser !== null && this.props.fm.auth.currentUser.uid !== null) {
				if(data.owneruid === this.props.fm.auth.currentUser.uid && data.instanceid === this.instanceID) {
					this.lastUpdate = new Date();
					this.updateFiles({id:docId,data:data});
					return;
				}
				if ((this.props.fm.auth.currentUser && data.owneruid === this.props.fm.auth.currentUser.uid) && (this.drawUpdatetimerId || this.state.isDrawing)) {
					this.updateFiles({id:docId,data:data});
					return;
				}
				if(data.owneruid === this.props.fm.auth.currentUser.uid && !this.checkLastUpdate(data.updatetime)) return;
			}
			try {
				const response = await fetchWithTimeout(data.geojsonUrl);
				if(response.ok) {
					const geoJSON = await response.json();
					geoJSON.id = docId;
					geoJSON.data = data;
					this.updateMapWithGeoJSON_shape(geoJSON);

					this.updateFiles({id:docId,data:data});
				}
				else {
					// 以前は無言で捨てていたため、図形が消えても原因が分からなかった
					throw new Error(`shape geojson fetch failed: ${response.status}`);
				}
			} catch (error) {
				console.error('Failed to load GeoJSON:', error);
				throw error;//呼び出し元(loadInitialItems)で失敗件数に計上して再試行させる
			}
			//this.addLineToMap(data, docId);
		}
		//ファイル
		else if (data.type === 4) {
			const fileData = this.fileHandler.displayDataOnMapFromFile(data.fileUrl, docId);
			if(fileData) {
				this.updateFiles({id:docId,data:data,fileData:fileData});
			}
		}

	}
	// files を id で追加/更新する。位置は最新の prevState で探す（this.state は setState 反映前の
	// 古い値のことがあり、並行して読み込むと重複や別項目の上書きが起きるため）
	updateFiles = (data) => {
		this.setState(prevState => {
			const newFiles = [...prevState.files];
			const index = newFiles.findIndex(item => item.id === data.id);
			if (index !== -1) {
				newFiles[index] = { ...newFiles[index], ...data };
			} else {
				newFiles.push(data);
			}
			return { files: newFiles };
		});
	};

	findMarkerByDocId(docId) {
		const markerObj = this.markers.find(marker => marker.id === docId);
		return markerObj ? markerObj.marker : null;
	}

	// 写真一覧を撮影日時順に並べ直す。
	// 撮影日時は ISO文字列 / Date / Firestore Timestamp / null が混在しうるので数値化して比較し、
	// 同時刻は docId で順序を固定する（比較結果が不定だと並びが呼び出しごとに変わる）。
	// ライトボックス表示中は、並び直し後も表示中の写真(docId)の位置を currentPhotoIndex に引き直す。
	// （コメント保存→リスナー経由で一覧が作り直された際に、インデックスだけ古いまま残って
	//   「次へ」「前へ」で写真が飛ぶのを防ぐ）
	updatePhotoMarkers() {
		const toTime = (v) => {
			if (!v) return 0;
			if (typeof v === 'object' && typeof v.seconds === 'number') return v.seconds * 1000;
			const t = new Date(v).getTime();
			return isNaN(t) ? 0 : t;
		};
		const photoMarkers = this.markers
		.filter(marker => marker.marker.data.iconDataUrl)
		.map(marker => ({
			...marker.marker.data,
			lat: marker.marker.lat,
			lng: marker.marker.lng,
			docId: marker.id
		}))
		.sort((a, b) => (toTime(a.dateTimeOriginal) - toTime(b.dateTimeOriginal)) || String(a.docId).localeCompare(String(b.docId)));

		this.setState(prevState => {
			const next = { photoMarkers };
			let idx = -1;
			if (prevState.selectedPhoto && prevState.selectedPhoto.docId) {
				idx = photoMarkers.findIndex(p => p.docId === prevState.selectedPhoto.docId);
				if (idx >= 0 && idx !== prevState.currentPhotoIndex) next.currentPhotoIndex = idx;
			}
			DiagLog.add(`[photo] list rebuilt n=${photoMarkers.length} markers=${this.markers.length} sel=${prevState.selectedPhoto ? prevState.selectedPhoto.docId : '-'} oldIdx=${prevState.currentPhotoIndex} newIdx=${idx} order=${photoMarkers.map(p => `${String(p.docId).slice(0,6)}@${toTime(p.dateTimeOriginal)}`).join(',')}`);
			return next;
		});
	}

	// 表示中の写真の現在位置を docId から求める（一覧が並び直された直後でも正しい位置を返す）
	getCurrentPhotoIndex(state) {
		const { photoMarkers, currentPhotoIndex, selectedPhoto } = state;
		if (!photoMarkers || photoMarkers.length === 0) return 0;
		if (selectedPhoto && selectedPhoto.docId) {
			const idx = photoMarkers.findIndex(p => p.docId === selectedPhoto.docId);
			if (idx >= 0) return idx;
		}
		return Math.min(Math.max(currentPhotoIndex || 0, 0), photoMarkers.length - 1);
	}

	showPhotoViewer(marker) {
		this.updatePhotoMarkers();
		setTimeout(() => {
			const currentPhotoIndex = this.state.photoMarkers.findIndex(photo => photo.docId === marker.docId);
			DiagLog.add(`[photo] open ${marker.docId} idx=${currentPhotoIndex} n=${this.state.photoMarkers.length}`);

			this.setState({
				selectedPhoto: {
					owneruid:marker.data.owneruid,
					url: marker.data.photoUrl,
					name: marker.name,
					note: marker.note,
					elevation: marker.elevation,
					cameraModel: marker.data.cameraModel,
					cameraModel: marker.data.cameraModel,
					fileName: marker.data.fileName,
					dateTimeOriginal: marker.data.dateTimeOriginal,
					docId:marker.docId,
				},
				currentPhotoIndex
			}, () => {
				this.scrollMapToPhoto(marker.lat, marker.lng);
			});
		}, 100);


	}

	handlePhotoSelect = (index) => {
		const selectedPhoto = this.state.photoMarkers[index];
		DiagLog.add(`[photo] select idx=${index} ${selectedPhoto ? selectedPhoto.docId : '-'}`);
		this.setState({ 
		currentPhotoIndex: index,
		selectedPhoto: {
			owneruid:selectedPhoto.owneruid,
			url: selectedPhoto.photoUrl,
			name: selectedPhoto.name,
			note: selectedPhoto.note,
			elevation: selectedPhoto.elevation,
			cameraModel: selectedPhoto.cameraModel,
			fileName: selectedPhoto.fileName,
			dateTimeOriginal: selectedPhoto.dateTimeOriginal,
			lat: selectedPhoto.lat,
			lng: selectedPhoto.lng,
			docId:selectedPhoto.docId,
		}
		}, () => {
			this.scrollMapToPhoto(selectedPhoto.lat, selectedPhoto.lng);
		});
	}

	handlePrevPhoto = () => {
		this.setState(prevState => {
			if (!prevState.photoMarkers || prevState.photoMarkers.length === 0) return null;
			const baseIndex = this.getCurrentPhotoIndex(prevState);
			const newIndex = (baseIndex - 1 + prevState.photoMarkers.length) % prevState.photoMarkers.length;
			const newPhoto = prevState.photoMarkers[newIndex];
			DiagLog.add(`[photo] prev sel=${prevState.selectedPhoto ? prevState.selectedPhoto.docId : '-'} stateIdx=${prevState.currentPhotoIndex} base=${baseIndex} -> ${newIndex} ${newPhoto ? newPhoto.docId : '-'} n=${prevState.photoMarkers.length}`);
			this.scrollMapToPhoto(newPhoto.lat, newPhoto.lng);
			return {
				currentPhotoIndex: newIndex,
				selectedPhoto: {
				...newPhoto,
				url: newPhoto.photoUrl,
				}
			};
		});
	}

	handleNextPhoto = () => {
		this.setState(prevState => {
			if (!prevState.photoMarkers || prevState.photoMarkers.length === 0) return null;
			const baseIndex = this.getCurrentPhotoIndex(prevState);
			const newIndex = (baseIndex + 1) % prevState.photoMarkers.length;
			const newPhoto = prevState.photoMarkers[newIndex];
			DiagLog.add(`[photo] next sel=${prevState.selectedPhoto ? prevState.selectedPhoto.docId : '-'} stateIdx=${prevState.currentPhotoIndex} base=${baseIndex} -> ${newIndex} ${newPhoto ? newPhoto.docId : '-'} n=${prevState.photoMarkers.length}`);
			this.scrollMapToPhoto(newPhoto.lat, newPhoto.lng);
			return {
				currentPhotoIndex: newIndex,
				selectedPhoto: {
				...newPhoto,
				url: newPhoto.photoUrl,
				}
			};
		});
	}

	updateSelectedPhoto = () => {
		const { photoMarkers, currentPhotoIndex } = this.state;
		const currentPhoto = photoMarkers[currentPhotoIndex];
		this.setState({
			selectedPhoto: {
				url: currentPhoto.photoUrl,
				name: currentPhoto.name,
				note: currentPhoto.note,
				elevation: currentPhoto.elevation,
				cameraModel: currentPhoto.cameraModel,
				fileName: currentPhoto.fileName,
				dateTimeOriginal: currentPhoto.dateTimeOriginal,
			}
		});
	}

	toggleFullscreen = () => {
		this.setState(prevState => ({
			isPhotoViewerFullscreen: !prevState.isPhotoViewerFullscreen
		}));
	}

	scrollMapToPhoto = (lat, lng) => {
		if (this.state.map) {
			this.state.map.flyTo({
				center: [lng, lat],
			});
		}
	}

	closePhotoViewer = () => {
		this.setState({ selectedPhoto: null });
	}


	addLabelSourceAndLayer(map, id) {
		console.log("addLabelSourceAndLayer:" + id);
		const t = (key) => translator.t(key);
		
		if(map.getLayer(id + '-label')) return;//追加済

		map.addLayer({
			id: id + '-label',
			type: 'symbol',
			source: id,
			layout: {
				'text-font': ['NotoSansCJKjp-Regular'],
				'text-size': 14,
				'text-anchor': 'center',
				'text-allow-overlap': false,
				'symbol-placement': 'point',
				'symbol-spacing': 1000000,
				'text-field': [
					'case',
					['==', ['geometry-type'], 'Point'],
					['concat',
						`${t('Area')}: `,
						[
							'case',
							['<', ['get', 'area'], 1000000],
							['number-format',['round', ['get', 'area']],{'min-fraction-digits': 0, 'max-fraction-digits': 0}],
							['number-format',['/', ['get', 'area'], 1000000],{'min-fraction-digits': 1, 'max-fraction-digits': 1}],
						],
						[
							'case',
							['<', ['get', 'area'], 1000000],
							' m²\n',
							' km²\n'
						],

						`${t('radius')} `,
						[
							'case',
							['<', ['get', 'radius'], 1000],
							['number-format', ['round', ['get', 'radius']], {'min-fraction-digits': 0, 'max-fraction-digits': 0}],
							['number-format', ['/', ['get', 'radius'], 1000], {'min-fraction-digits': 2, 'max-fraction-digits': 2}]
						],
						[
							'case',
							['<', ['get', 'radius'], 1000],
							' m',
							' km'
						]
					],
					['==', ['geometry-type'], 'Polygon'],
					['concat', 
						`${t('Area')}: `,
						[
							'case',
							['<', ['get', 'area'], 1000000],
							['number-format',['round', ['get', 'area']],{'min-fraction-digits': 0, 'max-fraction-digits': 0}],
							['number-format',['/', ['get', 'area'], 1000000],{'min-fraction-digits': 1, 'max-fraction-digits': 1}],
						],
						[
							'case',
							['<', ['get', 'area'], 1000000],
							' m²\n',
							' km²\n'
						],

						`${t('Perimeter')}: `,
						[
							'case',
							['<', ['get', 'totalDistance'], 1000],
							['number-format',['round', ['get', 'totalDistance']],{'min-fraction-digits': 0, 'max-fraction-digits': 0}],
							['number-format',['/', ['get', 'totalDistance'], 1000],{'min-fraction-digits': 2, 'max-fraction-digits': 2}],
						],
						[
							'case',
							['<', ['get', 'totalDistance'], 1000],
							' m\n',
							' km\n'
						],
					],
					''
				]
				},
			paint: {
				'text-color': '#000000',
				'text-halo-color': '#ffffff',
				'text-halo-width': 2
			},
			minzoom: 12,  // 最小ズームレベルを設定
			maxzoom: 20  // 最大ズームレベルを設定
			//filter: ['==', '$type', 'Point'], 
		});
		map.addLayer({
			id: id + '-center-point-layer',
			type: 'circle',
			source: id,
			paint: {
				'circle-radius': ['get', 'centerPointRadius'],
				'circle-color': ['get', 'centerPointColor'],
				'circle-opacity':0.1
			},
			filter: ['==', '$type', 'Point']
		});
	}

	addShapeSource(map,id) {
		if(!map.getSource(id)) {
			map.addSource(id, {
				type: 'geojson',
				data: {
					type: 'FeatureCollection',
					features: []
				}
			});
		}
		return map.getSource(id);
	}
	addShapeLayer(map,id) {
		map.addLayer({
			id: id + '-fill',
			type: 'fill',
			source: id,
			paint: {
				'fill-color': ['coalesce', ['get', 'fillColor'], ['get', 'color']],
				'fill-opacity': ['coalesce', ['get', 'fillOpacity'], 0.4]
			}
		});

		map.addLayer({
			id: id + '-outline',
			type: 'line',
			source: id,
			layout: {
				'line-cap': 'round',
				'line-join': 'round'
			},
			paint: {
				'line-color': ['get', 'color'],
				'line-width': ['get', 'width'],
				'line-opacity': ['coalesce', ['get', 'lineOpacity'], 1.0]
			}
		});
	}

	addSourceAndLayer(map,id,type,url,tileSize,minZoom,maxZoom,opacity,aboveLayer,copylight) {
	
		const dataSource = {
            type: type,
            tiles: [url],
            tileSize: tileSize,
            maxzoom: maxZoom,
            minzoom: minZoom,
            attribution: '© ' + copylight,
        };

		map.addSource(id,dataSource);

		map.addLayer({
            id: id + '-layer',
            type: type,
            source: id,
            paint: {
                'raster-opacity': opacity
            }
        }, aboveLayer);
	}

	addSourceAndLayerBottom(map,name,id,type,url,tileSize,minZoom,maxZoom,opacity,copylight,bp,cc) {

		//特殊処理が必要なカスタムタイルはカスタムプロトコルを使う様にする
		if(bp === 1 || cc === 1) {
			url = url.replace('https://', 'customtile://') + '&bp=' + bp + '&cc=' + cc;
		}
		else if(name === '色別傾斜区分図') {
			url = url.replace('https://', 'slopemap_b://');
		}
		else if(name === '高低傾斜強調図') {
			url = url.replace('https://', 'slopemap_c://');
		}
		else if(name === '雪崩傾斜タイプB') {
			url = url.replace('https://', 'slopezone1map_b://');
		}
		else if(name.startsWith('高精細傾斜量図')) {
			url = url.replace('https://', 'keisyaka://');
		}
		else if(name.startsWith('赤色立体地図_高精細') || cc === 2) {
			url = url.replace('https://', 'sekisyoku://');
		}
		const dataSource = {
			type: type,
			tiles: [url],
			tileSize: tileSize,
			maxzoom: maxZoom,
			minzoom: minZoom,
			attribution: '© ' + copylight,

		};

		map.addSource(id,dataSource);

		const newLayer = {
			id: id + '-layer',
			type: type,
			source: id,
			paint: {
				'raster-opacity': opacity
			}
		};

		const layers = map.getStyle().layers;
		if (layers.length > 0) {
			const firstLayerId = layers[0].id;
			map.addLayer(newLayer, firstLayerId);
		} else {
			map.addLayer(newLayer);
		}

	}

	//一番下に追加
	addLayerAtBottom(map, newLayer) {
		const layers = map.getStyle().layers;
		if (layers.length > 0) {
			const firstLayerId = layers[0].id;
			map.addLayer(newLayer, firstLayerId);
		} else {
			// レイヤーが一つも存在しない場合は、単純に追加
			map.addLayer(newLayer);
		}
	}

	removeSourceAndLayer(map, id) {
		if (map.getLayer(id + '-layer')) {
			map.removeLayer(id + '-layer');
		}
		if (map.getSource(id)) {
			map.removeSource(id);
		}
	}


	updateMapWithGeoJSON_shape = (geoJSON) => {
		const map = this.getMap();
		if (!map) throw new Error('map is not ready');
		const id = geoJSON.id;

		// 既存データ中の半径0の退化円を除去(表示浄化)。id/data は引き継ぐ。
		const originalCount = Array.isArray(geoJSON.features) ? geoJSON.features.length : 0;
		const cleaned = CommonUtils.stripZeroRadiusCircles(geoJSON, MIN_CIRCLE_RADIUS_M);
		cleaned.id = geoJSON.id;
		cleaned.data = geoJSON.data;
		const removedCount = originalCount - (Array.isArray(cleaned.features) ? cleaned.features.length : 0);

		// ソースが存在すればデータを更新する
		if (map.getSource(id)) {
			const source = map.getSource(id);
			source.setData(cleaned);
		}
		else {
			// ソースが存在しなければ、新しいソースを追加する
			const source = this.addShapeSource(map,id);
			source.setData(cleaned);
		}

		if (!map.getLayer(id + '-fill')) {
			this.addShapeLayer(map,id);
			this.addLabelSourceAndLayer(map,id);

		}

		// 自分が所有するシェイプ層でゼロ円を除去した場合のみ、掃除後の geojson を
		// ストレージに再保存して永続的に浄化する(他人の層は書き込み権限がないため表示除外のみ)。
		if (removedCount > 0 && geoJSON.data
			&& this.props.fm && this.props.fm.auth && this.props.fm.auth.currentUser
			&& geoJSON.data.owneruid === this.props.fm.auth.currentUser.uid) {
			const lng = geoJSON.data.lng;
			const lat = geoJSON.data.lat;
			this.updateDrawingData(3, cleaned, _shapeTag, lng, lat);
		}
	}

	updateMapWithGeoJSON_drawing = (geoJSON) => {
		const cleaned = CommonUtils.cleanupDuplicateLineStrings(geoJSON)
		const map = this.getMap();
		if (!map) throw new Error('map is not ready');
		const id = geoJSON.id;

		// ソースが存在すればデータを更新する
		if (map.getSource(id)) {
			const source = map.getSource(id);
			source.setData(cleaned);
		}
		else {
			// ソースが存在しなければ、新しいソースを追加する
			map.addSource(id, {
				type: 'geojson',
				data: cleaned
			});
		}
		if (!map.getLayer(id)) {
			this.addDrawingLayer(map,id);
		}
		this.syncLabelMarkers(id, cleaned);
	}
	addDrawingSource(map,id) {
		if(!map.getSource(this.myDrawing)) {
			map.addSource(id, {
				type: 'geojson',
				data: {
					type: 'FeatureCollection',
					features: []
				}
			});
		}
		return map.getSource(this.myDrawing);
	}

	addDrawingLayer(map,id) {
		map.addLayer({
			id: id,
			type: 'line',    // レイヤーのタイプ（この場合はライン）
			source: id,
			layout: {
				'line-cap': 'round',
				'line-join': 'round'
			},
			paint: {
				'line-color': ['get', 'color'],
				'line-width': ['get', 'width'],
				'line-opacity': ['coalesce', ['get', 'opacity'], 1]
			}
		});
		const t = (key) => translator.t(key);
		if(map.getLayer(id + '-label')) return;//追加済

		map.addLayer({
			id: id + '-label',
			type: 'symbol',
			source: id,
			layout: {
				'text-font': ['NotoSansCJKjp-Regular'],
				'text-size': 14,
				'text-anchor': 'center',
				'text-allow-overlap': false,
				'symbol-placement': 'point',
//				'text-offset': [0, 1],
				'symbol-spacing': 1000,
				'text-field': [
					'case',
					['==', ['geometry-type'], 'LineString'],
					['concat', 
						[
							'case',
							['<', ['get', 'distance'], 1000],
							['number-format',['round', ['get', 'distance']],{'min-fraction-digits': 0, 'max-fraction-digits': 0}],
							['number-format',['/', ['get', 'distance'], 1000],{'min-fraction-digits': 1, 'max-fraction-digits': 1}],
						],
						[
							'case',
							['<', ['get', 'distance'], 1000],
							' m\n',
							' km\n'
						],
						`${t('ascent')}: `,
						['number-format',['round', ['get', 'altitudeDifferenceAscent']],{'min-fraction-digits': 0, 'max-fraction-digits': 0}],' m\n',
						`${t('descent')}: `,
						['number-format',['round', ['get', 'altitudeDifferenceDescent']],{'min-fraction-digits': 0, 'max-fraction-digits': 0}],' m\n',

							['number-format', ['get', 'time'], {'min-fraction-digits': 1, 'max-fraction-digits': 1}],
							`${t('min')}`,

/*						[
							'case',
							['<', ['get', 'time'], 60],
							['concat', 
								['number-format', ['get', 'time'], {'min-fraction-digits': 1, 'max-fraction-digits': 1}],
								' min'
							],
							['concat',
								['number-format', ['floor', ['/', ['get', 'time'], 60]], {'min-fraction-digits': 0, 'max-fraction-digits': 0}],
								'h ',
								['number-format', ['%', ['get', 'time'], 60], {'min-fraction-digits': 1, 'max-fraction-digits': 1}],
								'min'
							]
						],*/
						'\n'
					],					
					''
				]//,'visibility': 'visible'
				},
			paint: {
				'text-color': '#000000',
				'text-halo-color': '#ffffff',
				'text-halo-width': 2
			},
			minzoom: 12,  // 最小ズームレベルを設定
			maxzoom: 20,  // 最大ズームレベルを設定
			filter: ['==', ['geometry-type'], 'LineString']
		});		

		if (!map.getLayer(id + '-grid-label')) {
			map.addLayer({
				id: id + '-grid-label',
				type: 'symbol',
				source: id,
				layout: {
					'text-font': ['NotoSansCJKjp-Regular'],
					'text-field': ['get', 'label'],
					'text-size': ['coalesce', ['get', 'fontSize'], 28],
					'text-anchor': 'center',
					'text-allow-overlap': true,
				},
				paint: {
					'text-color': ['get', 'color'],
					'text-halo-color': ['get', 'haloColor'],
					'text-halo-width': 2,
				},
				filter: ['all', ['==', ['geometry-type'], 'Point'], ['==', ['get', 'gridLabel'], true]]
			});
		}
		if (!map.getLayer(id + '-grid-cell-label')) {
			map.addLayer({
				id: id + '-grid-cell-label',
				type: 'symbol',
				source: id,
				layout: {
					'text-font': ['NotoSansCJKjp-Regular'],
					'text-field': ['get', 'label'],
					'text-size': ['coalesce', ['get', 'fontSize'], 14],
					'text-anchor': 'center',
					'text-allow-overlap': true,
				},
				paint: {
					'text-color': ['get', 'color'],
					'text-halo-color': ['get', 'haloColor'],
					'text-halo-width': 1.5,
				},
				filter: ['all', ['==', ['geometry-type'], 'Point'], ['==', ['get', 'gridCellLabel'], true], ['!=', ['get', 'userLabel'], true]]
			});
		}
		// ユーザーラベル（文字オブジェクト）
		// DOM マーカー描画は 3D(terrain)時に数に比例して毎フレームの遮蔽判定
		// (gl.readPixels) が走り激重になるため、シンボルレイヤー描画に移行した
		if (!map.getLayer(id + '-user-label')) {
			map.addLayer({
				id: id + '-user-label',
				type: 'symbol',
				source: id,
				layout: {
					'text-font': ['NotoSansCJKjp-Regular'],
					'text-field': ['get', 'label'],
					'text-size': ['coalesce', ['get', 'fontSize'], 20],
					'text-anchor': 'center',
					'text-allow-overlap': true,
					// 旧 DOM 実装(white-space: nowrap)と同様に自動折り返ししない
					'text-max-width': 1000,
				},
				paint: {
					'text-color': ['coalesce', ['get', 'color'], '#FF0000'],
					'text-halo-color': ['coalesce', ['get', 'haloColor'], '#ffffff'],
					'text-halo-width': 1.5,
				},
				filter: ['all', ['==', ['geometry-type'], 'Point'], ['==', ['get', 'userLabel'], true]]
			});
			// 自分のラベルのみクリックでメニューを開く（他ユーザーのラベルは表示のみ）
			if (id === this.myDrawing) {
				if (!map._userLabelClickBoundIds) map._userLabelClickBoundIds = new Set();
				if (!map._userLabelClickBoundIds.has(id)) {
					map._userLabelClickBoundIds.add(id);
					map.on('click', id + '-user-label', (e) => {
						// 図形ツール（計測/直線/ポリゴン等）でポイント追加中は
						// マーカー同様にラベルクリックのポップアップを抑制する。
						// ラベルモード('label')は既存ラベル編集のため通常どおり開く。
						if (this.state.isDrawingMode === 3 && this.state.shapeDrawingMode !== 'label') return;
						const clicked = e.features && e.features[0];
						if (!clicked || !clicked.properties || clicked.properties.userLabel !== true) return;
						// queryRenderedFeatures はクローンを返すためソースから最新を取得
						const feature = this.findLabelFeature(clicked.properties.labelId) || clicked;
						const [lng, lat] = feature.geometry.coordinates;
						this.openLabelMenuPopup(feature, { lng, lat });
					});
					map.on('mouseenter', id + '-user-label', () => {
						map.getCanvas().style.cursor = 'pointer';
					});
					map.on('mouseleave', id + '-user-label', () => {
						map.getCanvas().style.cursor = '';
					});
				}
			}
		}
	}

	// ===== MGRS / UTM 座標グリッド =====
	GRID_SOURCE_ID = 'mgrs-utm-grid';

	// グリッド用の source / layer を初期化（map load 時に1回）
	setupMgrsUtmGrid(map) {
		if (!map) return;
		if (map.getSource(this.GRID_SOURCE_ID)) { this.updateMgrsUtmGrid(map); return; }
		map.addSource(this.GRID_SOURCE_ID, {
			type: 'geojson',
			data: { type: 'FeatureCollection', features: [] }
		});
		map.addLayer({
			id: this.GRID_SOURCE_ID + '-line',
			type: 'line',
			source: this.GRID_SOURCE_ID,
			layout: { 'line-cap': 'round', 'line-join': 'round', 'visibility': 'none' },
			paint: {
				'line-color': ['coalesce', ['get', 'color'], '#dd5144'],
				'line-width': ['coalesce', ['get', 'width'], 1],
				'line-opacity': ['coalesce', ['get', 'opacity'], 0.7],
			},
			filter: ['==', ['geometry-type'], 'LineString'],
		});
		// 座標番号ラベル（線の上・中間）。中央アンカー。
		map.addLayer({
			id: this.GRID_SOURCE_ID + '-label',
			type: 'symbol',
			source: this.GRID_SOURCE_ID,
			layout: {
				'visibility': 'none',
				'text-font': ['NotoSansCJKjp-Regular'],
				'text-field': ['get', 'label'],
				// フォントサイズは生成時にズームに応じて properties.fontSize に焼き込む（自動調整）
				'text-size': ['coalesce', ['get', 'fontSize'], 13],
				'text-anchor': 'center',
				'text-allow-overlap': true,
				'text-max-width': 1000,
			},
			paint: {
				'text-color': ['coalesce', ['get', 'color'], '#dd5144'],
				'text-halo-color': ['coalesce', ['get', 'haloColor'], '#ffffff'],
				'text-halo-width': 1.5,
			},
			filter: ['all', ['==', ['geometry-type'], 'Point'], ['==', ['get', 'gridLabel'], true]],
		});
		// 100km 正方形 ID（各セルの左下隅）。bottom-left アンカーで隅から右上へ描画。
		map.addLayer({
			id: this.GRID_SOURCE_ID + '-square',
			type: 'symbol',
			source: this.GRID_SOURCE_ID,
			layout: {
				'visibility': 'none',
				'text-font': ['NotoSansCJKjp-Regular'],
				'text-field': ['get', 'label'],
				'text-size': ['coalesce', ['get', 'fontSize'], 15],
				'text-anchor': 'bottom-left',
				'text-allow-overlap': true,
				'text-max-width': 1000,
			},
			paint: {
				'text-color': ['coalesce', ['get', 'color'], '#dd5144'],
				'text-halo-color': ['coalesce', ['get', 'haloColor'], '#ffffff'],
				'text-halo-width': 1.5,
			},
			filter: ['all', ['==', ['geometry-type'], 'Point'], ['==', ['get', 'gridSquareLabel'], true]],
		});
		this.updateMgrsUtmGrid(map);
	}

	// moveend からの呼び出しをデバウンス
	scheduleGridUpdate = () => {
		if (this._gridUpdateTimer) clearTimeout(this._gridUpdateTimer);
		this._gridUpdateTimer = setTimeout(() => this.updateMgrsUtmGrid(), 150);
	};

	// 現在の表示範囲・ズーム・設定からグリッドを再生成
	updateMgrsUtmGrid = (mapArg) => {
		const map = mapArg || this.state.map;
		if (!map || !map.getSource(this.GRID_SOURCE_ID)) return;
		const lineLayer = this.GRID_SOURCE_ID + '-line';
		const labelLayer = this.GRID_SOURCE_ID + '-label';
		const squareLayer = this.GRID_SOURCE_ID + '-square';
		const settings = CommonUtils.gridOverlay || CommonUtils.GRID_OVERLAY_DEFAULT;

		if (!settings || (settings.mode !== 'mgrs' && settings.mode !== 'utm')) {
			if (map.getLayer(lineLayer)) map.setLayoutProperty(lineLayer, 'visibility', 'none');
			if (map.getLayer(labelLayer)) map.setLayoutProperty(labelLayer, 'visibility', 'none');
			if (map.getLayer(squareLayer)) map.setLayoutProperty(squareLayer, 'visibility', 'none');
			map.getSource(this.GRID_SOURCE_ID).setData({ type: 'FeatureCollection', features: [] });
			return;
		}

		const b = map.getBounds();
		const bounds = { north: b.getNorth(), south: b.getSouth(), east: b.getEast(), west: b.getWest() };
		const canvas = map.getCanvas();
		const viewportPx = (canvas && canvas.clientWidth) ? canvas.clientWidth : window.innerWidth;

		// 間隔・フォントは画面の実距離＋ピクセル幅からモジュール側で決定
		const { lines, labels } = generateGridGeoJSON(bounds, settings.mode, {
			color: settings.color,
			haloColor: '#ffffff',
			width: settings.width,
			opacity: settings.opacity,
			viewportPx,
		});

		map.getSource(this.GRID_SOURCE_ID).setData({ type: 'FeatureCollection', features: lines.concat(labels) });
		map.setLayoutProperty(lineLayer, 'visibility', 'visible');
		map.setLayoutProperty(labelLayer, 'visibility', 'visible');
		// ゾーン表記は MGRS(100km ID)・UTM(ゾーン) いずれも表示
		map.setLayoutProperty(squareLayer, 'visibility', 'visible');
	};


	//マーカー編集
	markerEdit(marker) {
		this.editingMarker = marker;
		this.setState({ showEditMarkerPopup: true });
    }
	//編集後処理
	handleEditMarker = (markerData) => {
		const { map } = this.state;
		if (!map) return;
//		console.log(markerData);
//		console.log(this.editingMarker);
		const existMarker = this.markers.find(markerObj => markerObj.id === markerData.marker.docId);
		if(existMarker && existMarker !== undefined) {
			// アンドゥ用に編集前のデータを保存
			this.recordUndo({
				kind: 'marker',
				op: 'edit',
				docId: existMarker.id,
				oldData: {
					name: existMarker.marker.name,
					reading: existMarker.marker.reading,
					note: existMarker.marker.note,
					iconNumber: existMarker.marker.iconNumber,
					elevation: existMarker.marker.elevation,
					lng: existMarker.marker.lng,
					lat: existMarker.marker.lat,
				},
			});
			existMarker.marker.closePopup();
			existMarker.marker.remove();
			existMarker.marker.name = markerData.name;
			existMarker.marker.reading = markerData.reading;
			existMarker.marker.note = markerData.note;
			existMarker.marker.iconNumber = markerData.iconNumber;
			existMarker.marker.elevation = markerData.elevation;

			markerData.marker.data.name = markerData.marker.name;
			markerData.marker.data.reading = markerData.marker.reading;
			markerData.marker.data.note = markerData.marker.note;
			markerData.marker.data.iconNumber = markerData.marker.iconNumber;
			markerData.marker.data.elevation = markerData.marker.elevation;
			markerData.marker.data.lat = markerData.marker.lat;
			markerData.marker.data.lng = markerData.marker.lng;

			existMarker.marker.data = markerData.marker.data;
			if(!existMarker.marker.elevation || existMarker.marker.elevation === undefined) existMarker.marker.elevation = "0";

			existMarker.marker.remakeMarker(
				(marker) => {
					marker.addToMap();
					this.updateFirebaseMarker(existMarker.marker,existMarker.id);
				},
				(marker) => {
					this.updateFirebaseMarker(marker,marker.docId);
				}
			);
		}
	}

	updateFirebaseMarker(marker,docId) {
		const uuid = this.props.uuid;
		const owneruid = marker.data.owneruid;
		const collectionPath = `userdata/${this.props.owneruid}/projects/${uuid}/items`;
		if(marker.reading === null || marker.reading === undefined) {
			marker.reading = "";
		}
		const data = {
			type:1,
			owneruid:owneruid,
			instanceid: this.instanceID,
			ownername:this.props.myName,
			ownercolor:this.props.myColor,
			lng: marker.lng,
			lat: marker.lat,
			elevation: parseInt(marker.elevation,10),
			name: marker.name,
			reading: marker.reading,
			note: marker.note,
			iconNumber: marker.iconNumber,
			updatetime: new Date(),
		};

		this.props.fm.updateDocument(collectionPath, docId, data)
		.then(() => {
			console.log('Document successfully written!');
			this.touchProjectIfEditable();
		})
		.catch((error) => {
			console.error('Failed to write document:', error);
		});
	}

	updateFirebasePhoto(marker,docId) {
		const uuid = this.props.uuid;
		const owneruid = marker.data.owneruid;
		const collectionPath = `userdata/${this.props.owneruid}/projects/${uuid}/items`;
		const data = {
			type:5,
			owneruid:owneruid,
			instanceid: this.instanceID,
			ownername:this.props.myName,
			ownercolor:this.props.myColor,
			lng: marker.lng,
			lat: marker.lat,
			elevation: parseInt(marker.elevation,10),
			name: marker.name,
			note: marker.note,
			iconNumber: marker.iconNumber,
			updatetime: new Date(),
		};

		this.props.fm.updateDocument(collectionPath, docId, data)
		.then(() => {
			console.log('Document successfully written!');
			this.touchProjectIfEditable();
		})
		.catch((error) => {
			console.error('Failed to write document:', error);
		});
	}

	markerMove(marker) {
		// 移動処理をここに追加
		marker.startMove();
	}

	markerCopyToClipboard(marker) {
		marker.closePopup();
		const t = (key) => translator.t(key);
		toast(t('confirmCopyClipboard'), {autoClose: 1000});
		this.setState({ showOkConfirmDialog: false });
	}

    markerCopy(markerData) {
		markerData.closePopup();
		const { map } = this.state;
		if (!map) return;
		if(!this.checkMarkerLimit()) return;
		
		markerData.lng += 0.0001;
		markerData.lat += 0.0001;
		this.defaultIconNumber = markerData.iconNumber;
		const newMarker = new Marker(map, markerData.lng, markerData.lat, markerData.elevation, markerData, 60, null,this,null,null,null);
		const uuid = this.props.uuid;
		const owneruid = this.props.owneruid;
		const uuid2 = CommonUtils.generateUUID();
		const collectionPath = `userdata/${owneruid}/projects/${uuid}/items`;
		const documentId = uuid2;
		if(!markerData.elevation || markerData.elevation === undefined) markerData.elevation = "0";

		if(markerData.reading === null || markerData.reading === undefined) {
			markerData.reading = "";
		}

		const data = {
			type:1,
			owneruid:this.props.fm.auth.currentUser.uid,
			instanceid: this.instanceID,
			ownername:this.props.myName,
			ownercolor:this.props.myColor,
			lng: markerData.lng,
			lat: markerData.lat,
			elevation: parseInt(markerData.elevation,10),
			name: markerData.name,
			reading: markerData.reading,
			note: markerData.note,
			iconNumber: markerData.iconNumber,
            createtime: new Date(),
            updatetime: new Date(),
		};

		this.props.fm.setDocument(collectionPath, documentId, data)
		.then(() => {
			console.log('Document successfully written!');
			newMarker.docId = documentId;
			this.updateProjectCoordinate();
		})
		.catch((error) => {
			console.error('Failed to write document:', error);
		});
    }

    markerRemove(marker) {
		const t = (key) => translator.t(key);
		let markerName = marker.name;
		if(!markerName || markerName.length < 1) markerName = t('Markers');
        this.showConfirm(CommonUtils.formatString(t('removeConfirm'),markerName)
			,marker
			, (data) => {
				this.setState({ showConfirmDialog: false });
				// アンドゥ用にマーカーデータを保存してから削除
				this.recordUndo({
					kind: 'marker',
					op: 'delete',
					docId: data.docId,
					markerData: {
						lng: data.lng, lat: data.lat,
						elevation: data.elevation,
						name: data.name, reading: data.reading,
						note: data.note, iconNumber: data.iconNumber,
					},
				});
				this.removeMarkerFromMap(data.docId);
				this.props.fm.deleteDocument(`userdata/${this.props.owneruid}/projects/${this.props.uuid}/items`, data.docId);
				this.touchProjectIfEditable();
			}
			,(data) => {
				this.setState({ showConfirmDialog: false });
        });
    }

    showConfirm = (message, data,onConfirm,onCancel) => {
		this.setState({ showConfirmDialog: true });
		this.setState({ confirmDialog: { message,data, onConfirm, onCancel} });
    };




    showOkConfirm = (message, data,onConfirm) => {
		this.setState({ showOkConfirmDialog: true });
		if(onConfirm === null) {
			onConfirm = (data) => {
				this.setState({ showOkConfirmDialog: false });
			} 
		}

		this.setState({ okConfirmDialog: { message,data, onConfirm} });
    };

	rotateEnaDisa(map,is2D) {
		if(is2D) {
			map.dragRotate.disable();
			map.touchZoomRotate.disableRotation();
			map.touchZoomRotate.enable(); 

			map.on('mousedown', (e) => {
				// Mac は Cmd (metaKey)、Win/Linux は Ctrl (ctrlKey) で回転ドラッグを有効化
				if (e.originalEvent.ctrlKey || e.originalEvent.metaKey) {
					map.dragRotate.enable();
				} else {
					map.dragRotate.disable();
				}
			});

			map.on('mouseup', () => {
				map.setPitch(0);
				map.dragRotate.disable();
			});
		} else {
			map.setPitch(60);
			map.dragRotate.enable();
			map.touchZoomRotate.enableRotation();
			map.touchZoomRotate.enable(); 
		}
	}

	metersToPixelsAtLatitude(meters, latitude, zoomLevel) {
		const earthCircumference = 40075016.686; // 地球の円周（メートル）
		const latRad = latitude * Math.PI / 180; // 緯度をラジアンに変換
		const metersPerPixel = earthCircumference * Math.cos(latRad) / Math.pow(2, zoomLevel + 8); // ズームレベルに応じた1ピクセルあたりのメートル数
		return meters / metersPerPixel; // メートルをピクセルに変換
	}

	clickAddMarkerButton = async () => {
			if(await this.checkClipboardPasteMarker()) {
				this.handlePasteMarker();
				return;
			}
			const dataCount = this.getMarkerDataCount()
			if(dataCount < MAX_MARKER_COUNT) {
				this.setState({ showAddMarkerPopup: true });
			}
			else {
				const t = (key) => translator.t(key);
				toast.info(t('max_data_message')); 
			}

		//↓iOSだけ別処理にしていたが、問題ないっぽい？ので統合した
		//navigator.clipboard.readText();をすると、iOSだけペーストメニューが表示される仕様っぽいのでAddMarkerPopupを表示して時間差でペースト処理をしている
/*		if(CommonUtils.isIOS()) {
			const dataCount = this.getDataCount()
			if(dataCount < MAX_DATA_COUNT) {
				this.setState({ showAddMarkerPopup: true });
			}
			else {
				const t = (key) => translator.t(key);
				toast.info(t('max_data_message')); 
			}

/*			setTimeout(() => {
				this.handlePasteMarker();
			}, 500);
*/
/*		}
		else {
			if(await this.checkClipboardPasteMarker()) {
				this.handlePasteMarker();
				return;
			}
			const dataCount = this.getDataCount()
			if(dataCount < MAX_DATA_COUNT) {
				this.setState({ showAddMarkerPopup: true });
			}
			else {
				const t = (key) => translator.t(key);
				toast.info(t('max_data_message')); 
			}
		}*/
	}

	clickUploadButton = () => {
		//写真とファイルの両方を受け付けるので、どちらかに空きがあれば開く
		const markerRest = MAX_MARKER_COUNT - this.getMarkerDataCount();
		const fileRest = MAX_FILE_COUNT - this.getFileDataCount();
		if(markerRest > 0 || fileRest > 0) {
			this.fileInputRef.click();
		}
		else {
			const t = (key) => translator.t(key);
			toast.info(t('max_data_message_all')); 
		}
	}

	clickPoszeroButton = () => {
		const { map } = this.state;
		if (!map) return;

		// ピッチとベアリングをリセット
		map.setPitch(0);
		map.setBearing(0);
		map.setTerrain(null);
		// 3D表示フラグをオフにする
		this.setState({ is3DEnabled: false });

		setTimeout(() => {
			this.customScale.update();
		}, 100);

	};

	handleAddMarker = (markerData, options = {}) => {
		window.scrollTo(0, 0);
		const { map } = this.state;
		if (!map) return;
		//ポップアップからの登録やペーストなど、実際に書き込む直前で上限を見る（skipLimitCheckはアンドゥ/リドゥの復元用）
		if(!options.skipLimitCheck && !this.checkMarkerLimit()) return null;

		this.defaultIconNumber = markerData.iconNumber;
//		const center = map.getCenter();
		const newMarker = new Marker(map, markerData.lng, markerData.lat, markerData.elevation, markerData, 60, null,this,null,null,null);
						//onstructor(map, lng, lat, alt, data, size, docId, boss,callback)
		const uuid = this.props.uuid;
		const owneruid = this.props.owneruid;
		const uuid2 = CommonUtils.generateUUID();
		const collectionPath = `userdata/${owneruid}/projects/${uuid}/items`;
		const documentId = uuid2;
		if(!markerData.elevation || markerData.elevation === undefined) markerData.elevation = "0";

		if(markerData.reading === null || markerData.reading === undefined) {
			markerData.reading = "";
		}
		const data = {
			type:1,
			owneruid:this.props.fm.auth.currentUser.uid,
			instanceid: this.instanceID,
			ownername:this.props.myName,
			ownercolor:this.props.myColor,
			lng: markerData.lng,
			lat: markerData.lat,
			elevation: parseInt(markerData.elevation,10),
			name: markerData.name,
			reading: markerData.reading,
			note: markerData.note,
			iconNumber: markerData.iconNumber,
            createtime: new Date(),
            updatetime: new Date(),
		};

		this.props.fm.setDocument(collectionPath, documentId, data)
		.then(() => {
			console.log('Document successfully written!');
			newMarker.docId = documentId;
			this.updateProjectCoordinate();
			// アンドゥ用に追加操作を記録（docId確定後）
			this.recordUndo({ kind: 'marker', op: 'add', docId: documentId });
		})
		.catch((error) => {
			console.error('Failed to write document:', error);
		});

		this.props.fm.checkAndSaveCurrentPosition(this.props.owneruid,this.props.uuid,this.state.map,this.currentProject);

		return documentId;
	}

	//マーカーをFirebaseに追加する
	addMarkers = (markers) => {
		//上限を超える分は切り捨てる
		const rest = Math.max(0, MAX_MARKER_COUNT - this.getMarkerDataCount());
		const targets = markers.slice(0, rest);
		if(targets.length < markers.length) {
			const t = (key) => translator.t(key);
			toast.info(t('max_data_message_B'));
		}
		for (let i = 0; i < targets.length; i++) {
			const markerData = targets[i];
			this.addMarkerToFirebase(markerData);
		}

		this.updateProjectCoordinate();
		this.props.fm.checkAndSaveCurrentPosition(this.props.owneruid,this.props.uuid,this.state.map,this.currentProject);
	}

	addMarkerToFirebase = (markerData) => {
		const { map } = this.state;
		if (!map) return;

		this.defaultIconNumber = markerData.iconNumber;
//		const center = map.getCenter();
		if(!markerData.elevation || markerData.elevation === undefined) markerData.elevation = "0";

		const newMarker = new Marker(map, markerData.lng, markerData.lat, markerData.elevation, markerData, 60, null,this,null,null,null);
						//onstructor(map, lng, lat, alt, data, size, docId, boss,callback)
		const uuid = this.props.uuid;
		const owneruid = this.props.owneruid;
		const uuid2 = CommonUtils.generateUUID();
		const collectionPath = `userdata/${owneruid}/projects/${uuid}/items`;
		const documentId = uuid2;

		if(markerData.reading === null || markerData.reading === undefined) {
			markerData.reading = "";
		}

		const data = {
			type:1,
			owneruid:markerData.owneruid,
			ownername:markerData.ownername,
			ownercolor:markerData.ownercolor,
			lng: markerData.lng,
			lat: markerData.lat,
			elevation: parseInt(markerData.elevation,10),
			name: markerData.name,
			reading: markerData.reading,
			note: markerData.note,
			iconNumber: markerData.iconNumber,
            createtime: markerData.createtime,
            updatetime: markerData.updatetime,
		};

		const sameMarker = this.findSameMarker(markerData)
		if(sameMarker == null) {
			this.props.fm.setDocument(collectionPath, documentId, data)
			.then(() => {
				console.log('Document successfully written!');
				newMarker.docId = documentId;
				this.addMarkerToMap(newMarker, documentId);
			})
			.catch((error) => {
				console.error('Failed to write document:', error);
			});
		}
		else if(markerData.createtime > sameMarker.data.updatetime) {
			this.props.fm.updateDocument(collectionPath, sameMarker.docId, data)
			.then(() => {
				console.log('Document successfully updateDocument!');
				this.removeMarkerFromMap(sameMarker.docId);
				newMarker.docId = sameMarker.docId;
				newMarker.remakeMarker(
					(marker) => {
						marker.addToMap();
					},
					(marker) => {
					}
				);
			})
			.catch((error) => {
				console.error('Failed to updateDocument:', error);
			});
		}
	}

	addMarkerToMap(newMarker, docId) {
		const existMarker = this.markers.find(markerObj => markerObj.id === docId);
		if(existMarker) {
			this.removeMarkerFromMap(docId);
		}

		newMarker.addToMap();
		this.markers.push({id: docId, marker: newMarker});
		if (newMarker.data && newMarker.data.iconDataUrl) {
			DiagLog.add(`[photo] marker added ${docId} replaced=${!!existMarker} markers=${this.markers.length}`);
			// 置き換え時は removeMarkerFromMap が「削除直後（この写真が無い）」一覧を作ってしまうので、
			// 再追加後に必ず作り直して一覧と実体を一致させる
			if (existMarker) this.updatePhotoMarkers();
		}
		this.setState(prevState => ({
			showAddMarkerPopup: false 
		}));
	}

	findSameMarker(markerData) {
		for (let i = 0; i < this.markers.length; i++) {
			const marker = this.markers[i].marker;
			if(markerData.lat.toFixed(6) === marker.lat.toFixed(6) 
			&& markerData.lng.toFixed(6) === marker.lng.toFixed(6)
			&& markerData.elevation.toFixed(6) === marker.elevation.toFixed(6)) {
				return marker;
			}
			else if(markerData.lat.toFixed(3) === marker.lat.toFixed(3) 
			&& markerData.lng.toFixed(3) === marker.lng.toFixed(3)
			&& (markerData.iconNumber === marker.iconNumber || markerData.name === marker.name)
			) {
				return marker;
			}
		}
	}

	removeMarkerFromMap(docId) {
		const markerObj =  this.markers.find(markerObj => markerObj.id === docId);
//	const testLabel = document.getElementById('testLabel');
//	testLabel.innerText = `removeMarkerFromMap: ${docId} / ${markerObj}`;

		if (markerObj) {
			markerObj.marker.remove(); // マーカーを地図から削除するメソッド
		}
		this.markers = this.markers.filter(markerObj => markerObj.id !== docId);
		DiagLog.add(`[photo] marker removed ${docId} existed=${!!markerObj} markers=${this.markers.length}`);
		this.updatePhotoMarkers();
	}

	makeMarkerGPX(type) {
		let header = `<?xml version="1.0" encoding="UTF-8"?>
		<gpx version="1.1" creator="collabomap - https://collabomap.com/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.topografix.com/GPX/1/1" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd" xmlns:kashmir3d="http://www.kashmir3d.com/namespace/kashmir3d" xmlns:geographica="http://geographica.biz/namespace/geographica">`;

		if(type === "picture" ) {
			header = `<?xml version="1.0" encoding="UTF-8"?>
			<gpx version="1.1" creator="collabomap - https://collabomap.com/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.topografix.com/GPX/1/1" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd" xmlns:kashmir3d="http://www.kashmir3d.com/namespace/kashmir3d" xmlns:geographica="http://geographica.biz/namespace/geographica" xmlns:type="picture">`;		
		}

		const footer = '\n</gpx>';

		let waypoints = '';

		this.markers.forEach(markerObj => {
			const marker = markerObj.marker;

			let time = marker.timestamp ? new Date(marker.data.updatetime).toISOString() : new Date().toISOString();
			if(type === "marker" && marker.data.fileurl && marker.data.iconurl) {
				return;
			} 
			else if(type === "picture" && (!marker.data.fileurl || !marker.data.iconurl)) {
				return;
			} 

			if(type === "picture") {
				time = CommonUtils.formatDateTime_FirestoreOrDateOrString(marker.data.dateTimeOriginal);
			}

			const lat = marker.lat.toFixed(6);
			const lng = marker.lng.toFixed(6);
			const ele = (Number(marker.elevation) || 0).toFixed(6);
			const name = marker.name || '';
			const cmt = marker.note || '';
			const reading = marker.reading || '';
			const icon = marker.iconNumber || 0;
			let fileUrsXML = "";
			if(marker.data.fileurl && marker.data.iconurl) {
				const encodedFileUrl = encodeURIComponent(marker.data.fileurl);
				const encodedIconUrl = encodeURIComponent(marker.data.iconurl);
				fileUrsXML = `\n				<geographica:fileurl>${encodedFileUrl}</geographica:fileurl>\n				<geographica:iconurl>${encodedIconUrl}</geographica:iconurl>`;
			}

			waypoints += `
		<wpt lat="${lat}" lon="${lng}" iswarning="0">
			<ele>${ele}</ele>
			<time>${time}</time>
			<name>${CommonUtils.escapeXml(name)}</name>
			<cmt>${CommonUtils.escapeXml(cmt)}</cmt>
			<extensions>
				<kashmir3d:ident>${CommonUtils.escapeXml(reading)}</kashmir3d:ident>
				<kashmir3d:icon>901001</kashmir3d:icon>
				<geographica:ownerID>${marker.data.owneruid}</geographica:ownerID>
				<geographica:ownerName>${marker.data.ownername}</geographica:ownerName>
				<geographica:ownerColor>${CommonUtils.colors[marker.data.ownercolor]}</geographica:ownerColor>
				<geographica:uuid>${marker.docId}</geographica:uuid>
				<geographica:icon>${icon}</geographica:icon>${fileUrsXML}
			</extensions>
		</wpt>`;
		});

		return header + waypoints + footer;
	}

	//写真GPXの処理
	//写真をFirebaseに追加する
	addPics = (pics) => {
		//上限を超える分は切り捨てる
		const rest = Math.max(0, MAX_MARKER_COUNT - this.getMarkerDataCount());
		const targets = pics.slice(0, rest);
		if(targets.length < pics.length) {
			const t = (key) => translator.t(key);
			toast.info(t('max_data_message_B'));
		}
		for (let i = 0; i < targets.length; i++) {
			const picData = targets[i];
			this.addPictureToFirebase(picData);
		}

		this.updateProjectCoordinate();
		this.props.fm.checkAndSaveCurrentPosition(this.props.owneruid,this.props.uuid,this.state.map,this.currentProject);
	}
	addPictureToFirebase = (picData) => {
		const { map } = this.state;
		if (!map) return;

		if(!picData.elevation || picData.elevation === undefined) picData.elevation = "0";

		const uuid = this.props.uuid;
		const owneruid = this.props.owneruid;
		const uuid2 = CommonUtils.generateUUID();
		const collectionPath = `userdata/${owneruid}/projects/${uuid}/items`;
		const documentId = uuid2;

		const samePicture = null;//this.findSamePicture(picData)
		if(samePicture == null) {
			this.props.fm.setDocument(collectionPath, documentId, picData)
			.then(() => {
				console.log('Document successfully written!');
				picData.docId = documentId;
//				this.addMarkerToMap(newMarker, documentId);
			})
			.catch((error) => {
				console.error('Failed to write document:', error);
			});
		}
		else if(picData.createtime > samePicture.data.updatetime) {
			this.props.fm.updateDocument(collectionPath, samePicture.docId, picData)
			.then(() => {
				console.log('Document successfully updateDocument!');
				this.removeMarkerFromMap(samePicture.docId);
				picData.docId = samePicture.docId;
/*				picData.remakeMarker(
					(marker) => {
						marker.addToMap();
					},
					(marker) => {
					}
				);
*/			})
			.catch((error) => {
				console.error('Failed to addPictureToFirebase:', error);
			});
		}
	}



	// 線データを地図に追加する関数
	addLineToMap = (lineData, docId) => {
		const { map } = this.state;
		if (!map) {
			console.error("Map is not initialized");
			return;
		}
		const lineCoordinates = lineData.coordinates.map(coord => [coord.lng, coord.lat]);
		const source = this.state.map.getSource(this.myDrawing);
		const data = source._data;

		data.features.push({
			type: 'Feature',
			geometry: {
				type: 'LineString',
				coordinates: lineCoordinates
			},
			properties: {
				id: docId,
				color: lineData.color,
				width: lineData.width,
			}
		});

		source.setData(data);
	};

	// 線データを地図から削除する関数
	removeLineFromMap = (docId) => {
		const source = this.state.map.getSource(docId);
		const data = source._data;

		if(data.features) {
			data.features = data.features.filter(feature => feature.properties.id !== docId);
		}
		else {
			data.features = [];
		}
		source.setData(data);

	};

	// 線データを地図上で更新する関数
	updateLineOnMap = (lineData, docId) => {
		const lineCoordinates = lineData.coordinates.map(coord => [coord.lng, coord.lat]);
		const source = this.state.map.getSource(this.myDrawing);
		const data = source._data;

		const lineIndex = data.features.findIndex(feature => feature.properties.id === docId);
		if (lineIndex !== -1) {
			data.features[lineIndex].geometry.coordinates = lineCoordinates;
			data.features[lineIndex].properties.color = lineData.color;
			data.features[lineIndex].properties.width = lineData.width;
			source.setData(data);
		}
	};



	togglePalettePopup = () => {
		this.setState(prevState => ({
			showPalettePopup: !prevState.showPalettePopup
		}));
	};

	handleColorSelect = (color,opacity) => {
		console.log('handleColorSelect:',color);
		this.setState({ selectedColor: color });
		this.setState({ selectedOpacity: opacity });
//		this.setState({ showPalettePopup: false });

		localStorage.setItem('selectedColor', color);
		localStorage.setItem('selectedOpacity', opacity.toString());
	};

	handleLineWidthChange = (width) => {
		this.setState({ lineWidth: width });
		localStorage.setItem('lineWidth', width.toString());
	};

	handleLineOpacityChange = (color,opacity) => {
		this.setState({ selectedOpacity: opacity });
		this.setState({ selectedColor: color });

		localStorage.setItem('selectedColor', color);
		localStorage.setItem('selectedOpacity', opacity.toString());
	};



	toggleMapSharePopup = () => {
		const t = (key) => translator.t(key);
		if (this.currentProject && this.currentProject.permission === 0) {
			toast.warn(t('private_map_no_share'), { autoClose: 3000 });
			return;
		}
		this.setState(prevState => ({
			showMapSharePopup: !prevState.showMapSharePopup
		}));
		if(this.state.showMapSharePopup) this.updateProjectCoordinate();
	};
	clickFavoButton = () => {
		const isfavo = !this.state.isfavorite;
		if(this.props.fm && this.props.fm.auth && this.props.fm.auth.currentUser) {
			const myCollectionPath = `userdata/${this.props.fm.auth.currentUser.uid}/projects/`;

			let data = null;
			data = {
				isfavorite: isfavo,
			};
			try {
				this.props.fm.updateDocument(myCollectionPath, this.props.uuid, data);
			} catch (error) {
				console.error('Failed to clickFavoButton:', error);
			}
			this.setState({isfavorite:isfavo});
		}
	};

	changeDrawingMode = () => {
		const {map} = this.state;
		map.resetNorth();
		map.setPitch(0)
		const t = (key) => translator.t(key);
		const buttonDrawMode = document.getElementById('buttonDrawMode');
		if(!buttonDrawMode) return;

		/*if(this.state.isDrawingMode === 0) {
			const centerMark = document.getElementById('centerMark');
			if (centerMark) {
				centerMark.style.pointerEvents = 'none';
			}

			this.state.map.doubleClickZoom.disable();
			this.setState({isDrawingMode:1});
			buttonDrawMode.textContent = t('freehand_drawing');
			map.getCanvas().style.cursor = 'url(/img/pen.png) 0 32, auto';
		}*/
		if(this.state.isDrawingMode === 1) {//フリーハンド描画
			const centerMark = document.getElementById('centerMark');
			if (centerMark) {
				centerMark.style.pointerEvents = 'none';
			}

			this.state.map.doubleClickZoom.disable();
			this.setState({isDrawingMode:2});
			buttonDrawMode.textContent = t('freehand_eraser');
			map.getCanvas().style.cursor = 'url(/img/eraser.png) 0 32, auto';

			this.setState({
				penButtonBG:normalBackGround,
				shapeButtonBG:normalBackGround,
				eraserButtonBG:activeBackGround,
			});	
		}
		else {
			const centerMark = document.getElementById('centerMark');
			if (centerMark) {
				centerMark.style.pointerEvents = 'auto';
			}
			this.state.map.doubleClickZoom.enable();
			this.setState({isDrawingMode:0});
			buttonDrawMode.textContent = t('freehand_drawing');
			map.touchZoomRotate.enable();
			map.dragPan.enable();
			map.getCanvas().style.cursor = 'grab';

			this.setState({
				penButtonBG:normalBackGround,
				shapeButtonBG:normalBackGround,
				eraserButtonBG:normalBackGround,
			});	
		}
	};

	//アンドゥボタン
	handleUndo = () => {
		this.undo();
	};

	//リドゥボタン
	handleRedo = () => {
		this.redo();
	};

	clickPenButton = () => {
		this.endShapeAll();

		const {map} = this.state;
		map.resetNorth();
		map.setPitch(0)

		if(this.state.isDrawingMode === 1) {
			const centerMark = document.getElementById('centerMark');
			if (centerMark) {
				centerMark.style.pointerEvents = 'auto';
			}
			this.state.map.doubleClickZoom.enable();
			this.setState({isDrawingMode:0});
			map.touchZoomRotate.enable();
			map.dragPan.enable();
			map.getCanvas().style.cursor = 'grab';
			this.setState({
				penButtonBG:normalBackGround,
				shapeButtonBG:normalBackGround,
				eraserButtonBG:normalBackGround,
			});	
		}
		else {
			const centerMark = document.getElementById('centerMark');
			if (centerMark) {
				centerMark.style.pointerEvents = 'none';
			}

			this.state.map.doubleClickZoom.disable();
			this.setState({isDrawingMode:1});

			map.getCanvas().style.cursor = 'url(/img/pen.png) 0 32, auto';

			this.setState({
				penButtonBG:activeBackGround,
				shapeButtonBG:normalBackGround,
				eraserButtonBG:normalBackGround,
			});	
		}
	};
	clickShapeButton = () => {
		const {map} = this.state;
		map.resetNorth();
		map.setPitch(0)
		this.shapeDrawing = false;

		if(this.state.isDrawingMode === 3) {
			const centerMark = document.getElementById('centerMark');
			if (centerMark) {
				centerMark.style.pointerEvents = 'auto';
			}
			this.state.map.doubleClickZoom.enable();
			this.setState({isDrawingMode:0});
			map.touchZoomRotate.enable();
			map.dragPan.enable();
			map.getCanvas().style.cursor = 'grab';
			this.changeMarkersPointerEvents(true); // 描画モード終了時にマーカークリックを再有効化（ラベル作成後に無効のまま残る不具合対策）
			this.setState({
				penButtonBG:normalBackGround,
				shapeButtonBG:normalBackGround,
				eraserButtonBG:normalBackGround,
			});
		}
		else {
			const centerMark = document.getElementById('centerMark');
			if (centerMark) {
				centerMark.style.pointerEvents = 'none';
			}

			this.state.map.doubleClickZoom.disable();
			this.setState({isDrawingMode:3});

			map.getCanvas().style.cursor = 'crosshair';

			this.setState({
				penButtonBG:normalBackGround,
				shapeButtonBG:activeBackGround,
				eraserButtonBG:normalBackGround,
			});

			if(!this.state.shapeDrawingMode || this.state.shapeDrawingMode === undefined || this.state.shapeDrawingMode === '') {
				this.setState({
					shapeDrawingMode: 'line',
					lineButtonBG: activeBackGround,
					circleButtonBG: normalBackGround,
					polygonButtonBG: normalBackGround,
					measurementButtonBG: normalBackGround,
					gridButtonBG: normalBackGround,
				});
			}
		}


	};

	//検索
	clickSearchButton = () => {
		this.setState(prevState => ({
			showSearchPopup: !prevState.showSearchPopup
		}));
	};

	handleSearchSubmit = (result) => {
		const { map } = this.state;
		if (map) {
		map.flyTo({
			center: [result.lng, result.lat],
			zoom: 15
		});
		}
		this.setState({ showSearchPopup: false });
	};

	handleSearchClose = () => {
		this.setState({ showSearchPopup: false });
	};

	handleSearchUpdate = (keyword, results) => {
		this.setState({ searchKeyword: keyword, searchResults: results });
	};

	//消しゴム
	clickEraserButton = () => {
		this.endShapeAll();

		const {map} = this.state;
		map.resetNorth();
		map.setPitch(0)
		const t = (key) => translator.t(key);

		if(this.state.isDrawingMode === 2) {
			const centerMark = document.getElementById('centerMark');
			if (centerMark) {
				centerMark.style.pointerEvents = 'auto';
			}
			this.state.map.doubleClickZoom.enable();
			this.setState({isDrawingMode:0});
			map.touchZoomRotate.enable();
			map.dragPan.enable();
			map.getCanvas().style.cursor = 'grab';
			this.setState({ penButtonBG: normalBackGround});
			this.setState({ shapeButtonBG: normalBackGround});
			this.setState({ eraserButtonBG: normalBackGround});

			return;
		}
		const centerMark = document.getElementById('centerMark');
		if (centerMark) {
			centerMark.style.pointerEvents = 'none';
		}

		this.state.map.doubleClickZoom.disable();
		this.setState({isDrawingMode:2});
		map.getCanvas().style.cursor = 'url(/img/eraser.png) 0 32, auto';
		this.setState({ penButtonBG: normalBackGround});
		this.setState({ shapeButtonBG: normalBackGround});
		this.setState({ eraserButtonBG: activeBackGround});
	};

	update3dDistance = (distance) => {
		if(distance < 1000) distance = distance + "m";
		else distance = (distance / 1000).toFixed(1) + "km";
		this.setState({ labelScaleDistance: distance });
	}

	updateProjectCoordinate = async () => {
		if(!this.props.fm || !this.props.fm.auth || !this.props.fm.auth.currentUser || !this.props.fm.auth.currentUser.uid) return;

		const myCollectionPath = `userdata/${this.props.fm.auth.currentUser.uid}/projects/`;
		const center = this.state.map.getCenter();
		const zoomLevel = this.state.map.getZoom();
		let data = null;
		data = {
			lng:center.lng,
			lat:center.lat,
			zoom:zoomLevel,
			updatetime: new Date(),
		};
		try {
			this.props.fm.updateDocument(myCollectionPath, this.props.uuid,data);
		} catch (error) {
			console.error('Failed to updateDocument:', error);
		}

		// 非オーナーの場合、上記は自分の閲覧履歴コピーの更新のみ。
		// 共同編集者ならプロジェクト本体の updatetime も更新する（スロットル付き）。
		if(this.props.fm.auth.currentUser.uid !== this.props.owneruid) {
			this.touchProjectIfEditable();
		}
	}

	// プロジェクト本体の updatetime 更新（オーナー、または共同編集者 permission == 2 のみ）。
	// permission == 1（閲覧のみ）はルールで拒否されるため呼ばない。
	touchProjectIfEditable = () => {
		if(!this.props.fm || !this.props.fm.auth || !this.props.fm.auth.currentUser) return;
		const isOwner = this.props.fm.auth.currentUser.uid === this.props.owneruid;
		if(isOwner || (this.currentProject && this.currentProject.permission === 2)) {
			this.props.fm.touchProjectUpdatetime(this.props.owneruid, this.props.uuid);
		}
	}

	makeThumbnail = async (title) => {
		try {
			const thumbnailUrl = await this.saveMapScreenshotToFirestorage(400,title);
			this.setState({ 
				showThumbnailPopup: true, 
			});
			this.thumbnailUrl = thumbnailUrl;

			if (thumbnailUrl) {
				const myCollectionPath = `userdata/${this.props.owneruid}/projects/`;
				const center = this.state.map.getCenter();
				const zoomLevel = this.state.map.getZoom();

				let data = null;
				data = {
					lng:center.lng,
					lat:center.lat,
					zoom:zoomLevel,
					thumbnailUrl:thumbnailUrl,
				};
				try {
					this.props.fm.updateDocument(myCollectionPath, this.props.uuid,data);
				} catch (error) {
					console.error('Failed to updateDocument:', error);
				}
			}
		} catch (error) {
			console.error('Error creating thumbnail:', error);
			// You might want to show an error message to the user here
		}
	}
	closeThumbnailPopup = () => {
		this.setState({ showThumbnailPopup: false });
	}
	closeImagePopup = () => {
		this.setState({ showImagePopup: false });
	}

	deleteProject = async (title) => {
		const t = (key) => translator.t(key);
        this.showConfirm(CommonUtils.formatString(t('removeConfirm'),title)
			,this
			, (data) => {
				this.showConfirm(CommonUtils.formatString(t('reConfirm'),title)
					,this
					, (data) => {
					this.showConfirm(CommonUtils.formatString(t('rereConfirm'),title)
						,this
						, (data) => {
						this.setState({ showConfirmDialog: false });
							//削除処理
							this.setState({ showConfirmDialog: false,showOkConfirmDialog:false });
							this.props.fm.deleteProject(this.props.uuid, this.props.owneruid
								, () => {
									this.showOkConfirm(t('deleteed'),null
										, (data) => {
											window.location.href = `/top`;
										});
								}
								, (errorMsg) => {
									this.showOkConfirm(t('Error') + ':' + errorMsg,null
										, (data) => {
										});
								}
							);
						}
						,(data) => {
							this.setState({ showConfirmDialog: false });
					});		
					}
					,(data) => {
						this.setState({ showConfirmDialog: false });
				});		
			}
			,(data) => {
				this.setState({ showConfirmDialog: false });
        });		


	}


	handleSetting = () => {
		this.setState(prevState => ({
			showEditProjectPopup: !prevState.showEditProjectPopup
		}));
		//this.setState({ showEditProjectPopup: true });
	};
	closeSettingPopup = () => {
		this.setState({ showEditProjectPopup: false });
	};

	closePopup = () => {
		this.setState({ showAddMarkerPopup: false });
		window.scrollTo(0, 0);
	};



	toggleLMapSetting = () => {
		this.setState(prevState => ({
			showLayerSettingPopup: !prevState.showLayerSettingPopup
		}));
	}
	// handleApplyLayerSettings関数を追加
	handleApplyLayerSettings = (newOverlay, overlayOpacity, newMap, newExaggeration, newBlendMode, gridSettings) => {
		const { map } = this.state;
		if (map) {
			this.currentOverlay = newOverlay;
			this.currentMap = newMap;

			let layerSetting = CommonUtils.overlays[newOverlay];
			if(layerSetting) layerSetting.op = overlayOpacity;

			if (newBlendMode === 'multiply' || newBlendMode === 'normal') {
				CommonUtils.setOverlayBlendMode(newBlendMode);
			}

			// MGRS/UTM グリッド設定を保存して再描画
			let savedGrid = CommonUtils.gridOverlay;
			if (gridSettings) {
				savedGrid = CommonUtils.setGridOverlay(gridSettings);
				this.updateMgrsUtmGrid(map);
			}

			this.setupOverlay(map, newOverlay);
			this.setupBaseMap(map, newMap);

			const collectionPath = `userdata/${this.props.owneruid}/projects/`;
			const data = {
				overlay: newOverlay,
				basemap: newMap,
				updatetime: new Date(),
				exaggeration: newExaggeration,
				gridOverlay: savedGrid,
			};

			// 組み込みオーバーレイ (CommonUtils.overlays) は保存しない。
			// 古い保存データが現コードと衝突するバグを避けるため、組み込みは常にコード定義のみを真とする。
			// （カスタムオーバーレイは customLayers.overlays で別途保存される）

			this.props.fm.updateDocument(collectionPath, this.props.uuid, data)
			.then(() => {
				console.log('handlePhotoUpdateMemo successfully written!');
				this.updateProjectCoordinate();
				this.setState({ exaggeration: newExaggeration });

				this.createTerrainControl(newExaggeration);
				
			})
			.catch((error) => {
				console.error('Failed to write handlePhotoUpdateMemo:', error);
			});
		}
	}

	createTerrainControl(exaggeration = 1) {
		const { map } = this.state;
		if (map) {
			// 既存の TerrainControl があれば削除
			if (this.terrainControl) {
				map.removeControl(this.terrainControl);
			}

			// 新しい TerrainControl を作成
			this.terrainControl = new maplibregl.TerrainControl({
				source: 'terrain',
				exaggeration: exaggeration
			});

			map.addControl(this.terrainControl, 'top-right');
		}
	}


	// カスタムレイヤーの更新用関数
	updateCustomLayer = (type, key, updatedLayer) => {
		if (type === 'overlay') {
			this.customOverlays[key] = updatedLayer;
		} else if (type === 'map') {
			this.customMaps[key] = updatedLayer;
		}
		// カスタムレイヤーの保存
		const customOverlays = Object.entries(this.customOverlays)
			.filter(([key, value]) => value.url)
			.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

		const customMaps = Object.entries(this.customMaps)
			.filter(([key, value]) => value.url)
			.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

		const collectionPath = `userdata/${this.props.owneruid}/projects/`;
		const data = {
			updatetime: new Date(),
		};
		if (Object.keys(customOverlays).length > 0 || Object.keys(customMaps).length > 0) {
			data.customLayers = {
				overlays: customOverlays,
				maps: customMaps
			};
		}

		this.props.fm.updateDocument(collectionPath, this.props.uuid, data)
		.then(() => {
			console.log('handlePhotoUpdateMemo successfully written!');
			this.updateProjectCoordinate();
		})
		.catch((error) => {
			console.error('Failed to write handlePhotoUpdateMemo:', error);
		});

	}


	toggleLayerListPanel = () => {
		this.setState(prevState => ({
			showLayerListPanel: !prevState.showLayerListPanel
		}));
	}
	
	toggleDataListPanel = () => {
		this.setState(prevState => ({
			showDataListPanel: !prevState.showDataListPanel
		}));
	}
	
	handleDeleteFile = (file) => {
		const { map } = this.state;

		console.log('handleDeleteFile:' + file.id);
		console.log('handleDeleteFile:' + file.data.owneruid);
		console.log('handleDeleteFile:' + file.data.fileName);
		const uuid = this.props.uuid;
		const owneruid = this.props.owneruid;

		const t = (key) => translator.t(key);
		this.showConfirm(
			CommonUtils.formatString(t('removeConfirm'),file.fileTitle),
			file.data,
			(data) => {
				const source = map.getSource(file.id);
				if(source) source.setData([]);
				this.currentLine = [];

				if(file.data.type === 2) {//手書き
					this.rebuidDrawLayer(map,file.id);
				}
				else if(file.data.type === 3) {//図形
					this.rebuidShapeLayer(map,file.id);
				}
				else if(file.data.type === 4) {//ファイル
					const style = map.getStyle();
					const sources = Object.keys(style.sources).filter(sourceId => sourceId.includes(file.id));
					const layers = style.layers.filter(layer => layer.id.includes(file.id)).map(layer => layer.id);

					sources.forEach(sourceId => {
						const source = map.getSource(sourceId);
						if (source) {
							source.setData([]);
						}
					});
					layers.forEach(layerId => {
						map.removeLayer(layerId);
					});

				}
				this.setState(prevState => ({
					files: prevState.files.filter(item => item.id !== file.id)
				}));
				this.setState({ showConfirmDialog: false });
				// FileHandlerの削除ロジックを呼び出す
				if (this.fileHandler) {
					this.fileHandler.deleteFile(owneruid,file.id,data);
				}
			},
			() => {
				this.setState({ showConfirmDialog: false });
			}
		);
		
	}
	rebuidDrawLayer(map,id) {
		const source = map.getSource(id);
		if(source) {
			// まずソースのデータを空にする
			source.setData({
				type: 'FeatureCollection',
				features: []
			});
		}

		// レイヤーの削除（label レイヤーも含める）
		if(map.getLayer(id)) {
			map.removeLayer(id);
		}
		if(map.getLayer(id + '-label')) {
			map.removeLayer(id + '-label');
		}
		if(map.getLayer(id + '-grid-label')) {
			map.removeLayer(id + '-grid-label');
		}
		if(map.getLayer(id + '-grid-cell-label')) {
			map.removeLayer(id + '-grid-cell-label');
		}
		if(map.getLayer(id + '-user-label')) {
			map.removeLayer(id + '-user-label');
		}

		// ソースの削除
		if(map.getSource(id)) {
			map.removeSource(id);
		}
		this.undoHistory = [];
		this.redoHistory = [];
		if(id === this.myDrawing) {
			this.addDrawingSource(map,id);
			this.addDrawingLayer(map,id);
			console.log('addDrawingSource:addDrawingLayer');							
		}
	}
	rebuidShapeLayer(map,id) {
		const source = map.getSource(id);
		if(source) {
			// まずソースのデータを空にする
			source.setData({
				type: 'FeatureCollection',
				features: []
			});
		}

		// 関連するすべてのレイヤーを削除
		if(map.getLayer(id + '-fill')) {
			map.removeLayer(id + '-fill');
		}
		if(map.getLayer(id + '-outline')) {
			map.removeLayer(id + '-outline');
		}
		if(map.getLayer(id + '-label')) {
			map.removeLayer(id + '-label');
		}
		if(map.getLayer(id + '-center-point-layer')) {
			map.removeLayer(id + '-center-point-layer');
		}

		// ソースの削除
		if(map.getSource(id)) {
			map.removeSource(id);
		}

		if(id === this.myShape) {
			this.addShapeLayer(map,id);
			this.addLabelSourceAndLayer(map,id);
		}
	}

	onDeleteMarker = (marker) => {
		this.markerRemove(marker.marker);
	}
	onDeletePhoto = (photo) => {
		this.handlePtohoDelete(photo);
	}

	clickLineButton = () => {
		this.setState({
			shapeDrawingMode: 'line',
			lineButtonBG: activeBackGround,
			circleButtonBG: normalBackGround,
			polygonButtonBG: normalBackGround,
			measurementButtonBG: normalBackGround,
			gridButtonBG: normalBackGround,
			labelButtonBG: normalBackGround,
		});
	};

	clickMeasurementButton = () => {
		this.setState({
			shapeDrawingMode: 'measurement',
			lineButtonBG: normalBackGround,
			circleButtonBG: normalBackGround,
			polygonButtonBG: normalBackGround,
			measurementButtonBG: activeBackGround,
			gridButtonBG: normalBackGround,
			labelButtonBG: normalBackGround,
		});
	};

	clickCircleButton = () => {
		this.setState({
			shapeDrawingMode: 'circle',
			lineButtonBG: normalBackGround,
			circleButtonBG: activeBackGround,
			polygonButtonBG: normalBackGround,
			measurementButtonBG: normalBackGround,
			gridButtonBG: normalBackGround,
			labelButtonBG: normalBackGround,
		});
	};


	clickPolygonButton = () => {
		this.setState({
			shapeDrawingMode: 'polygon',
			lineButtonBG: normalBackGround,
			circleButtonBG: normalBackGround,
			polygonButtonBG: activeBackGround,
			measurementButtonBG: normalBackGround,
			gridButtonBG: normalBackGround,
			labelButtonBG: normalBackGround,
		});
	};

	clickGridButton = () => {
		this.setState({
			shapeDrawingMode: 'grid',
			lineButtonBG: normalBackGround,
			circleButtonBG: normalBackGround,
			polygonButtonBG: normalBackGround,
			measurementButtonBG: normalBackGround,
			gridButtonBG: activeBackGround,
			labelButtonBG: normalBackGround,
			labelButtonBG: normalBackGround,
		});
	};

	// ラベル追加ボタン（ラベルモードのトグル）
	clickLabelButton = () => {
		if (this.state.labelMode) {
			// ラベルモード解除
			this.setState({
				labelMode: false,
				labelButtonBG: normalBackGround,
				showLabelAddPopup: false,
				pendingLabelLngLat: null,
			});
			return;
		}
		// ラベルモードへ入る（他の描画ツールを解除）
		this.setState({
			shapeDrawingMode: 'label',
			lineButtonBG: normalBackGround,
			circleButtonBG: normalBackGround,
			polygonButtonBG: normalBackGround,
			measurementButtonBG: normalBackGround,
			gridButtonBG: normalBackGround,
			labelButtonBG: activeBackGround,
			showLabelAddPopup: false,
			pendingLabelLngLat: null,
		});
	};

	// ラベル追加ダイアログを閉じる（モードは解除しない）
	closeLabelAddPopup = () => {
		this.setState({
			showLabelAddPopup: false,
			pendingLabelLngLat: null,
		});
	};

	// ラベル編集ダイアログを閉じる
	closeLabelEditPopup = () => {
		this.setState({
			showLabelEditPopup: false,
			editingLabelFeature: null,
		});
	};

	// 現在の drawing ソース・レイヤを取得（無ければ追加）
	ensureDrawingSource = () => {
		const { map } = this.state;
		if (!map || !this.myDrawing) return null;
		let source = map.getSource(this.myDrawing);
		if (!source) {
			source = this.addDrawingSource(map, this.myDrawing);
		}
		// レイヤ本体が無ければ追加（直線/ラベル/グリッドセルラベル等をまとめて登録）
		if (map.getLayer(this.myDrawing) === undefined) {
			this.addDrawingLayer(map, this.myDrawing);
		}
		return source;
	};

	// 指定内容でラベル feature を drawing ソースに追加
	addLabelFeature = ({ lng, lat, label, fontSize, color, haloColor }) => {
		const source = this.ensureDrawingSource();
		if (!source) return null;
		this.addToHistory(); // アンドゥ用に変更前の状態を保存
		const data = source._data || { type: 'FeatureCollection', features: [] };
		const labelId = CommonUtils.generateUUID();
		const feature = {
			type: 'Feature',
			geometry: { type: 'Point', coordinates: [lng, lat] },
			properties: {
				color: color || this.state.selectedColor,
				haloColor: haloColor || this.getHaloColor(color || this.state.selectedColor),
				gridCellLabel: true,
				userLabel: true,
				labelId,
				label,
				fontSize: fontSize,
			},
		};
		data.features.push(feature);
		source.setData(data);
		this.syncLabelMarkers(this.myDrawing, data);
		this.updateDrawingData(2, data, _drawingTag, lng, lat);
		return feature;
	};

	// 追加ダイアログから呼ばれる
	handleAddLabel = (text, fontSize, color) => {
		const { map, pendingLabelLngLat } = this.state;
		if (!map) return;
		const pt = pendingLabelLngLat || map.getCenter();
		this.addLabelFeature({
			lng: pt.lng,
			lat: pt.lat,
			label: text,
			fontSize: fontSize,
			color: color,
		});
		const newSettings = { fontSize, color: color || this.state.labelSettings.color };
		localStorage.setItem('labelSettings', JSON.stringify(newSettings));
		// ダイアログは閉じる（ラベルモードは維持）
		this.setState({
			labelSettings: newSettings,
			showLabelAddPopup: false,
			pendingLabelLngLat: null,
		});
	};

	// 編集ダイアログから呼ばれる
	handleSaveLabel = (text, fontSize, color) => {
		const editing = this.state.editingLabelFeature;
		if (!editing) { this.closeLabelEditPopup(); return; }
		const { map } = this.state;
		if (!map) { this.closeLabelEditPopup(); return; }
		const source = map.getSource(this.myDrawing);
		if (!source) { this.closeLabelEditPopup(); return; }
		const data = source._data;
		const idx = (data.features || []).findIndex(f =>
			f && f.properties && f.properties.userLabel && f.properties.labelId === editing.labelId);
		if (idx >= 0) {
			this.addToHistory(); // アンドゥ用に変更前の状態を保存
			data.features[idx].properties.label = text;
			data.features[idx].properties.fontSize = fontSize;
			if (color) {
				data.features[idx].properties.color = color;
				data.features[idx].properties.haloColor = this.getHaloColor(color);
			}
			source.setData(data);
			this.syncLabelMarkers(this.myDrawing, data);
			const [lng, lat] = data.features[idx].geometry.coordinates;
			this.updateDrawingData(2, data, _drawingTag, lng, lat);
			const newSettings = { fontSize, color: color || this.state.labelSettings.color };
			localStorage.setItem('labelSettings', JSON.stringify(newSettings));
			this.setState({ labelSettings: newSettings });
		}
		this.closeLabelEditPopup();
	};

	// userLabel は -user-label シンボルレイヤーで描画される（source.setData に自動追従）。
	// 旧実装の DOM マーカー描画は 3D(terrain)時に毎フレームの遮蔽判定(gl.readPixels)で
	// ラベル数に比例して重くなるため廃止した。残存 DOM マーカーがあれば除去するだけ。
	syncLabelMarkers = (sourceId, data) => {
		if (!this.labelMarkersBySource) return;
		const sourceMarkers = this.labelMarkersBySource.get(sourceId);
		if (!sourceMarkers) return;
		for (const marker of sourceMarkers.values()) {
			marker.remove();
		}
		this.labelMarkersBySource.delete(sourceId);
	};

	// ラベル feature クリック時のメニューポップアップ
	openLabelMenuPopup = (feature, lngLat) => {
		const { map } = this.state;
		if (!map) return;
		if (!feature || !feature.properties) return;
		if (feature.properties.userLabel !== true) return;
		const t = (key) => translator.t(key);

		if (this.currentLabelMenuPopup) {
			try { this.currentLabelMenuPopup.remove(); } catch (e) {}
			this.currentLabelMenuPopup = null;
		}

		const labelText = (feature.properties.label || '').replace(/[&<>"']/g,
			(c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))
			.replace(/\n/g, '<br>');//複数行ラベル

		const html = `<h3>${labelText}</h3><p></p>` +
			`<button class="buttonBlue_s" id="labelEditButton">${t('edit')}</button>` +
			`<button class="buttonBlue_s" id="labelMoveButton">${t('move')}</button>` +
			`<button class="buttonBlue_s" id="labelCopyButton">${t('copy')}</button>` +
			`<button class="buttonBlue_s" id="labelCopyButtonB">${t('copyB')}</button>` +
			`<br>` +
			`<button class="buttonRed_s" id="labelRemoveButton">${t('delete')}</button>`;

		const labelId = feature.properties.labelId;

		const popup = new maplibregl.Popup({ closeOnClick: true })
			.setLngLat(lngLat)
			.setHTML(html)
			.addTo(map);

		this.currentLabelMenuPopup = popup;

		// addTo() renders HTML synchronously — bind handlers immediately
		const editBtn = document.getElementById('labelEditButton');
		const moveBtn = document.getElementById('labelMoveButton');
		const copyBtn = document.getElementById('labelCopyButton');
		const copyBBtn = document.getElementById('labelCopyButtonB');
		const removeBtn = document.getElementById('labelRemoveButton');
		if (editBtn) editBtn.addEventListener('click', () => { popup.remove(); this.labelEdit(labelId); });
		if (moveBtn) moveBtn.addEventListener('click', () => { popup.remove(); this.labelMove(labelId); });
		if (copyBtn) copyBtn.addEventListener('click', () => { popup.remove(); this.labelCopy(labelId); });
		if (copyBBtn) copyBBtn.addEventListener('click', () => { popup.remove(); this.copyLabelToClipboard(labelId); });
		if (removeBtn) removeBtn.addEventListener('click', () => { popup.remove(); this.labelRemove(labelId); });
	};

	findLabelFeature = (labelId) => {
		const { map } = this.state;
		if (!map || !this.myDrawing) return null;
		const source = map.getSource(this.myDrawing);
		if (!source) return null;
		const data = source._data;
		if (!data || !data.features) return null;
		return data.features.find(f =>
			f && f.properties && f.properties.userLabel && f.properties.labelId === labelId) || null;
	};

	labelEdit = (labelId) => {
		const feature = this.findLabelFeature(labelId);
		if (!feature) return;
		this.setState({
			editingLabelFeature: {
				labelId: labelId,
				text: feature.properties.label || '',
				fontSize: feature.properties.fontSize || 20,
				color: feature.properties.color || '#FF0000',
			},
			showLabelEditPopup: true,
		});
	};

	// 移動（一時マーカーを重ねてドラッグ）
	labelMove = (labelId) => {
		const { map } = this.state;
		if (!map || !this.myDrawing) return;
		const source = map.getSource(this.myDrawing);
		if (!source) return;
		const data = source._data;
		const idx = (data.features || []).findIndex(f =>
			f && f.properties && f.properties.userLabel && f.properties.labelId === labelId);
		if (idx < 0) return;
		const feature = data.features[idx];
		const [lng, lat] = feature.geometry.coordinates;
		const props = feature.properties;

		this.addToHistory(); // アンドゥ用に変更前の状態を保存
		data.features.splice(idx, 1);
		source.setData(data);
		this.syncLabelMarkers(this.myDrawing, data);

		const el = document.createElement('div');
		el.className = 'blinking-marker';
		el.style.display = 'inline-block';
		el.style.whiteSpace = 'pre';//複数行ラベルの改行を保つ（自動折り返しはしない）
		el.style.textAlign = 'center';
		el.style.lineHeight = '1.2';
		el.style.fontWeight = 'bold';
		el.style.fontSize = (props.fontSize || 20) + 'px';
		el.style.color = props.color || '#000000';
		el.style.textShadow = `-1px -1px 0 ${props.haloColor || '#ffffff'}, 1px -1px 0 ${props.haloColor || '#ffffff'}, -1px 1px 0 ${props.haloColor || '#ffffff'}, 1px 1px 0 ${props.haloColor || '#ffffff'}`;
		el.style.pointerEvents = 'auto';
		el.style.cursor = 'move';
		el.textContent = props.label || '';

		const temp = new maplibregl.Marker({ element: el, draggable: true, anchor: 'center' })
			.setLngLat([lng, lat])
			.addTo(map);

		const finalize = () => {
			const pos = temp.getLngLat();
			temp.remove();
			const curSource = map.getSource(this.myDrawing);
			if (!curSource) return;
			const curData = curSource._data || { type: 'FeatureCollection', features: [] };
			const restored = {
				type: 'Feature',
				geometry: { type: 'Point', coordinates: [pos.lng, pos.lat] },
				properties: { ...props },
			};
			curData.features.push(restored);
			curSource.setData(curData);
			this.syncLabelMarkers(this.myDrawing, curData);
			this.updateDrawingData(2, curData, _drawingTag, pos.lng, pos.lat);
		};

		temp.on('dragend', finalize);
	};

	labelCopy = (labelId) => {
		const feature = this.findLabelFeature(labelId);
		if (!feature) return;
		const [lng, lat] = feature.geometry.coordinates;
		this.addLabelFeature({
			lng: lng + 0.0001,
			lat: lat + 0.0001,
			label: feature.properties.label,
			fontSize: feature.properties.fontSize,
			color: feature.properties.color,
			haloColor: feature.properties.haloColor,
		});
	};

	copyLabelToClipboard = async (labelId) => {
		const feature = this.findLabelFeature(labelId);
		if (!feature) return;
		const [lng, lat] = feature.geometry.coordinates;
		const p = feature.properties || {};
		const clipboardData = {
			app: 'CollaboMap-Label',
			lng, lat,
			label: p.label,
			fontSize: p.fontSize,
			color: p.color,
			haloColor: p.haloColor,
		};
		try {
			await navigator.clipboard.writeText(JSON.stringify(clipboardData, null, 2));
			const t = (key) => translator.t(key);
			toast(t('confirmCopyClipboard'), { autoClose: 1000 });
		} catch (err) {
			console.error('Failed to copy label data: ', err);
		}
	};

	labelRemove = (labelId) => {
		const feature = this.findLabelFeature(labelId);
		if (!feature) return;
		const t = (key) => translator.t(key);
		const name = feature.properties.label || t('Label');
		this.showConfirm(
			CommonUtils.formatString(t('removeConfirm'), name),
			{ labelId },
			(data) => {
				this.setState({ showConfirmDialog: false });
				const { map } = this.state;
				if (!map || !this.myDrawing) return;
				const source = map.getSource(this.myDrawing);
				if (!source) return;
				this.addToHistory(); // アンドゥ用に変更前の状態を保存
				const src = source._data;
				src.features = (src.features || []).filter(f =>
					!(f && f.properties && f.properties.userLabel && f.properties.labelId === data.labelId));
				source.setData(src);
				this.syncLabelMarkers(this.myDrawing, src);
				const c = map.getCenter();
				this.updateDrawingData(2, src, _drawingTag, c.lng, c.lat);
			},
			() => {
				this.setState({ showConfirmDialog: false });
			}
		);
	};

    clickChatButton = () => {
        this.setState(prevState => ({
            showChatPanel: !prevState.showChatPanel
        }));
    };

	handlePhotoUpdateMemo = (photoId,memo) => {
		console.log(`handlePhotoUpdateMemo:${photoId} / ${memo}`);
		DiagLog.add(`[photo] memo write ${photoId} len=${memo ? memo.length : 0} sel=${this.state.selectedPhoto ? this.state.selectedPhoto.docId : '-'} idx=${this.state.currentPhotoIndex}`);

		const uuid = this.props.uuid;
		const owneruid = this.props.owneruid;
		const collectionPath = `userdata/${owneruid}/projects/${uuid}/items`;
		const data = {
			note: memo,
			instanceid: this.instanceID,
            updatetime: new Date(),
		};

		this.props.fm.updateDocument(collectionPath, photoId, data)
		.then(() => {
			console.log('handlePhotoUpdateMemo successfully written!');
			this.updateProjectCoordinate();
		})
		.catch((error) => {
			console.error('Failed to write handlePhotoUpdateMemo:', error);
		});
	}

	handlePtohoDelete = (photo) => {
		const t = (key) => translator.t(key);
		this.showConfirm(
			t('DeletePhotoConfirmation'),
			photo,
			(data) => {
				this.setState({ showConfirmDialog: false });
				// FileHandlerの削除ロジックを呼び出す
				if (this.fileHandler) {
					this.fileHandler.deletePhoto(data);
					this.removeMarkerFromMap(data.docId);
				}
				// 写真ビューアを閉じる
				this.closePhotoViewer();
			},
			() => {
				this.setState({ showConfirmDialog: false });
			}
		);
	};

	handlePtohoMove = (photo) => {
		this.closePhotoViewer();
		const markerObj =  this.markers.find(markerObj => markerObj.id === photo.docId);
		if(markerObj && markerObj.marker) {
			markerObj.marker.startMove();
		}
	};


	captureMapScreenshot = (sizeWidth, sizeHeight, title) => {
		return new Promise((resolve, reject) => {
			const { map } = this.state;
			if (!map) {
			reject(new Error("Map is not initialized"));
			return;
			}
			this.setState({ isShowUI: false });
			const thumbnailPopup = document.getElementById('thumbnailPopup');
			if (thumbnailPopup) thumbnailPopup.style.display = 'none';

			let captureAttempted = false;

			const captureMap = () => {
			if (captureAttempted) return;
			captureAttempted = true;

			try {
				// map.getCanvas().toDataURL() で地図のキャンバスを画像として取得
				const imageData = map.getCanvas().toDataURL('image/png');

				// 画像のロードが完了するまで待機
				const img = new Image();
				img.onload = () => {
				// 現在のマップのサイズを取得
				const width = img.width;
				const height = img.height;

				// 正方形のサイズを決定（短い辺に合わせる）
				const size = Math.min(width, height);

				// 切り取り開始位置を計算（中央に配置）
				const startX = (width - size) / 2;
				const startY = (height - size) / 2;

				// 一時的なキャンバスを作成して正方形部分を切り出す
				const tempCanvas = document.createElement('canvas');
				tempCanvas.width = size;
				tempCanvas.height = size;
				const tempCtx = tempCanvas.getContext('2d');
				tempCtx.drawImage(img, startX, startY, size, size, 0, 0, size, size);

				// 指定されたサイズにリサイズ
				const outputCanvas = document.createElement('canvas');
				outputCanvas.width = sizeWidth;
				outputCanvas.height = sizeHeight;
				const outputCtx = outputCanvas.getContext('2d');
				outputCtx.imageSmoothingEnabled = true;
				outputCtx.imageSmoothingQuality = 'high';
				outputCtx.drawImage(tempCanvas, 0, size / 8, size, size / 2, 0, 0, outputCanvas.width, outputCanvas.height);

				// マーカーを描画
				const scale = window.devicePixelRatio || 1;
				if (this.markers && this.markers.length > 0) {
					for (const markerObj of this.markers) {
						const markerInstance = markerObj.marker;
						if (!markerInstance || !markerInstance.marker) continue;

						const mlMarker = markerInstance.marker; // maplibregl.Marker
						const lngLat = mlMarker.getLngLat();
						const cssPoint = map.project(lngLat); // CSS pixels

						// CSS pixels → canvas pixels
						const canvasX = cssPoint.x * scale;
						const canvasY = cssPoint.y * scale;

						// 第1クロップ後の座標
						const croppedX = canvasX - startX;
						const croppedY = canvasY - startY;

						// 第2クロップ・リサイズ後の出力座標
						const outX = croppedX / size * outputCanvas.width;
						const outY = (croppedY - size / 8) / (size / 2) * outputCanvas.height;

						// アイコンサイズを出力スケールに合わせる
						const iconCSSSize = markerInstance.size || 60;
						const iconOutSize = iconCSSSize * scale * (outputCanvas.width / size);

						const element = mlMarker.getElement();

						// 画面範囲内のマーカーのみ描画
						if (outX >= -iconOutSize && outX <= outputCanvas.width + iconOutSize &&
							outY >= -iconOutSize && outY <= outputCanvas.height + iconOutSize) {
							outputCtx.drawImage(element,
								outX - iconOutSize / 2,
								outY - iconOutSize / 2,
								iconOutSize, iconOutSize);
						}
					}
				}

				// ユーザーラベルは -user-label シンボルレイヤー描画のため
				// 地図キャンバス自体に含まれる（手描き不要）

				// タイトルを描画
				const color = CommonUtils.numberToHexColor(CommonUtils.colors[this.props.myColor]);

				// フォントサイズを計算
				const maxWidth = outputCanvas.width * 0.9; // 画像幅の90%を最大幅とする
				const calculateFontSize = (ctx, text, maxWidth) => {
					let fontSize = 50; // 開始フォントサイズ
					ctx.font = `bold ${fontSize}px Arial`;
					while (ctx.measureText(text).width > maxWidth && fontSize > 10) {
					fontSize--;
					ctx.font = `bold ${fontSize}px Arial`;
					}
					return fontSize;
				};

				if (title.length > 0) {
					const fontSize = calculateFontSize(outputCtx, title, maxWidth);
					outputCtx.font = `bold ${fontSize}px Arial`;
					outputCtx.textAlign = 'center';
					outputCtx.textBaseline = 'middle';

					// 縁取りを描画
					outputCtx.strokeStyle = 'white';
					outputCtx.lineWidth = Math.max(2, fontSize / 10); // フォントサイズに応じて線の太さを調整
					outputCtx.strokeText(title, outputCanvas.width / 2, outputCanvas.height / 2);

					// タイトルを描画
					outputCtx.fillStyle = color;
					outputCtx.fillText(title, outputCanvas.width / 2, outputCanvas.height / 2);
				}

				// 最終的な画像データを生成
				const outputImageData = outputCanvas.toDataURL('image/jpeg', 0.95);

				// UIを再表示する
				this.setState({ isShowUI: true });

				// サムネイルポップアップを再表示する
				if (thumbnailPopup) thumbnailPopup.style.display = 'block';

				resolve(outputImageData);
				};
				img.onerror = (error) => {
				reject(new Error("Failed to load image: " + error.message));
				};
				img.src = imageData;
			} catch (error) {
				this.showOkConfirm(error.message, null, (data) => {
				this.setState({ showOkConfirmDialog: false });
				});
				this.setState({ isShowUI: true });
				if (thumbnailPopup) thumbnailPopup.style.display = 'block';
				reject(error);
			}
			};

			// マップのレンダリングが完了したタイミングでスクリーンショットを取得
			const onRender = () => {
			captureMap();
			};

			map.on('render', onRender);
			map.triggerRepaint();

			// フォールバックとしてのタイムアウト
			setTimeout(() => {
				if (!captureAttempted) {
					console.warn('Capture timeout reached, forcing capture');
					captureMap();
				}
			}, 5000); // 5秒後にフォールバック
		});
	};

/*captureMapFullScreenshot = () => {
    return new Promise((resolve, reject) => {
        const { map } = this.state;
        if (!map) {
            reject(new Error("Map is not initialized"));
            return;
        }
        
        this.setState({ isShowUI: false });

        const mapContainer = document.getElementById('mapView'); // MapLibre の親要素を取得
        if (!mapContainer) {
            this.setState({ isShowUI: true });
            reject(new Error("Map container not found"));
            return;
        }

        let captureAttempted = false;

        const captureMap = () => {
            if (captureAttempted) return;
            captureAttempted = true;

            try {
                const scale = window.devicePixelRatio;
                const width = mapContainer.clientWidth * scale;
                const height = mapContainer.clientHeight * scale;

                domtoimage.toPng(mapContainer, {
                    quality: 0.95,
                    bgcolor: 'white',
                    width: width,
                    height: height,
                    style: {
                        transform: `scale(${scale})`,
                        transformOrigin: 'top left',
                        width: `${mapContainer.clientWidth}px`,
                        height: `${mapContainer.clientHeight}px`,
                    }
                }).then((dataUrl) => {
                    this.setState({ isShowUI: true });
                    resolve(dataUrl);
                }).catch((error) => {
                    console.error('Error capturing screenshot:', error);
                    this.setState({ isShowUI: true });
                    reject(error);
                });

            } catch (error) {
                console.error("Capture failed:", error);
                this.setState({ isShowUI: true });
                reject(error);
            }
        };

        // マップがレンダリングされるたびにキャプチャ試行
        const onRender = () => {
            captureMap();
        };

        map.on('render', onRender);
        map.triggerRepaint();

        // 5秒後に強制キャプチャ
        setTimeout(() => {
            if (!captureAttempted) {
                console.warn('Capture timeout reached, forcing capture');
                captureMap();
            }
        }, 5000);
    });
};*/
	//フルスクリーンのスクリーンショット処理
	//変数の調整がいまいち
	captureMapFullScreenshot = () => {
		return new Promise((resolve, reject) => {
			const { map } = this.state;
			if (!map) {
				reject(new Error("Map is not initialized"));
				return;
			}
			this.setState({ isShowUI: false });

			let captureAttempted = false;
			const captureMap = () => {
				if (captureAttempted) return;
				captureAttempted = true;

				try {
					// map.getCanvas().toDataURL() で地図のキャンバスを画像として取得
					const imageData = map.getCanvas().toDataURL('image/png');
					// 画像のロードが完了するまで待機
					const img = new Image();
					img.onload = () => {
						// ドキュメント全体の高さと幅を取得
						const fullHeight = Math.max(
							document.body.scrollHeight,
							document.documentElement.scrollHeight,
							document.body.offsetHeight,
							document.documentElement.offsetHeight,
							document.body.clientHeight,
							document.documentElement.clientHeight,
							window.visualViewport.height // デバイスピクセルに変換
						) * window.devicePixelRatio;
							const fullWidth = Math.max(
							document.body.scrollWidth,
							document.documentElement.scrollWidth,
							document.body.offsetWidth,
							document.documentElement.offsetWidth,
							document.body.clientWidth,
							document.documentElement.clientWidth,
							window.visualViewport.width  // デバイスピクセルに変換
						) * window.devicePixelRatio;

						// 一時的なキャンバスを作成
						const tempCanvas = document.createElement('canvas');
						tempCanvas.width = fullWidth;
						tempCanvas.height = fullHeight;
						const tempCtx = tempCanvas.getContext('2d');

						// 地図の画像をキャンバスに描画
		//				tempCtx.drawImage(img, 0, 0);
						let xm = 0.9,ym = 0.85;
						if(CommonUtils.isIOS() || CommonUtils.isAndroid()) {
							xm = 1.0;
							ym = 0.9;
						}

						tempCtx.drawImage(img, 0,0, fullWidth*xm, fullHeight*ym, 0, 0, fullWidth, fullHeight);

						// マーカーを描画
						const scale = window.devicePixelRatio || 1;
						if (this.markers && this.markers.length > 0) {
							for (const markerObj of this.markers) {
								const markerInstance = markerObj.marker;
								if (!markerInstance || !markerInstance.marker) continue;

								const mlMarker = markerInstance.marker; // maplibregl.Marker
								const lngLat = mlMarker.getLngLat();
								const cssPoint = map.project(lngLat); // CSS pixels

								// CSS pixels → canvas pixels → output pixels
								const outX = cssPoint.x * scale / xm;
								const outY = cssPoint.y * scale / ym;

								// アイコンサイズを出力スケールに合わせる
								const iconCSSSize = markerInstance.size || 60;
								const iconOutSize = iconCSSSize * scale / xm;

								const element = mlMarker.getElement();

								// 画面範囲内のマーカーのみ描画
								if (outX >= -iconOutSize && outX <= fullWidth + iconOutSize &&
									outY >= -iconOutSize && outY <= fullHeight + iconOutSize) {
									tempCtx.drawImage(element,
										outX - iconOutSize / 2,
										outY - iconOutSize / 2,
										iconOutSize, iconOutSize);
								}
							}
						}

						// ユーザーラベルは -user-label シンボルレイヤー描画のため
						// 地図キャンバス自体に含まれる（手描き不要）

						// 最終的な画像データを生成
						const outputImageData = tempCanvas.toDataURL('image/jpeg', 0.95);

						// UIを再表示する
						this.setState({ isShowUI: true });

						resolve(outputImageData);
					};
					img.onerror = (error) => {
						this.showOkConfirm(error.message, null, (data) => {
							this.setState({ showOkConfirmDialog: false });
						});
						reject(new Error("Failed to load image: " + error.message));
					};
					img.src = imageData;
				} catch (error) {
					this.showOkConfirm(error.message, null, (data) => {
						this.setState({ showOkConfirmDialog: false });
					});
					this.setState({ isShowUI: true });
					reject(error);
				}
			};

			// マップのレンダリングが完了したタイミングでスクリーンショットを取得
			const onRender = () => {
				captureMap();
			};

			map.on('render', onRender);
			map.triggerRepaint();

			// フォールバックとしてのタイムアウト
			setTimeout(() => {
				if (!captureAttempted) {
					console.warn('Capture timeout reached, forcing capture');
					captureMap();
				}
			}, 5000); // 5秒後にフォールバック
		});
	};

	// Toggle the center mark menu
	toggleCenterMarkMenu = (e) => {
		// Stop event propagation to prevent the click from reaching the map
		if (e && e.stopPropagation) {
			e.stopPropagation();
		}
		
		this.setState(prevState => ({
			showCenterMarkMenu: !prevState.showCenterMarkMenu
		}));
	}
		// Open Google Maps at the current center coordinates
	openGoogleMaps = (e) => {
		if (e && e.stopPropagation) {
			e.stopPropagation();
		}
		
		const { map } = this.state;
		if (!map) return;
		
		const center = map.getCenter();
		const lat = center.lat;
		const lng = center.lng;
		const zoom = Math.round(map.getZoom()); // 現在のズームレベルを取得（四捨五入）
		
		// Google マップの URL に緯度、経度、ズームレベルを渡す
		const url = `https://www.google.com/maps/@${lat},${lng},${zoom}z`;
		window.open(url, '_blank');
		
		this.setState({ showCenterMarkMenu: false });
	}

	openStreetView = (e) => {
		if (e && e.stopPropagation) {
			e.stopPropagation();
		}
		const { map } = this.state;
		if (!map) return;
		
		const center = map.getCenter();
		const lat = center.lat;
		const lng = center.lng;
		
		// ストリートビューを直接開くための正しいURL形式
		const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}`;
		window.open(url, '_blank');
		
		this.setState({ showCenterMarkMenu: false });
	}

	// Show weather forecast for the current location
	showWeatherForecast = async (e) => {
		if (e && e.stopPropagation) {
			e.stopPropagation();
		}
		const { map } = this.state;
		if (!map) return;
		
		const center = map.getCenter();
		const lat = center.lat;
		const lng = center.lng;
		
		try {
			// Open a weather service in a new tab
			// You could potentially integrate with a weather API here instead
			let url;
			if(lat > 22.365 && lat < 47.055 && lng > 120.194 && lng < 149.492) {
				url = `https://www.windy.com/${lat}/${lng}/jmaMsm?jmaMsm,rain,${lat},${lng}`;
			}
			else {
				url = `https://www.windy.com/${lat}/${lng}?rain,${lat},${lng}`;
			}
			
			window.open(url, '_blank');
		} catch (error) {
			console.error('Error fetching weather forecast:', error);
			this.showOkConfirm('天気予報の取得に失敗しました', null, () => {
			this.setState({ showOkConfirmDialog: false });
			});
		}
		
		this.setState({ showCenterMarkMenu: false });
	}

	// Create a marker at the center of the map
	createMarkerAtCenter = async (e) => {
		if (e && e.stopPropagation) {
			e.stopPropagation();
		}
		const { map } = this.state;
		if (!map) return;
		if(!this.checkMarkerLimit()) {
			this.setState({ showCenterMarkMenu: false });
			return;
		}
		
		const center = map.getCenter();
		const lat = center.lat;
		const lng = center.lng;
		
		// Get elevation for the center point
		let elevation = "0";
		try {
			elevation = await elevationService.getElevation(lat, lng);
		} catch (error) {
			console.error('Error fetching elevation:', error);
		}
		
		// Prepare marker data
		const markerData = {
			lat: lat,
			lng: lng,
			elevation: elevation,
			name: "",
			note: "",
			iconNumber: this.defaultIconNumber || 0
		};
		
		// Show the add marker popup with pre-filled coordinates
		this.setState({ 
			showAddMarkerPopup: true,
			showCenterMarkMenu: false
		});
		
		// If we have a reference to the AddMarkerPopup component, we could pre-fill its fields:
		if (this.addMarkerPopupRef && this.addMarkerPopupRef.current) {
			this.addMarkerPopupRef.current.setMarkerData(markerData);
		} else {
			// Otherwise, just call handleAddMarker directly if you want to create a marker without the popup
			// this.handleAddMarker(markerData);
		}
	}

/*
	captureMapFullScreenshot = () => {
		return new Promise((resolve, reject) => {
			const { map } = this.state;
			if (!map) {
				reject(new Error("Map is not initialized"));
				return;
			}
			this.setState({ isShowUI: false });
//			const thumbnailPopup = document.getElementById('thumbnailPopup');
//			if (thumbnailPopup) thumbnailPopup.style.display = 'none';

			let captureAttempted = false;

			const captureMap = () => {
			if (captureAttempted) return;
				captureAttempted = true;

				try {

					// ドキュメント全体の高さと幅を取得
					const fullHeight = Math.max(
						document.body.scrollHeight,
						document.documentElement.scrollHeight,
						document.body.offsetHeight,
						document.documentElement.offsetHeight,
						document.body.clientHeight,
						document.documentElement.clientHeight
					);

					const fullWidth = Math.max(
						document.body.scrollWidth,
						document.documentElement.scrollWidth,
						document.body.offsetWidth,
						document.documentElement.offsetWidth,
						document.body.clientWidth,
						document.documentElement.clientWidth
					);
					
					html2canvas(map.getContainer(), {
						y:-50,
						height: fullHeight* 1.1,
						width: fullWidth* 1.1,
						scrollX: -window.scrollX,
						scrollY: -window.scrollY,
						windowHeight: fullHeight* 1.1,
						windowWidth: fullWidth* 1.1,
						useCORS: true,
						allowTaint: true,
						foreignObjectRendering: true,
						logging: false,
						imageTimeout: 0,
						scale: window.devicePixelRatio
					}).then(canvas => {
						this.setState({ isShowUI: true });
//						this.showOkConfirm("ok",null, (data) => {this.setState({ showOkConfirmDialog: false });});

//						if (thumbnailPopup) thumbnailPopup.style.display = 'none';

						const a = fullHeight* 1.1 - fullHeight;
						const b = fullWidth* 1.1 - fullWidth;

						// 一時的なキャンバスを作成して正方形部分を切り出す
						const tempCanvas = document.createElement('canvas');
						tempCanvas.width = fullWidth;
						tempCanvas.height = fullHeight;
						const tempCtx = tempCanvas.getContext('2d');
						tempCtx.drawImage(canvas, 0,0, fullWidth - b, fullHeight - a, 0, 0, fullWidth, fullHeight);


						// 最終的な画像データを生成
						const imageData = tempCanvas.toDataURL('image/jpeg', 0.95);
						resolve(imageData);
					}).catch(error => {
						this.showOkConfirm(error.message,null, (data) => {this.setState({ showOkConfirmDialog: false });});
						this.setState({ isShowUI: true });
//						if (thumbnailPopup) thumbnailPopup.style.display = 'block';
						reject(new Error("Failed to capture map: " + error.message));
					});
				} catch (error) {
					this.showOkConfirm(error.message,null, (data) => {this.setState({ showOkConfirmDialog: false });});
					this.setState({ isShowUI: true });
//					if (thumbnailPopup) thumbnailPopup.style.display = 'block';
					reject(error);
				}
			};

			const onRender = () => {
				captureMap();
			};

			map.on('render', onRender);
			map.triggerRepaint();

			// フォールバックとしてのタイムアウト
			setTimeout(() => {
			if (!captureAttempted) {
				console.warn('Capture timeout reached, forcing capture');
				captureMap();
			}
			}, 5000); // 5秒後にフォールバック
		});
	};
*/

	//iOSでなぜかマップタイルの読み込みが遅れる？のでダミー関数で1回待つ
	waitCaptureMapScreenshot = () => {
		return new Promise((resolve, reject) => {
			const { map } = this.state;
			if (!map) {
				reject(new Error("Map is not initialized"));
				return;
			}

			// マップの再描画を待つ
			map.once('idle', () => {
				try {
					// マップコンテナ全体（マーカーを含む）をキャプチャ
					html2canvas(map.getContainer(), {
						useCORS: true,
						allowTaint: true,
						foreignObjectRendering: true
					}).then(canvas => {
						const imageData = canvas.toDataURL('image/jpeg', 0.95);
						resolve(imageData);					
					}).catch(error => {
						reject(error);
					});
				}
				catch (error) {
					reject(error);
				}
			});
			// 強制的にマップの再描画をトリガー
			map.triggerRepaint();
		});
	}

	saveMapScreenshotToFirestorage = async (outputSize,title) => {
		try {
			if(CommonUtils.isIOS()) {//iOSだとスクショが撮れないことが多々あるので待つ
				this.setState({ isShowUI: false });
				const thumbnailPopup = document.getElementById('thumbnailPopup');
				thumbnailPopup.style.display = 'none';
				await this.waitCaptureMapScreenshot();
//				await this.waitCaptureMapScreenshot();
			}//他の場所で待ってみたりいろいろやってみたが、他に解決方法が無かった。良い方法が見つかったら直して

			const imageData = await this.captureMapScreenshot(outputSize,outputSize / 2,title);

			// 画像のロードが完了するまで待機
			await new Promise((resolve, reject) => {
				const img = new Image();
				img.onload = resolve;
				img.onerror = reject;
				img.src = imageData;
			});

			//const settingButton = document.getElementById('settingButton');
			//settingButton.src = imageData;

			const thumbnailPopup = document.getElementById('thumbnailPopup');
			if (thumbnailPopup) thumbnailPopup.style.display = 'block';

			const fileName = `screenshot.jpg`;
			const filePath = `files/${this.props.owneruid}/${this.props.uuid}/${this.props.owneruid}/open/${fileName}`;

			// Base64データをBlobに変換
			const byteString = atob(imageData.split(',')[1]);
			const mimeString = imageData.split(',')[0].split(':')[1].split(';')[0];
			const ab = new ArrayBuffer(byteString.length);
			const ia = new Uint8Array(ab);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			const blob = new Blob([ab], {type: mimeString});

			// Firebase Storageにアップロード
			const fileUrl = await this.props.fm.uploadFile(filePath, blob);
			console.log('Screenshot uploaded:', fileUrl);

			return fileUrl;
		}
		catch (error) {
			console.error('Error saving screenshot:', error);
			throw error;
		}
	}
	togglePrint = () => {
		this.setState({ showPrintMap: true });
	};

	closePrintMapPopup = () => {
		this.setState({ showPrintMap: false });
	};

	togglePrintMap = () => {

		const printer = new MapLibrePrinter(this.state.map);
		printer.printMap('A4', 'landscape', 50000);
	};

	toggleScreenShot = () => {
		this.captureFullPage();
	};

	captureFullPage = async () => {
		try {
		
			const imageData = await this.captureMapFullScreenshot();

			// 画像のロードが完了するまで待機
			await new Promise((resolve, reject) => {
				const img = new Image();
				img.onload = resolve;
				img.onerror = reject;
				img.src = imageData;
			});

			//const settingButton = document.getElementById('settingButton');
			//settingButton.src = imageData;

			// Base64データをBlobに変換
			const byteString = atob(imageData.split(',')[1]);
			const ab = new ArrayBuffer(byteString.length);
			const ia = new Uint8Array(ab);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			const blob = new Blob([ab], {type: 'image/png'});

			console.log('Screenshot copied to clipboard successfully');

			// BlobをURLに変換してセット
			const blobUrl = URL.createObjectURL(blob);

			setTimeout(() => {
				this.setState({ 
					showImagePopup: true,
					imageUrl: blobUrl
				});
				this.imageUrl = blobUrl;
			}, 100);
			const clipboardItem = new ClipboardItem({ 'image/png': blob });
			if(!CommonUtils.isIOS()) {
				await navigator.clipboard.write([clipboardItem]);
			}
			else {
				navigator.permissions.query({ name: 'clipboard-write' }).then(result => {
					const t = (key) => translator.t(key);
					if (result.state === 'granted') {
						// 許可されている場合は、クリップボードに書き込む
						navigator.clipboard.write([clipboardItem]);
					} else if (result.state === 'prompt') {
						// まだ許可を求めていない場合は、許可を求める
						navigator.clipboard.write([clipboardItem]).then(() => {
							// 許可された場合は、クリップボードに書き込む
							navigator.clipboard.write([clipboardItem]);

							}).catch(err => {
								// 許可されなかった場合は、エラー処理
								this.showOkConfirm(t('clipboard_permission_error'), null, (data) => {
									this.setState({ showOkConfirmDialog: false });
								});							
								console.error('Clipboard write permission denied:', err);
						});
					} else {
						// 許可されていない場合は、エラー処理
						this.showOkConfirm(t('clipboard_permission_error'), null, (data) => {
							this.setState({ showOkConfirmDialog: false });
						});
						console.error('Clipboard write permission denied');
					}
				});
			}

			return blob;
		}
		catch (error) {
			this.showOkConfirm(error.message, null, (data) => {
				this.setState({ showOkConfirmDialog: false });
			});

			console.error('Error saving screenshot:', error);
			throw error;
		}
	};

	//マーカー＋写真の件数(type1/type5はどちらもthis.markersで保持している)
	getMarkerDataCount() {
		return this.markers ? this.markers.length : 0;
	}

	//アップロードファイル(type4)の件数。フリーハンド(2)/図形(3)はユーザーごとに1件ずつなので数えない
	getFileDataCount() {
		if(!this.state.files) return 0;
		return this.state.files.filter(f => f.data && f.data.type === 4).length;
	}

	//マーカー＋写真をaddCount件追加できるか。上限を超える場合はトーストを出してfalse
	checkMarkerLimit(addCount = 1) {
		if(this.getMarkerDataCount() + addCount <= MAX_MARKER_COUNT) return true;
		const t = (key) => translator.t(key);
		toast.info(t('max_data_message'));
		return false;
	}


	mapCopy = () => {
		const t = (key) => translator.t(key);

		if(!this.currentProject.iscopyable) {
			this.showOkConfirm(t('Copy not possible'),null
			, (data) => {
				this.setState({ showOkConfirmDialog: false });
			});
			return;
		}


        this.showConfirm(CommonUtils.formatString(t('ConfirmCopyMap'),this.currentProject.title )
			,this
			, (data) => {
				this.startLoading(t('waitingMessage'));
				this.setState({ showConfirmDialog: false });
				this.props.fm.copyProject(this.props.uuid,this.props.owneruid,this.props.fm.auth.currentUser.uid,this.props.myName
				, (copyProjectData,copyDocId) => {
					const lat = this.state.map.getCenter().lat;
					const lng = this.state.map.getCenter().lng;
					const zoom = this.state.map.getZoom();

					this.showOkConfirm(t('ConfirmMoveCopyMap'),null
					, (data) => {
						this.endLoading();
						window.location.href = `/map/${copyDocId}_${copyProjectData.owneruid}#${zoom}/${lat}/${lng}`;
					});
				}
				, (errorMsg) => {
					this.endLoading();
				});
			}
			,(data) => {
				this.setState({ showConfirmDialog: false });
        });
    }
	

	render() {
		const t = (key) => translator.t(key);
//		console.log(`render this.state.protruding ${this.props.protruding}`);


		const isRightHanded = this.props.userSettings && this.props.userSettings.handedness === 1;
		const buttonStyle = {
			position: 'absolute',
			[isRightHanded ? 'right' : 'left']: '10px',
		};
		const buttonStyleB = {
			position: 'absolute',
			[isRightHanded ? 'left' : 'right']: '10px',
		};

		const penButtonStyle = { ...buttonStyle, top: 'calc(50% - 80px)' };
		const shapeButtonStyle = { ...buttonStyle, top: 'calc(50% - 40px)' };
		const eraserButtonStyle = { ...buttonStyle, top: '50%' };
		const paletteButtonStyle = { ...buttonStyle, top: 'calc(50% + 40px)' };
		const undoButtonStyle = { ...buttonStyle, top: 'calc(50% + 100px)' };
		const redoButtonStyle = { ...buttonStyle, top: 'calc(50% + 140px)' };

		const poszeroButtonStyle = { ...buttonStyleB, top: 'top: 200px',position: 'absolute' };
		const addMarketButtonStyle = { ...buttonStyleB, top: 'top: 240px' };
		const uploadButtonStyle = { ...buttonStyleB, top: 'top: 280px' };

		return (
		<div>
			<div id="mapView" ref={this.mapContainerRef} style={{height:`calc(100vh - 45px - ${this.props.protruding}px`}}>
				{this.state.isShowUI && (<>

					{(this.state.isDrawingMode === 0 || this.state.labelMode) && (<>
						<img
							id="centerMark"
							src="/img/center.png"
							alt="centerMark"
							onClick={this.toggleCenterMarkMenu}
						></img>
						{this.state.showCenterMarkMenu && (
							<div id="centerMarkMenu" className="center-mark-menu">
							<div className="center-mark-menu-item" onClick={this.openGoogleMaps}>
								{t('Open Google Maps')}
							</div>
							<div className="center-mark-menu-item" onClick={this.openStreetView}>
								{t('Street view')}
							</div>
							<div className="center-mark-menu-item" onClick={this.showWeatherForecast}>
								{t('Weather forecast display')}
							</div>
							<div className="center-mark-menu-item" onClick={this.createMarkerAtCenter}>
								{t('Make a marker')}
							</div>
							</div>
						)}
					</>)}

					<img id="poszeroButton"  className='toolButton' onClick={this.clickPoszeroButton}  src="/img/tool_position_zero_b.png" alt={t('poszeroButton')} style={poszeroButtonStyle}></img>
					<img id="searchButton"  className="toolButton" src="/img/icon_search_b.png" onClick={this.clickSearchButton} alt={t('searchButton')}></img>
				</>)}
				{(this.state.isShowUI && this.props.fm.auth.currentUser && this.props.fm.auth.currentUser.uid && this.props.fm.auth.currentUser.uid === this.props.owneruid) && (<>
					<img id="settingButton" className="toolButton" src="/img/icon_settings_b.png" onClick={this.handleSetting} alt={t('Setting')}></img>
				</>)}
	
				{this.state.isShowUI && this.state.permission === 2 && (<>
					<img id="addMarketButton"  className='toolButton' onClick={this.clickAddMarkerButton}  src="/img/icon_marker_b.png" alt={t('addMarketButton')} style={addMarketButtonStyle}></img>
					<img id="uploadButton"  className='toolButton' onClick={this.clickUploadButton} src="/img/icon_cloud_upload_b.png" alt={t('uploadButton')} style={uploadButtonStyle}></img>


					<img id="layerButton"  className='toolButton' onClick={this.toggleLMapSetting} src="/img/icon_layers_b.png" alt={t('LayerSetting')}></img>

					<img id="penButton" className='toolButton' onClick={this.clickPenButton} src="/img/icon_pen_b.png" alt={t('penButton')} style={{ ...penButtonStyle, backgroundColor: this.state.penButtonBG }}></img>
					<img id="shapeButton" className='toolButton' onClick={this.clickShapeButton} src="/img/icon_shape_b.png" alt={t('shapeButton')} style={{ ...shapeButtonStyle, backgroundColor: this.state.shapeButtonBG }}></img>
					<img id="paletteButton" className='toolButton' onClick={this.togglePalettePopup} src="/img/icon_palette_b.png" alt={t('paletteButton')} style={paletteButtonStyle}></img>
					<img id="eraserButton" className='toolButton' onClick={this.clickEraserButton} src="/img/icon_eraser_b.png" alt={t('eraserButton')} style={{ ...eraserButtonStyle, backgroundColor: this.state.eraserButtonBG }}></img>
					<img id="undoButton" className='toolButton' onClick={this.handleUndo} disabled={this.state.drawingHistory && this.state.drawingHistory.length <= 1} src="/img/icon_undo_b.png" alt={t('undoButton')} style={undoButtonStyle}></img>
					<img id="redoButton" className='toolButton' onClick={this.handleRedo} src="/img/icon_redo_b.png" alt={t('redoButton')} title={t('redoButton')} style={redoButtonStyle}></img>
				</>)}
				{this.state.isShowUI && this.state.permission >= 1 && (<>
					{this.state.isfavorite
						? <img id="favoriteButton"  className='toolButton' onClick={this.clickFavoButton} src="/img/icon_favorite_true.png" alt={t('Add_favorite')}></img>
						: <img id="favoriteButton"  className='toolButton' onClick={this.clickFavoButton} src="/img/icon_favorite_b.png" alt={t('Add_favorite')}></img>
					}
					<img id="copyProjectButton"  className='toolButton'  onClick={this.mapCopy} src="/img/icon_file_copy_b.png" alt={t('CopyProject')}></img>
				</>)}

				{this.state.isShowUI && this.state.permission === 2 &&  this.state.isDrawingMode === 3 && (<>
					<img id="lineButton"  className='toolButton' onClick={this.clickLineButton} src="/img/icon_polyline.png" alt={t('lineButton')} style={{ backgroundColor: this.state.lineButtonBG }}></img>
					<img id="circleButton"  className='toolButton' onClick={this.clickCircleButton} src="/img/icon_circle.png" alt={t('circleButton')} style={{ backgroundColor: this.state.circleButtonBG }}></img>
					<img id="polygonButton"  className='toolButton' onClick={this.clickPolygonButton} src="/img/icon_pentagon.png" alt={t('polygonButton')} style={{ backgroundColor: this.state.polygonButtonBG }}></img>
					<img id="measurementButton"  className='toolButton' onClick={this.clickMeasurementButton} src="/img/icon_measurement.png" alt={t('measurementButton')} style={{ backgroundColor: this.state.measurementButtonBG }}></img>
					<img id='gridButton' className='toolButton' onClick={this.clickGridButton} alt={t('gridButton')} title={t('gridButton')} style={{ backgroundColor: this.state.gridButtonBG, padding: '5px', boxSizing: 'border-box' }} src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='1.5'%3E%3Crect x='3' y='3' width='18' height='18'/%3E%3Cline x1='9' y1='3' x2='9' y2='21'/%3E%3Cline x1='15' y1='3' x2='15' y2='21'/%3E%3Cline x1='3' y1='9' x2='21' y2='9'/%3E%3Cline x1='3' y1='15' x2='21' y2='15'/%3E%3C/svg%3E"/>
					<img id='labelButton' className='toolButton' onClick={this.clickLabelButton} alt={t('labelButton')} title={t('labelButton')} style={{ backgroundColor: this.state.labelButtonBG, padding: '5px', boxSizing: 'border-box' }} src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ctext x='12' y='19' text-anchor='middle' font-family='serif' font-weight='bold' font-size='22' fill='%23333'%3EA%3C/text%3E%3C/svg%3E"/>
				</>)}


				{this.state.isShowUI && (<>
					<img id="datalistButton"  className='toolButton' src="/img/icon_datalist_b.png" alt={t('Data_list')} onClick={this.toggleDataListPanel}></img>
					<img id="chatButton"  className='toolButton' onClick={this.clickChatButton}  src="/img/icon_chat_b.png" alt={t('chatButton')}></img>
					<img id="shareButton"  className='toolButton' onClick={this.toggleMapSharePopup} src="/img/icon_share_b.png" alt={t('Share')}></img>
					<img id="screenShotButton"  className='toolButton' onClick={this.toggleScreenShot} src="/img/icon_screenShot_b.png" alt={t('ScreenShot')}></img>
					<img id="printButton"  className='toolButton' onClick={this.togglePrint} src="/img/icon_print_b.png" alt={t('Print')}></img>
				</>)}

				{this.state.isShowUI && this.state.permission === 2 &&  (this.state.isDrawingMode === 1 || this.state.isDrawingMode === 3) && (<>
					<div className="number_box" style={{ backgroundColor: this.state.selectedColor,color: (this.state.selectedColor === '#FFFFFF' || this.state.selectedColor === '#FFFF00' || this.state.selectedColor === '#C0C0C0') ? 'black' : 'white', cursor: 'pointer' }} onClick={this.togglePalettePopup}>
						{this.state.lineWidth}
					</div>
				</>)}

				{this.state.isShowUI && this.state.permission === 2 &&  this.state.isDrawingMode !== 0 && this.state.isDrawingMode !== 3 && (<>
					<button id="buttonDrawMode"
						onClick={this.changeDrawingMode} 
						className="roundButton_TC" 
						style={{ 
							backgroundColor: this.state.isDrawingMode === 0 ? 'gray' : '#8fbc18', 
						}}>
						{this.state.isDrawingMode === 1 ? t('freehand_drawing') : t('freehand_eraser') }
					</button>
				</>)}

				{this.state.is3DEnabled && this.state.showDistanceLayer && this.state.map && (
					<>
					<DistanceLayer
						map={this.state.map}
						update3dDistance={this.update3dDistance} 
					/>
					<label id="labelScaleDistance">{this.state.labelScaleDistance}</label>
					</>
				)}

				<div id="testLabel" className='testLabel' style={{display:'none'}}></div>

				{/* 実機で読み込み不具合が起きたときにログをコピーするための小さなボタン（左下）。
				    ?debug=1 が付いているときだけ表示する */}
				{this.state.isShowUI && DiagLog.isEnabled() && (
					<button
						id="diagLogButton"
						onClick={this.toggleDiagLogPopup}
						title={t('Diagnostics Log')}
						aria-label={t('Diagnostics Log')}
						style={{
							position: 'absolute',
							left: '6px',
							bottom: '6px',
							width: '28px',
							height: '28px',
							margin: 0,
							padding: 0,
							borderRadius: '50%',
							border: '1px solid #999',
							backgroundColor: DiagLog.getErrorCount() > 0 ? 'rgba(231,76,60,0.9)' : 'rgba(255,255,255,0.6)',
							color: DiagLog.getErrorCount() > 0 ? '#fff' : '#555',
							fontSize: '9px',
							fontWeight: 'bold',
							lineHeight: 1,
							cursor: 'pointer',
							zIndex: 100,
							opacity: 0.85,//?debug=1 のときだけ表示されるので、見つけられるよう十分に見える状態にしておく
						}}
					>LOG</button>
				)}
				{this.state.showDiagLogPopup && DiagLog.isEnabled() && (
					<DiagLogPopup onClose={this.toggleDiagLogPopup} />
				)}

				{this.state.showAddMarkerPopup &&
					<AddMarkerPopup 
						onSubmit={this.handleAddMarker}
						lat={this.state.map.getCenter().lat}
						lng={this.state.map.getCenter().lng}
						defaultIconNumber = {this.defaultIconNumber}
						onClose={this.closePopup} 
					/>
				}
				{this.state.showEditProjectPopup && 
					<EditProjectPopup 
						fm = {this.props.fm}
						map = {this.state.map}
						parent={this}
						onClose={this.closeSettingPopup}
						myName={this.props.myName}
						myColor={this.props.myColor} 
						data={this.currentProject}
						docId={this.props.uuid}
					/>
				}
				{this.state.showEditMarkerPopup && 
					<EditMarkerPopup 
						onSubmit={this.handleEditMarker}
						markerData={this.editingMarker}
						onClose={() => this.setState({ showEditMarkerPopup: false })} 
					/>
				}
				{this.state.showPalettePopup && 
					<PalettePopup 
						onSelectColor={this.handleColorSelect} 
						onClose={this.togglePalettePopup}
						initialLineWidth={this.state.lineWidth}
						initialLineColor = {this.state.selectedColor} 
						initialLineOpacity = {this.state.selectedOpacity} 
						onLineWidthChange={this.handleLineWidthChange}
						onLineOpacityChange={this.handleLineOpacityChange}
					/>
				}
				{this.state.showMapSharePopup && 
					<MapSharePopup 
						onClose={this.toggleMapSharePopup}
						currentProject={this.currentProject}
					/>
				}
				{this.state.showConfirmDialog && (
					<ConfirmDialog
						message={this.state.confirmDialog.message}
						data = {this.state.confirmDialog.data}
						okTitle={'OK'}
						cancelTitle={t('Cancel')}
						onConfirm={this.state.confirmDialog.onConfirm}
						onCancel={this.state.confirmDialog.onCancel}
					/>
				)}
				{this.state.showOkConfirmDialog && (
					<ConfirmDialog
						message={this.state.okConfirmDialog.message}
						data = {this.state.okConfirmDialog.data}
						okTitle={'OK'}
						cancelTitle={null}
						onConfirm={this.state.okConfirmDialog.onConfirm}
						onCancel={null}
					/>
				)}
				{this.state.showSearchPopup && 
					<SearchPopup 
						onSubmit={this.handleSearchSubmit}
						onClose={this.handleSearchClose}
						onUpdate={this.handleSearchUpdate}
						initialKeyword={this.state.searchKeyword}
						initialResults={this.state.searchResults}
					/>
				}
				{this.state.showLayerSettingPopup && (
					<LayerSettingPopup
					overlays={CommonUtils.overlays}
					maps={CommonUtils.maps}
					customOverlays={this.customOverlays}
					customMaps={this.customMaps}
					boss={this}

					currentOverlay={this.currentOverlay}
					currentMap={this.currentMap}
					onClose={this.toggleLMapSetting}
					onApply={this.handleApplyLayerSettings}
					onUpdateCustomLayer={this.updateCustomLayer}
					currentExaggeration={this.state.exaggeration}
					onExaggerationChange={(value) => this.setState({ exaggeration: value })}
					currentGridSettings={CommonUtils.gridOverlay}
					/>
				)}
				<LayerListPanel
					map={this.state.map}
					isOpen={this.state.showLayerListPanel}
					onClose={this.toggleLayerListPanel}
				/>
				<DataListPanel
					map={this.state.map}
					fm={this.props.fm}
					uuid={this.props.uuid}
					owneruid={this.props.owneruid}
					myUid={this.props.fm.auth.currentUser ? this.props.fm.auth.currentUser.uid : null}
					mapManager={this}
					markers={this.markers.filter(markerObj => !markerObj.marker.data.iconDataUrl)}
					photos={
						this.markers
							.filter(marker => marker.marker.data.iconDataUrl)
							.map(marker => ({
								...marker.marker.data,
								lat: marker.marker.lat,
								lng: marker.marker.lng,
								docId: marker.id
							}))
					}
					files={this.state.files}
					counts={{
						markerUsed: this.getMarkerDataCount(),
						markerMax: MAX_MARKER_COUNT,
						fileUsed: this.getFileDataCount(),
						fileMax: MAX_FILE_COUNT,
						loadSource: this.state.itemsLoadSource,
						indexTime: this.state.itemsIndexTime,
					}}
					isOpen={this.state.showDataListPanel}
					onClose={this.toggleDataListPanel}

					onDeleteFile={this.handleDeleteFile}
					onDeleteMarker={this.onDeleteMarker}
					onDeletePhoto={this.onDeletePhoto}
				/>
				<ChatPanel
					fm = {this.props.fm}
					uuid={this.props.uuid}
					owneruid={this.props.owneruid}
					myUid={this.props.fm.auth.currentUser ? this.props.fm.auth.currentUser.uid : null}
					userDoc={this.props.userDoc}
					isOpen={this.state.showChatPanel}
					onClose={() => this.setState({ showChatPanel: false })}
				/>
				<input
					type="file"
					style={{ display: 'none' }}
					ref={ref => this.fileInputRef = ref}
					onChange={this.handleFileUpload}
					multiple
				/>
				{this.state.uploadProgress && (
					<ProgressBar
						progress={this.state.uploadProgress.current}
						total={this.state.uploadProgress.total}
					/>
				)}
				{this.state.selectedPhoto && (
				<PhotoViewer
					photo={this.state.selectedPhoto}
					photoMarkers={this.state.photoMarkers}
					myUid={this.props.fm.auth.currentUser ? this.props.fm.auth.currentUser.uid : null}
					onClose={this.closePhotoViewer}
					onDelete={this.handlePtohoDelete}
					onPrev={this.handlePrevPhoto}
					onNext={this.handleNextPhoto}
					onMoveStart={this.handlePtohoMove}
					currentIndex={this.state.currentPhotoIndex}
					totalPhotos={this.state.photoMarkers.length}
					isFullscreen={this.state.isPhotoViewerFullscreen}
					toggleFullscreen={this.toggleFullscreen}
					onPhotoSelect={this.handlePhotoSelect}
					onUpdateMemo={this.handlePhotoUpdateMemo}
				/>
				)}
				{this.state.showThumbnailPopup && (
					<div className="popup">
						<div className="popup-inner">
							<h2>{t('Thumbnail Created')}</h2>
							<img src={this.thumbnailUrl} alt="Thumbnail" style={{ maxWidth: '100%', marginBottom: '20px' }} />
							<p>{t('Thumbnail has been created and saved.')}</p>
							<button className='button_y' onClick={this.closeThumbnailPopup}>{t('Close')}</button>
						</div>
					</div>
				)}
				{this.state.showImagePopup && (
					<div className="popup">
						<div className="popup-inner">
							<h2>{t('Screenshot Create')}</h2>
							<img src={this.imageUrl} alt="Screen Shot" style={{ maxWidth: '100%', marginBottom: '20px' }} />
							<p>{t('Screenshot has been created.')}</p>
							<button className='button_y' onClick={this.closeImagePopup}>{t('Close')}</button>
						</div>
					</div>
				)}
				{this.state.isShowUI && this.state.isDrawingMode ===0 && (<>
					<div id="elevationLabel">
						{this.state.centerElevation !== null
							? `${t('Elevation')}: ${this.state.centerElevation} m`
							: `${t('Elevation')}: ---- m`}
					</div>
				</>)}
				<SeamlessLegendPanel
					map={this.state.map}
					visible={!!this.state.isShowUI && this.currentOverlay === 'seamless'}
				/>
				{this.state.showLoadingPopup && (<>
					<div>
						<LoadingPopup isVisible={this.state.showLoadingPopup} message={this.state.loadingMessage} />
					</div>
				</>)}


				{this.state.showShapeOperationPanel && (
					<ShapeOperationPanel
					onConfirm={() => {
						this.setState({ showShapeOperationPanel: false });
						this.handleDoubleClick({ lngLat: this.state.map.unproject(this.state.operationPanelPosition) });
					}}
					onUndo={() => {
						this.removeLastPoint();
					}}
					position={this.state.operationPanelPosition}
					/>
				)}
				{this.state.showPrintMap && (
					<PrintMapPopup
						map={this.state.map}
						markers={this.markers}
						title={this.state.projectTitle}
						ownerName={this.state.ownerName}
						memo={this.currentProject ? this.currentProject.memo : ''}
						onClose={this.closePrintMapPopup}
					/>
				)}
				{this.state.showLabelAddPopup && (
					<LabelPopup
						mode="add"
						initialFontSize={this.state.labelSettings.fontSize}
						initialColor={this.state.labelSettings.color || this.state.selectedColor}
						onAdd={this.handleAddLabel}
						onClose={this.closeLabelAddPopup}
					/>
				)}
				{this.state.showLabelEditPopup && this.state.editingLabelFeature && (
					<LabelPopup
						mode="edit"
						initialText={this.state.editingLabelFeature.text}
						initialFontSize={this.state.editingLabelFeature.fontSize}
						initialColor={this.state.editingLabelFeature.color}
						onSave={this.handleSaveLabel}
						onClose={this.closeLabelEditPopup}
					/>
				)}
				{this.state.showShortcutsPopup && (
					<ShortcutsPopup
						onClose={() => this.setState({ showShortcutsPopup: false })}
					/>
				)}
				{this.state.showGridDivisionPopup && this.state.pendingGridBounds && (
					<GridDivisionPopup
						widthMeters={this.state.pendingGridBounds.widthMeters}
						heightMeters={this.state.pendingGridBounds.heightMeters}
						defaultMethod={this.state.gridSettings.method}
						defaultEqualDivisions={this.state.gridSettings.equalDivisions}
						defaultDistanceInterval={this.state.gridSettings.distanceInterval}
						defaultFontSize={this.state.gridSettings.fontSize}
						defaultLabelMode={this.state.gridSettings.labelMode}
						onConfirm={this.handleGridConfirm}
						onCancel={this.handleGridCancel}
					/>
				)}
			</div>
		</div>

		);
	}
}
//					<img id="PrintButton"  className='toolButton' onClick={this.togglePrintMap} src="/img/icon_print_b.png" alt={t('Print')}></img>


export default MapManager;